webpackJsonp([188034299440437],{

/***/ 99:
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),

/***/ 100:
/***/ (function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventOptionsKey = __webpack_require__(31);
	
	var _eventOptionsKey2 = _interopRequireDefault(_eventOptionsKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ensureCanMutateNextEventHandlers(eventHandlers) {
	  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
	    // eslint-disable-next-line no-param-reassign
	    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
	  }
	}
	
	var TargetEventHandlers = function () {
	  function TargetEventHandlers(target) {
	    _classCallCheck(this, TargetEventHandlers);
	
	    this.target = target;
	    this.events = {};
	  }
	
	  _createClass(TargetEventHandlers, [{
	    key: 'getEventHandlers',
	    value: function () {
	      function getEventHandlers(eventName, options) {
	        var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));
	
	        if (!this.events[key]) {
	          this.events[key] = {
	            handlers: [],
	            handleEvent: undefined
	          };
	          this.events[key].nextHandlers = this.events[key].handlers;
	        }
	
	        return this.events[key];
	      }
	
	      return getEventHandlers;
	    }()
	  }, {
	    key: 'handleEvent',
	    value: function () {
	      function handleEvent(eventName, options, event) {
	        var eventHandlers = this.getEventHandlers(eventName, options);
	        eventHandlers.handlers = eventHandlers.nextHandlers;
	        eventHandlers.handlers.forEach(function (handler) {
	          if (handler) {
	            // We need to check for presence here because a handler function may
	            // cause later handlers to get removed. This can happen if you for
	            // instance have a waypoint that unmounts another waypoint as part of an
	            // onEnter/onLeave handler.
	            handler(event);
	          }
	        });
	      }
	
	      return handleEvent;
	    }()
	  }, {
	    key: 'add',
	    value: function () {
	      function add(eventName, listener, options) {
	        var _this = this;
	
	        // options has already been normalized at this point.
	        var eventHandlers = this.getEventHandlers(eventName, options);
	
	        ensureCanMutateNextEventHandlers(eventHandlers);
	
	        if (eventHandlers.nextHandlers.length === 0) {
	          eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
	
	          this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
	        }
	
	        eventHandlers.nextHandlers.push(listener);
	
	        var isSubscribed = true;
	        var unsubscribe = function () {
	          function unsubscribe() {
	            if (!isSubscribed) {
	              return;
	            }
	
	            isSubscribed = false;
	
	            ensureCanMutateNextEventHandlers(eventHandlers);
	            var index = eventHandlers.nextHandlers.indexOf(listener);
	            eventHandlers.nextHandlers.splice(index, 1);
	
	            if (eventHandlers.nextHandlers.length === 0) {
	              // All event handlers have been removed, so we want to remove the event
	              // listener from the target node.
	
	              if (_this.target) {
	                // There can be a race condition where the target may no longer exist
	                // when this function is called, e.g. when a React component is
	                // unmounting. Guarding against this prevents the following error:
	                //
	                //   Cannot read property 'removeEventListener' of undefined
	                _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
	              }
	
	              eventHandlers.handleEvent = undefined;
	            }
	          }
	
	          return unsubscribe;
	        }();
	        return unsubscribe;
	      }
	
	      return add;
	    }()
	  }]);
	
	  return TargetEventHandlers;
	}();
	
	exports['default'] = TargetEventHandlers;

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports['default'] = CAN_USE_DOM;

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = canUsePassiveEventListeners;
	
	var _canUseDOM = __webpack_require__(29);
	
	var _canUseDOM2 = _interopRequireDefault(_canUseDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Adapted from Modernizr
	// https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35
	function testPassiveEventListeners() {
	  if (!_canUseDOM2['default']) {
	    return false;
	  }
	
	  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
	    return false;
	  }
	
	  var supportsPassiveOption = false;
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function () {
	        function get() {
	          supportsPassiveOption = true;
	        }
	
	        return get;
	      }()
	    });
	    window.addEventListener('test', null, opts);
	  } catch (e) {
	    // do nothing
	  }
	
	  return supportsPassiveOption;
	}
	
	var memoized = void 0;
	
	function canUsePassiveEventListeners() {
	  if (memoized === undefined) {
	    memoized = testPassiveEventListeners();
	  }
	  return memoized;
	}

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = eventOptionsKey;
	/* eslint-disable no-bitwise */
	
	/**
	 * Generate a unique key for any set of event options
	 */
	function eventOptionsKey(normalizedEventOptions) {
	  if (!normalizedEventOptions) {
	    return 0;
	  }
	
	  // If the browser does not support passive event listeners, the normalized
	  // event options will be a boolean.
	  if (normalizedEventOptions === true) {
	    return 100;
	  }
	
	  // At this point, the browser supports passive event listeners, so we expect
	  // the event options to be an object with possible properties of capture,
	  // passive, and once.
	  //
	  // We want to consistently return the same value, regardless of the order of
	  // these properties, so let's use binary maths to assign each property to a
	  // bit, and then add those together (with an offset to account for the
	  // booleans at the beginning of this function).
	  var capture = normalizedEventOptions.capture << 0;
	  var passive = normalizedEventOptions.passive << 1;
	  var once = normalizedEventOptions.once << 2;
	  return capture + passive + once;
	}

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EVENT_HANDLERS_KEY = undefined;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	
	var _normalizeEventOptions = __webpack_require__(33);
	
	var _normalizeEventOptions2 = _interopRequireDefault(_normalizeEventOptions);
	
	var _TargetEventHandlers = __webpack_require__(28);
	
	var _TargetEventHandlers2 = _interopRequireDefault(_TargetEventHandlers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Export to make testing possible.
	var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
	
	function addEventListener(target, eventName, listener, options) {
	  if (!target[EVENT_HANDLERS_KEY]) {
	    // eslint-disable-next-line no-param-reassign
	    target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
	  }
	  var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
	  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
	}
	
	// Deprecated
	function removeEventListener(unsubscribeFn) {
	  unsubscribeFn();
	}

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = normalizeEventOptions;
	
	var _canUsePassiveEventListeners = __webpack_require__(30);
	
	var _canUsePassiveEventListeners2 = _interopRequireDefault(_canUsePassiveEventListeners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function normalizeEventOptions(eventOptions) {
	  if (!eventOptions) {
	    return undefined;
	  }
	
	  if (!(0, _canUsePassiveEventListeners2['default'])()) {
	    // If the browser does not support the passive option, then it is expecting
	    // a boolean for the options argument to specify whether it should use
	    // capture or not. In more modern browsers, this is passed via the `capture`
	    // option, so let's just hoist that value up.
	    return !!eventOptions.capture;
	  }
	
	  return eventOptions;
	}

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(61);
	var isArguments = __webpack_require__(60);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 60:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	var URL = __webpack_require__(504)
	var promise = __webpack_require__(448)
	var fetch = __webpack_require__(324)({ Promise: promise }).fetch
	var escape = __webpack_require__(380)
	
	var YOUTUBE = 'youtube'
	var VIMEO = 'vimeo'
	var DAILYMOTION = 'dailymotion'
	
	var validVimeoOpts = [
	  'thumbnail_small',
	  'thumbnail_medium',
	  'thumbnail_large'
	]
	var validYouTubeOpts = [
	  'default',
	  'mqdefault',
	  'hqdefault',
	  'sddefault',
	  'maxresdefault'
	]
	var validDailyMotionOpts = [
	  'thumbnail_60_url',
	  'thumbnail_120_url',
	  'thumbnail_180_url',
	  'thumbnail_240_url',
	  'thumbnail_360_url',
	  'thumbnail_480_url',
	  'thumbnail_720_url',
	  'thumbnail_1080_url'
	]
	
	var VIMEO_MATCH_RE = /^(?:\/video|\/channels\/[\w-]+|\/groups\/[\w-]+\/videos)?\/(\d+)/
	
	function embed (url, opts) {
	  var res = embed.info(url)
	  return res && embed[res.source] && embed[res.source](res.id, opts)
	}
	
	embed.info = function (url) {
	  url = URL.parse(url, true)
	
	  var id
	
	  id = detectYoutube(url)
	  if (id) {
	    return {
	      id: id,
	      source: YOUTUBE,
	      url: url.href
	    }
	  }
	
	  id = detectVimeo(url)
	  if (id) {
	    return {
	      id: id,
	      source: VIMEO,
	      url: url.href
	    }
	  }
	
	  id = detectDailymotion(url)
	  if (id) {
	    return {
	      id: id,
	      source: DAILYMOTION,
	      url: url.href
	    }
	  }
	}
	
	// For compat with <=2.0.1
	embed.videoSource = embed.info
	
	embed.image = function (url, opts, cb) {
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	  opts = opts || {}
	
	  var res = embed.info(url)
	  if (!res && cb) return setTimeout(function () { cb() })
	  return res && embed[res.source].image(res.id, opts, cb)
	}
	
	function detectVimeo (url) {
	  var match
	  return (url.hostname === 'vimeo.com' && (match = VIMEO_MATCH_RE.exec(url.pathname))) ? match[1] : null
	}
	
	function detectYoutube (url) {
	  if (url.hostname.indexOf('youtube.com') > -1) {
	    return url.query.v
	  }
	
	  if (url.hostname === 'youtu.be') {
	    return url.pathname.split('/')[1]
	  }
	
	  return null
	}
	
	function detectDailymotion (url) {
	  if (url.hostname.indexOf('dailymotion.com') > -1) {
	    return url.pathname.split('/')[2].split('_')[0]
	  }
	
	  if (url.hostname === 'dai.ly') {
	    return url.pathname.split('/')[1]
	  }
	
	  return null
	}
	
	embed.vimeo = function (id, opts) {
	  opts = parseOptions(opts)
	  return '<iframe src="//player.vimeo.com/video/' + id + opts.query + '"' + opts.attr + ' frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'
	}
	
	embed.youtube = function (id, opts) {
	  opts = parseOptions(opts)
	  return '<iframe src="//www.youtube.com/embed/' + id + opts.query + '"' + opts.attr + ' frameborder="0" allowfullscreen></iframe>'
	}
	
	embed.dailymotion = function (id, opts) {
	  opts = parseOptions(opts)
	  return '<iframe src="//www.dailymotion.com/embed/video/' + id + opts.query + '"' + opts.attr + ' frameborder="0" allowfullscreen></iframe>'
	}
	
	embed.youtube.image = function (id, opts, cb) {
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	  opts = opts || {}
	
	  opts.image = validYouTubeOpts.indexOf(opts.image) > 0 ? opts.image : 'default'
	
	  var src = '//img.youtube.com/vi/' + id + '/' + opts.image + '.jpg'
	
	  var result = {
	    src: src,
	    html: '<img src="' + src + '"/>'
	  }
	
	  if (!cb) return result.html
	
	  setTimeout(function () { cb(null, result) })
	}
	
	embed.vimeo.image = function (id, opts, cb) {
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  if (!cb) throw new Error('must pass embed.vimeo.image a callback')
	
	  opts = opts || {}
	
	  opts.image = validVimeoOpts.indexOf(opts.image) >= 0 ? opts.image : 'thumbnail_large'
	
	  fetch('https://vimeo.com/api/v2/video/' + id + '.json')
	    .then(function (res) {
	      if (res.status !== 200) {
	        throw new Error('unexpected response from vimeo')
	      }
	
	      return res.json()
	    })
	    .then(function (body) {
	      if (!body || !body[0] || !body[0][opts.image]) {
	        throw new Error('no image found for vimeo.com/' + id)
	      }
	
	      var src = body[0][opts.image].split(':')[1]
	
	      var result = {
	        src: src,
	        html: '<img src="' + src + '"/>'
	      }
	
	      cb(null, result)
	    })
	    .catch(function (err) {
	      cb(err)
	    })
	}
	
	embed.dailymotion.image = function (id, opts, cb) {
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  if (!cb) throw new Error('must pass embed.dailymotion.image a callback')
	
	  opts = opts || {}
	
	  opts.image = validDailyMotionOpts.indexOf(opts.image) >= 0 ? opts.image : 'thumbnail_480_url'
	
	  fetch('https://api.dailymotion.com/video/' + id + '?fields=' + opts.image)
	    .then(function (res) {
	      if (res.status !== 200) {
	        throw new Error('unexpected response from dailymotion')
	      }
	
	      return res.json()
	    })
	    .then(function (body) {
	      if (!body || !body[opts.image]) {
	        throw new Error('no image found for dailymotion.com/' + id)
	      }
	
	      var src = body[opts.image]
	
	      var result = {
	        src: src,
	        html: '<img src="' + src + '"/>'
	      }
	
	      cb(null, result)
	    })
	    .catch(function (err) {
	      cb(err)
	    })
	}
	
	function serializeQuery (query) {
	  return Object.keys(query).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(query[key])
	  }).join('&')
	}
	
	function parseOptions (opts) {
	  var queryString = ''
	  var attributes = ''
	
	  if (opts && opts.hasOwnProperty('query')) {
	    queryString = '?' + serializeQuery(opts.query)
	  }
	
	  if (opts && opts.hasOwnProperty('attr')) {
	    attributes = ' ' + Object.keys(opts.attr).map(function (key) {
	      return key + '="' + escape(opts.attr[key]) + '"'
	    }).join(' ')
	  }
	
	  return { query: queryString, attr: attributes }
	}
	
	module.exports = embed


/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;(function (self) {
	  'use strict';
	
	  function fetchPonyfill(options) {
	    var Promise = options && options.Promise || self.Promise;
	    var XMLHttpRequest = options && options.XMLHttpRequest || self.XMLHttpRequest;
	    var global = self;
	
	    return (function () {
	      var self = Object.create(global, {
	        fetch: {
	          value: undefined,
	          writable: true
	        }
	      });
	
	      (function(self) {
	        'use strict';
	
	        if (self.fetch) {
	          return
	        }
	
	        var support = {
	          searchParams: 'URLSearchParams' in self,
	          iterable: 'Symbol' in self && 'iterator' in Symbol,
	          blob: 'FileReader' in self && 'Blob' in self && (function() {
	            try {
	              new Blob()
	              return true
	            } catch(e) {
	              return false
	            }
	          })(),
	          formData: 'FormData' in self,
	          arrayBuffer: 'ArrayBuffer' in self
	        }
	
	        if (support.arrayBuffer) {
	          var viewClasses = [
	            '[object Int8Array]',
	            '[object Uint8Array]',
	            '[object Uint8ClampedArray]',
	            '[object Int16Array]',
	            '[object Uint16Array]',
	            '[object Int32Array]',
	            '[object Uint32Array]',
	            '[object Float32Array]',
	            '[object Float64Array]'
	          ]
	
	          var isDataView = function(obj) {
	            return obj && DataView.prototype.isPrototypeOf(obj)
	          }
	
	          var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	            return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	          }
	        }
	
	        function normalizeName(name) {
	          if (typeof name !== 'string') {
	            name = String(name)
	          }
	          if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	            throw new TypeError('Invalid character in header field name')
	          }
	          return name.toLowerCase()
	        }
	
	        function normalizeValue(value) {
	          if (typeof value !== 'string') {
	            value = String(value)
	          }
	          return value
	        }
	
	        // Build a destructive iterator for the value list
	        function iteratorFor(items) {
	          var iterator = {
	            next: function() {
	              var value = items.shift()
	              return {done: value === undefined, value: value}
	            }
	          }
	
	          if (support.iterable) {
	            iterator[Symbol.iterator] = function() {
	              return iterator
	            }
	          }
	
	          return iterator
	        }
	
	        function Headers(headers) {
	          this.map = {}
	
	          if (headers instanceof Headers) {
	            headers.forEach(function(value, name) {
	              this.append(name, value)
	            }, this)
	          } else if (Array.isArray(headers)) {
	            headers.forEach(function(header) {
	              this.append(header[0], header[1])
	            }, this)
	          } else if (headers) {
	            Object.getOwnPropertyNames(headers).forEach(function(name) {
	              this.append(name, headers[name])
	            }, this)
	          }
	        }
	
	        Headers.prototype.append = function(name, value) {
	          name = normalizeName(name)
	          value = normalizeValue(value)
	          var oldValue = this.map[name]
	          this.map[name] = oldValue ? oldValue+','+value : value
	        }
	
	        Headers.prototype['delete'] = function(name) {
	          delete this.map[normalizeName(name)]
	        }
	
	        Headers.prototype.get = function(name) {
	          name = normalizeName(name)
	          return this.has(name) ? this.map[name] : null
	        }
	
	        Headers.prototype.has = function(name) {
	          return this.map.hasOwnProperty(normalizeName(name))
	        }
	
	        Headers.prototype.set = function(name, value) {
	          this.map[normalizeName(name)] = normalizeValue(value)
	        }
	
	        Headers.prototype.forEach = function(callback, thisArg) {
	          for (var name in this.map) {
	            if (this.map.hasOwnProperty(name)) {
	              callback.call(thisArg, this.map[name], name, this)
	            }
	          }
	        }
	
	        Headers.prototype.keys = function() {
	          var items = []
	          this.forEach(function(value, name) { items.push(name) })
	          return iteratorFor(items)
	        }
	
	        Headers.prototype.values = function() {
	          var items = []
	          this.forEach(function(value) { items.push(value) })
	          return iteratorFor(items)
	        }
	
	        Headers.prototype.entries = function() {
	          var items = []
	          this.forEach(function(value, name) { items.push([name, value]) })
	          return iteratorFor(items)
	        }
	
	        if (support.iterable) {
	          Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	        }
	
	        function consumed(body) {
	          if (body.bodyUsed) {
	            return Promise.reject(new TypeError('Already read'))
	          }
	          body.bodyUsed = true
	        }
	
	        function fileReaderReady(reader) {
	          return new Promise(function(resolve, reject) {
	            reader.onload = function() {
	              resolve(reader.result)
	            }
	            reader.onerror = function() {
	              reject(reader.error)
	            }
	          })
	        }
	
	        function readBlobAsArrayBuffer(blob) {
	          var reader = new FileReader()
	          var promise = fileReaderReady(reader)
	          reader.readAsArrayBuffer(blob)
	          return promise
	        }
	
	        function readBlobAsText(blob) {
	          var reader = new FileReader()
	          var promise = fileReaderReady(reader)
	          reader.readAsText(blob)
	          return promise
	        }
	
	        function readArrayBufferAsText(buf) {
	          var view = new Uint8Array(buf)
	          var chars = new Array(view.length)
	
	          for (var i = 0; i < view.length; i++) {
	            chars[i] = String.fromCharCode(view[i])
	          }
	          return chars.join('')
	        }
	
	        function bufferClone(buf) {
	          if (buf.slice) {
	            return buf.slice(0)
	          } else {
	            var view = new Uint8Array(buf.byteLength)
	            view.set(new Uint8Array(buf))
	            return view.buffer
	          }
	        }
	
	        function Body() {
	          this.bodyUsed = false
	
	          this._initBody = function(body) {
	            this._bodyInit = body
	            if (!body) {
	              this._bodyText = ''
	            } else if (typeof body === 'string') {
	              this._bodyText = body
	            } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	              this._bodyBlob = body
	            } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	              this._bodyFormData = body
	            } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	              this._bodyText = body.toString()
	            } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	              this._bodyArrayBuffer = bufferClone(body.buffer)
	              // IE 10-11 can't handle a DataView body.
	              this._bodyInit = new Blob([this._bodyArrayBuffer])
	            } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	              this._bodyArrayBuffer = bufferClone(body)
	            } else {
	              throw new Error('unsupported BodyInit type')
	            }
	
	            if (!this.headers.get('content-type')) {
	              if (typeof body === 'string') {
	                this.headers.set('content-type', 'text/plain;charset=UTF-8')
	              } else if (this._bodyBlob && this._bodyBlob.type) {
	                this.headers.set('content-type', this._bodyBlob.type)
	              } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	                this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	              }
	            }
	          }
	
	          if (support.blob) {
	            this.blob = function() {
	              var rejected = consumed(this)
	              if (rejected) {
	                return rejected
	              }
	
	              if (this._bodyBlob) {
	                return Promise.resolve(this._bodyBlob)
	              } else if (this._bodyArrayBuffer) {
	                return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	              } else if (this._bodyFormData) {
	                throw new Error('could not read FormData body as blob')
	              } else {
	                return Promise.resolve(new Blob([this._bodyText]))
	              }
	            }
	
	            this.arrayBuffer = function() {
	              if (this._bodyArrayBuffer) {
	                return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	              } else {
	                return this.blob().then(readBlobAsArrayBuffer)
	              }
	            }
	          }
	
	          this.text = function() {
	            var rejected = consumed(this)
	            if (rejected) {
	              return rejected
	            }
	
	            if (this._bodyBlob) {
	              return readBlobAsText(this._bodyBlob)
	            } else if (this._bodyArrayBuffer) {
	              return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	            } else if (this._bodyFormData) {
	              throw new Error('could not read FormData body as text')
	            } else {
	              return Promise.resolve(this._bodyText)
	            }
	          }
	
	          if (support.formData) {
	            this.formData = function() {
	              return this.text().then(decode)
	            }
	          }
	
	          this.json = function() {
	            return this.text().then(JSON.parse)
	          }
	
	          return this
	        }
	
	        // HTTP methods whose capitalization should be normalized
	        var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	        function normalizeMethod(method) {
	          var upcased = method.toUpperCase()
	          return (methods.indexOf(upcased) > -1) ? upcased : method
	        }
	
	        function Request(input, options) {
	          options = options || {}
	          var body = options.body
	
	          if (input instanceof Request) {
	            if (input.bodyUsed) {
	              throw new TypeError('Already read')
	            }
	            this.url = input.url
	            this.credentials = input.credentials
	            if (!options.headers) {
	              this.headers = new Headers(input.headers)
	            }
	            this.method = input.method
	            this.mode = input.mode
	            if (!body && input._bodyInit != null) {
	              body = input._bodyInit
	              input.bodyUsed = true
	            }
	          } else {
	            this.url = String(input)
	          }
	
	          this.credentials = options.credentials || this.credentials || 'omit'
	          if (options.headers || !this.headers) {
	            this.headers = new Headers(options.headers)
	          }
	          this.method = normalizeMethod(options.method || this.method || 'GET')
	          this.mode = options.mode || this.mode || null
	          this.referrer = null
	
	          if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	            throw new TypeError('Body not allowed for GET or HEAD requests')
	          }
	          this._initBody(body)
	        }
	
	        Request.prototype.clone = function() {
	          return new Request(this, { body: this._bodyInit })
	        }
	
	        function decode(body) {
	          var form = new FormData()
	          body.trim().split('&').forEach(function(bytes) {
	            if (bytes) {
	              var split = bytes.split('=')
	              var name = split.shift().replace(/\+/g, ' ')
	              var value = split.join('=').replace(/\+/g, ' ')
	              form.append(decodeURIComponent(name), decodeURIComponent(value))
	            }
	          })
	          return form
	        }
	
	        function parseHeaders(rawHeaders) {
	          var headers = new Headers()
	          rawHeaders.split(/\r?\n/).forEach(function(line) {
	            var parts = line.split(':')
	            var key = parts.shift().trim()
	            if (key) {
	              var value = parts.join(':').trim()
	              headers.append(key, value)
	            }
	          })
	          return headers
	        }
	
	        Body.call(Request.prototype)
	
	        function Response(bodyInit, options) {
	          if (!options) {
	            options = {}
	          }
	
	          this.type = 'default'
	          this.status = 'status' in options ? options.status : 200
	          this.ok = this.status >= 200 && this.status < 300
	          this.statusText = 'statusText' in options ? options.statusText : 'OK'
	          this.headers = new Headers(options.headers)
	          this.url = options.url || ''
	          this._initBody(bodyInit)
	        }
	
	        Body.call(Response.prototype)
	
	        Response.prototype.clone = function() {
	          return new Response(this._bodyInit, {
	            status: this.status,
	            statusText: this.statusText,
	            headers: new Headers(this.headers),
	            url: this.url
	          })
	        }
	
	        Response.error = function() {
	          var response = new Response(null, {status: 0, statusText: ''})
	          response.type = 'error'
	          return response
	        }
	
	        var redirectStatuses = [301, 302, 303, 307, 308]
	
	        Response.redirect = function(url, status) {
	          if (redirectStatuses.indexOf(status) === -1) {
	            throw new RangeError('Invalid status code')
	          }
	
	          return new Response(null, {status: status, headers: {location: url}})
	        }
	
	        self.Headers = Headers
	        self.Request = Request
	        self.Response = Response
	
	        self.fetch = function(input, init) {
	          return new Promise(function(resolve, reject) {
	            var request = new Request(input, init)
	            var xhr = new XMLHttpRequest()
	
	            xhr.onload = function() {
	              var options = {
	                status: xhr.status,
	                statusText: xhr.statusText,
	                headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	              }
	              options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	              var body = 'response' in xhr ? xhr.response : xhr.responseText
	              resolve(new Response(body, options))
	            }
	
	            xhr.onerror = function() {
	              reject(new TypeError('Network request failed'))
	            }
	
	            xhr.ontimeout = function() {
	              reject(new TypeError('Network request failed'))
	            }
	
	            xhr.open(request.method, request.url, true)
	
	            if (request.credentials === 'include') {
	              xhr.withCredentials = true
	            }
	
	            if ('responseType' in xhr && support.blob) {
	              xhr.responseType = 'blob'
	            }
	
	            request.headers.forEach(function(value, name) {
	              xhr.setRequestHeader(name, value)
	            })
	
	            xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	          })
	        }
	        self.fetch.polyfill = true
	      })(typeof self !== 'undefined' ? self : this);
	
	
	      return {
	        fetch: self.fetch,
	        Headers: self.Headers,
	        Request: self.Request,
	        Response: self.Response
	      };
	    }());
	  }
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return fetchPonyfill;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = fetchPonyfill;
	  } else {
	    self.fetchPonyfill = fetchPonyfill;
	  }
	}(typeof self === 'undefined' ? this : self));
	


/***/ }),

/***/ 380:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match HTML entities and HTML characters. */
	var reUnescapedHtml = /[&<>"'`]/g,
	    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	/** Used to map characters to HTML entities. */
	var htmlEscapes = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#39;',
	  '`': '&#96;'
	};
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Used by `_.escape` to convert characters to HTML entities.
	 *
	 * @private
	 * @param {string} chr The matched character to escape.
	 * @returns {string} Returns the escaped character.
	 */
	var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
	 * their corresponding HTML entities.
	 *
	 * **Note:** No other characters are escaped. To escape additional
	 * characters use a third-party library like [_he_](https://mths.be/he).
	 *
	 * Though the ">" character is escaped for symmetry, characters like
	 * ">" and "/" don't need escaping in HTML and have no special meaning
	 * unless they're part of a tag or unquoted attribute value. See
	 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	 * (under "semi-related fun fact") for more details.
	 *
	 * Backticks are escaped because in IE < 9, they can break out of
	 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	 * [#133](https://html5sec.org/#133) of the
	 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
	 *
	 * When working with HTML you should always
	 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	 * XSS vectors.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escape('fred, barney, & pebbles');
	 * // => 'fred, barney, &amp; pebbles'
	 */
	function escape(string) {
	  string = toString(string);
	  return (string && reHasUnescapedHtml.test(string))
	    ? string.replace(reUnescapedHtml, escapeHtmlChar)
	    : string;
	}
	
	module.exports = escape;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object ? baseValues(object, keys(object)) : [];
	}
	
	module.exports = includes;


/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory){
	  'use strict';
	
	  /*istanbul ignore next:cant test*/
	  if (typeof module === 'object' && typeof module.exports === 'object') {
	    module.exports = factory();
	  } else if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Browser globals
	    root.objectPath = factory();
	  }
	})(this, function(){
	  'use strict';
	
	  var toStr = Object.prototype.toString;
	  function hasOwnProperty(obj, prop) {
	    if(obj == null) {
	      return false
	    }
	    //to handle objects with null prototypes (too edge case?)
	    return Object.prototype.hasOwnProperty.call(obj, prop)
	  }
	
	  function isEmpty(value){
	    if (!value) {
	      return true;
	    }
	    if (isArray(value) && value.length === 0) {
	        return true;
	    } else if (typeof value !== 'string') {
	        for (var i in value) {
	            if (hasOwnProperty(value, i)) {
	                return false;
	            }
	        }
	        return true;
	    }
	    return false;
	  }
	
	  function toString(type){
	    return toStr.call(type);
	  }
	
	  function isObject(obj){
	    return typeof obj === 'object' && toString(obj) === "[object Object]";
	  }
	
	  var isArray = Array.isArray || function(obj){
	    /*istanbul ignore next:cant test*/
	    return toStr.call(obj) === '[object Array]';
	  }
	
	  function isBoolean(obj){
	    return typeof obj === 'boolean' || toString(obj) === '[object Boolean]';
	  }
	
	  function getKey(key){
	    var intKey = parseInt(key);
	    if (intKey.toString() === key) {
	      return intKey;
	    }
	    return key;
	  }
	
	  function factory(options) {
	    options = options || {}
	
	    var objectPath = function(obj) {
	      return Object.keys(objectPath).reduce(function(proxy, prop) {
	        if(prop === 'create') {
	          return proxy;
	        }
	
	        /*istanbul ignore else*/
	        if (typeof objectPath[prop] === 'function') {
	          proxy[prop] = objectPath[prop].bind(objectPath, obj);
	        }
	
	        return proxy;
	      }, {});
	    };
	
	    function hasShallowProperty(obj, prop) {
	      return (options.includeInheritedProps || (typeof prop === 'number' && Array.isArray(obj)) || hasOwnProperty(obj, prop))
	    }
	
	    function getShallowProperty(obj, prop) {
	      if (hasShallowProperty(obj, prop)) {
	        return obj[prop];
	      }
	    }
	
	    function set(obj, path, value, doNotReplace){
	      if (typeof path === 'number') {
	        path = [path];
	      }
	      if (!path || path.length === 0) {
	        return obj;
	      }
	      if (typeof path === 'string') {
	        return set(obj, path.split('.').map(getKey), value, doNotReplace);
	      }
	      var currentPath = path[0];
	      var currentValue = getShallowProperty(obj, currentPath);
	      if (path.length === 1) {
	        if (currentValue === void 0 || !doNotReplace) {
	          obj[currentPath] = value;
	        }
	        return currentValue;
	      }
	
	      if (currentValue === void 0) {
	        //check if we assume an array
	        if(typeof path[1] === 'number') {
	          obj[currentPath] = [];
	        } else {
	          obj[currentPath] = {};
	        }
	      }
	
	      return set(obj[currentPath], path.slice(1), value, doNotReplace);
	    }
	
	    objectPath.has = function (obj, path) {
	      if (typeof path === 'number') {
	        path = [path];
	      } else if (typeof path === 'string') {
	        path = path.split('.');
	      }
	
	      if (!path || path.length === 0) {
	        return !!obj;
	      }
	
	      for (var i = 0; i < path.length; i++) {
	        var j = getKey(path[i]);
	
	        if((typeof j === 'number' && isArray(obj) && j < obj.length) ||
	          (options.includeInheritedProps ? (j in Object(obj)) : hasOwnProperty(obj, j))) {
	          obj = obj[j];
	        } else {
	          return false;
	        }
	      }
	
	      return true;
	    };
	
	    objectPath.ensureExists = function (obj, path, value){
	      return set(obj, path, value, true);
	    };
	
	    objectPath.set = function (obj, path, value, doNotReplace){
	      return set(obj, path, value, doNotReplace);
	    };
	
	    objectPath.insert = function (obj, path, value, at){
	      var arr = objectPath.get(obj, path);
	      at = ~~at;
	      if (!isArray(arr)) {
	        arr = [];
	        objectPath.set(obj, path, arr);
	      }
	      arr.splice(at, 0, value);
	    };
	
	    objectPath.empty = function(obj, path) {
	      if (isEmpty(path)) {
	        return void 0;
	      }
	      if (obj == null) {
	        return void 0;
	      }
	
	      var value, i;
	      if (!(value = objectPath.get(obj, path))) {
	        return void 0;
	      }
	
	      if (typeof value === 'string') {
	        return objectPath.set(obj, path, '');
	      } else if (isBoolean(value)) {
	        return objectPath.set(obj, path, false);
	      } else if (typeof value === 'number') {
	        return objectPath.set(obj, path, 0);
	      } else if (isArray(value)) {
	        value.length = 0;
	      } else if (isObject(value)) {
	        for (i in value) {
	          if (hasShallowProperty(value, i)) {
	            delete value[i];
	          }
	        }
	      } else {
	        return objectPath.set(obj, path, null);
	      }
	    };
	
	    objectPath.push = function (obj, path /*, values */){
	      var arr = objectPath.get(obj, path);
	      if (!isArray(arr)) {
	        arr = [];
	        objectPath.set(obj, path, arr);
	      }
	
	      arr.push.apply(arr, Array.prototype.slice.call(arguments, 2));
	    };
	
	    objectPath.coalesce = function (obj, paths, defaultValue) {
	      var value;
	
	      for (var i = 0, len = paths.length; i < len; i++) {
	        if ((value = objectPath.get(obj, paths[i])) !== void 0) {
	          return value;
	        }
	      }
	
	      return defaultValue;
	    };
	
	    objectPath.get = function (obj, path, defaultValue){
	      if (typeof path === 'number') {
	        path = [path];
	      }
	      if (!path || path.length === 0) {
	        return obj;
	      }
	      if (obj == null) {
	        return defaultValue;
	      }
	      if (typeof path === 'string') {
	        return objectPath.get(obj, path.split('.'), defaultValue);
	      }
	
	      var currentPath = getKey(path[0]);
	      var nextObj = getShallowProperty(obj, currentPath)
	      if (nextObj === void 0) {
	        return defaultValue;
	      }
	
	      if (path.length === 1) {
	        return nextObj;
	      }
	
	      return objectPath.get(obj[currentPath], path.slice(1), defaultValue);
	    };
	
	    objectPath.del = function del(obj, path) {
	      if (typeof path === 'number') {
	        path = [path];
	      }
	
	      if (obj == null) {
	        return obj;
	      }
	
	      if (isEmpty(path)) {
	        return obj;
	      }
	      if(typeof path === 'string') {
	        return objectPath.del(obj, path.split('.'));
	      }
	
	      var currentPath = getKey(path[0]);
	      if (!hasShallowProperty(obj, currentPath)) {
	        return obj;
	      }
	
	      if(path.length === 1) {
	        if (isArray(obj)) {
	          obj.splice(currentPath, 1);
	        } else {
	          delete obj[currentPath];
	        }
	      } else {
	        return objectPath.del(obj[currentPath], path.slice(1));
	      }
	
	      return obj;
	    }
	
	    return objectPath;
	  }
	
	  var mod = factory();
	  mod.create = factory;
	  mod.withInheritedProps = factory({includeInheritedProps: true})
	  return mod;
	});


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	!function(t,n){ true?module.exports=n():"function"==typeof define&&define.amd?define("PrismicDOM",[],n):"object"==typeof exports?exports.PrismicDOM=n():t.PrismicDOM=n()}(this,function(){return function(t){function n(e){if(r[e])return r[e].exports;var a=r[e]={i:e,l:!1,exports:{}};return t[e].call(a.exports,a,a.exports,n),a.l=!0,a.exports}var r={};return n.m=t,n.c=r,n.i=function(t){return t},n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=5)}([function(t,n,r){!function(n,r){t.exports=function(){return function(t){function n(e){if(r[e])return r[e].exports;var a=r[e]={i:e,l:!1,exports:{}};return t[e].call(a.exports,a,a.exports,n),a.l=!0,a.exports}var r={};return n.m=t,n.c=r,n.i=function(t){return t},n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=3)}([function(t,n,r){"use strict";function e(t){return t&&t.__esModule?t:{default:t}}var a=r(2),u=e(a),c=r(1),i=e(c);t.exports={Link:u.default,Date:i.default}},function(t,n,r){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.default=function(t){if(!t)return null;var n=24==t.length?t.substring(0,22)+":"+t.substring(22,24):t;return new Date(n)}},function(t,n,r){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.default={url:function(t,n){return"Document"===t.link_type?n?n(t,t.isBroken):"":t.url}}},function(t,n,r){t.exports=r(0)}])}()}()},function(t,n,r){"use strict";function e(t){return t&&t.__esModule?t:{default:t}}var a=r(0),u=e(a),c=r(2),i=e(c);t.exports={Date:u.default.Date,RichText:i.default,Link:u.default.Link}},function(t,n,r){"use strict";function e(t){return t&&t.__esModule?t:{default:t}}function a(t,n,r,e,a){switch(n){case p.Elements.heading1:return c("h1",r,a);case p.Elements.heading2:return c("h2",r,a);case p.Elements.heading3:return c("h3",r,a);case p.Elements.heading4:return c("h4",r,a);case p.Elements.heading5:return c("h5",r,a);case p.Elements.heading6:return c("h6",r,a);case p.Elements.paragraph:return c("p",r,a);case p.Elements.preformatted:return i(r);case p.Elements.strong:return c("strong",r,a);case p.Elements.em:return c("em",r,a);case p.Elements.listItem:case p.Elements.oListItem:return c("li",r,a);case p.Elements.list:return c("ul",r,a);case p.Elements.oList:return c("ol",r,a);case p.Elements.image:return o(t,r);case p.Elements.embed:return s(r);case p.Elements.hyperlink:return f(t,r,a);case p.Elements.label:return l(r,a);case p.Elements.span:return v(e);default:return""}}function u(t){return t.label?' class="'+t.label+'"':""}function c(t,n,r){return"<"+t+u(n)+">"+r.join("")+"</"+t+">"}function i(t){return"<pre"+u(t)+">"+(0,j.default)(t.text)+"</pre>"}function o(t,n){var r=n.linkTo?b.Link.url(n.linkTo,t):null,e=n.linkTo&&n.linkTo.target?'target="'+n.linkTo.target+'" rel="noopener"':"",a=[n.label||"","block-img"],u='<img src="'+n.url+'" alt="'+(n.alt||"")+'" copyright="'+(n.copyright||"")+'">';return'\n    <p class="'+a.join(" ")+'">\n      '+(r?"<a "+e+' href="'+r+'">'+u+"</a>":u)+"\n    </p>\n  "}function s(t){return'\n    <div data-oembed="'+t.oembed.embed_url+'"\n      data-oembed-type="'+t.oembed.type+'"\n      data-oembed-provider="'+t.oembed.provider_name+'"\n      '+u(t)+">\n          \n      "+t.oembed.html+"\n    </div>\n  "}function f(t,n,r){return"<a "+(n.data.target?'target="'+n.data.target+'" rel="noopener"':"")+' href="'+b.Link.url(n.data,t)+'">'+r.join("")+"</a>"}function l(t,n){return"<span "+u(t.data)+">"+n.join("")+"</span>"}function v(t){return t?(0,j.default)(t).replace(/\n/g,"<br />"):""}Object.defineProperty(n,"__esModule",{value:!0});var p=r(4),d=e(p),b=r(0),O=r(3),j=e(O);n.default={asText:function(t,n){return d.default.asText(t,n)},asHtml:function(t,n,r){return d.default.serialize(t,a.bind(null,n),r).join("")},Elements:p.Elements}},function(t,n,r){"use strict";function e(t){var n=""+t,r=a.exec(n);if(!r)return n;var e,u="",c=0,i=0;for(c=r.index;c<n.length;c++){switch(n.charCodeAt(c)){case 34:e="&quot;";break;case 38:e="&amp;";break;case 39:e="&#39;";break;case 60:e="&lt;";break;case 62:e="&gt;";break;default:continue}i!==c&&(u+=n.substring(i,c)),i=c+1,u+=e}return i!==c?u+n.substring(i,c):u}/*!
	 * escape-html
	 * Copyright(c) 2012-2013 TJ Holowaychuk
	 * Copyright(c) 2015 Andreas Lubbe
	 * Copyright(c) 2015 Tiancheng "Timothy" Gu
	 * MIT Licensed
	 */
	var a=/["'&<>]/;t.exports=e},function(t,n,r){!function(n,r){t.exports=function(){return function(t){function n(e){if(r[e])return r[e].exports;var a=r[e]={i:e,l:!1,exports:{}};return t[e].call(a.exports,a,a.exports,n),a.l=!0,a.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=123)}([function(t,n,r){"use strict";function e(t){return function n(r,e){switch(arguments.length){case 0:return n;case 1:return Object(u.a)(r)?n:Object(a.a)(function(n){return t(r,n)});default:return Object(u.a)(r)&&Object(u.a)(e)?n:Object(u.a)(r)?Object(a.a)(function(n){return t(n,e)}):Object(u.a)(e)?Object(a.a)(function(n){return t(r,n)}):t(r,e)}}}n.a=e;var a=r(1),u=r(27)},function(t,n,r){"use strict";function e(t){return function n(r){return 0===arguments.length||Object(a.a)(r)?n:t.apply(this,arguments)}}n.a=e;var a=r(27)},function(t,n,r){"use strict";function e(t){return function n(r,e,i){switch(arguments.length){case 0:return n;case 1:return Object(c.a)(r)?n:Object(u.a)(function(n,e){return t(r,n,e)});case 2:return Object(c.a)(r)&&Object(c.a)(e)?n:Object(c.a)(r)?Object(u.a)(function(n,r){return t(n,e,r)}):Object(c.a)(e)?Object(u.a)(function(n,e){return t(r,n,e)}):Object(a.a)(function(n){return t(r,e,n)});default:return Object(c.a)(r)&&Object(c.a)(e)&&Object(c.a)(i)?n:Object(c.a)(r)&&Object(c.a)(e)?Object(u.a)(function(n,r){return t(n,r,i)}):Object(c.a)(r)&&Object(c.a)(i)?Object(u.a)(function(n,r){return t(n,e,r)}):Object(c.a)(e)&&Object(c.a)(i)?Object(u.a)(function(n,e){return t(r,n,e)}):Object(c.a)(r)?Object(a.a)(function(n){return t(n,e,i)}):Object(c.a)(e)?Object(a.a)(function(n){return t(r,n,i)}):Object(c.a)(i)?Object(a.a)(function(n){return t(r,e,n)}):t(r,e,i)}}}n.a=e;var a=r(1),u=r(0),c=r(27)},function(t,n,r){"use strict";function e(t,n,r){return function(){if(0===arguments.length)return r();var e=Array.prototype.slice.call(arguments,0),c=e.pop();if(!Object(a.a)(c)){for(var i=0;i<t.length;){if("function"==typeof c[t[i]])return c[t[i]].apply(c,e);i+=1}if(Object(u.a)(c))return n.apply(null,e)(c)}return r.apply(this,arguments)}}n.a=e;var a=r(15),u=r(43)},function(t,n,r){"use strict";n.a={init:function(){return this.xf["@@transducer/init"]()},result:function(t){return this.xf["@@transducer/result"](t)}}},function(t,n,r){"use strict";var e=r(12),a=r(1),u=r(0),c=r(29),i=Object(u.a)(function(t,n){return 1===t?Object(a.a)(n):Object(e.a)(t,Object(c.a)(t,[],n))});n.a=i},function(t,n,r){"use strict";function e(t,n){return Object.prototype.hasOwnProperty.call(n,t)}n.a=e},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(30),c=r(8),i=r(134),o=r(5),s=r(13),f=Object(e.a)(Object(a.a)(["fantasy-land/map","map"],i.a,function(t,n){switch(Object.prototype.toString.call(n)){case"[object Function]":return Object(o.a)(n.length,function(){return t.call(this,n.apply(this,arguments))});case"[object Object]":return Object(c.a)(function(r,e){return r[e]=t(n[e]),r},{},Object(s.a)(n));default:return Object(u.a)(t,n)}}));n.a=f},function(t,n,r){"use strict";function e(t,n,r){for(var e=0,a=r.length;e<a;){if((n=t["@@transducer/step"](n,r[e]))&&n["@@transducer/reduced"]){n=n["@@transducer/value"];break}e+=1}return t["@@transducer/result"](n)}function a(t,n,r){for(var e=r.next();!e.done;){if((n=t["@@transducer/step"](n,e.value))&&n["@@transducer/reduced"]){n=n["@@transducer/value"];break}e=r.next()}return t["@@transducer/result"](n)}function u(t,n,r,e){return t["@@transducer/result"](r[e](Object(s.a)(t["@@transducer/step"],t),n))}function c(t,n,r){if("function"==typeof t&&(t=Object(o.a)(t)),Object(i.a)(r))return e(t,n,r);if("function"==typeof r["fantasy-land/reduce"])return u(t,n,r,"fantasy-land/reduce");if(null!=r[f])return a(t,n,r[f]());if("function"==typeof r.next)return a(t,n,r);if("function"==typeof r.reduce)return u(t,n,r,"reduce");throw new TypeError("reduce: list must be array or iterable")}n.a=c;var i=r(31),o=r(66),s=r(67),f="undefined"!=typeof Symbol?Symbol.iterator:"@@iterator"},function(t,n,r){"use strict";var e=r(0),a=r(157),u=Object(e.a)(function(t,n){return Object(a.a)(t,n,[],[])});n.a=u},function(t,n,r){"use strict";function e(t,n){t=t||[],n=n||[];var r,e=t.length,a=n.length,u=[];for(r=0;r<e;)u[u.length]=t[r],r+=1;for(r=0;r<a;)u[u.length]=n[r],r+=1;return u}n.a=e},function(t,n,r){"use strict";var e=r(23),a=r(2),u=Object(a.a)(Object(e.a)("slice",function(t,n,r){return Array.prototype.slice.call(r,t,n)}));n.a=u},function(t,n,r){"use strict";function e(t,n){switch(t){case 0:return function(){return n.apply(this,arguments)};case 1:return function(t){return n.apply(this,arguments)};case 2:return function(t,r){return n.apply(this,arguments)};case 3:return function(t,r,e){return n.apply(this,arguments)};case 4:return function(t,r,e,a){return n.apply(this,arguments)};case 5:return function(t,r,e,a,u){return n.apply(this,arguments)};case 6:return function(t,r,e,a,u,c){return n.apply(this,arguments)};case 7:return function(t,r,e,a,u,c,i){return n.apply(this,arguments)};case 8:return function(t,r,e,a,u,c,i,o){return n.apply(this,arguments)};case 9:return function(t,r,e,a,u,c,i,o,s){return n.apply(this,arguments)};case 10:return function(t,r,e,a,u,c,i,o,s,f){return n.apply(this,arguments)};default:throw new Error("First argument to _arity must be a non-negative integer no greater than ten")}}n.a=e},function(t,n,r){"use strict";var e=r(1),a=r(6),u=r(68),c=!{toString:null}.propertyIsEnumerable("toString"),i=["constructor","valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"],o=function(){return arguments.propertyIsEnumerable("length")}(),s=function(t,n){for(var r=0;r<t.length;){if(t[r]===n)return!0;r+=1}return!1},f="function"!=typeof Object.keys||o?function(t){if(Object(t)!==t)return[];var n,r,e=[],f=o&&Object(u.a)(t);for(n in t)!Object(a.a)(n,t)||f&&"length"===n||(e[e.length]=n);if(c)for(r=i.length-1;r>=0;)n=i[r],Object(a.a)(n,t)&&!s(e,n)&&(e[e.length]=n),r-=1;return e}:function(t){return Object(t)!==t?[]:Object.keys(t)},l=Object(e.a)(f);n.a=l},function(t,n,r){"use strict";var e=r(2),a=r(8),u=Object(e.a)(a.a);n.a=u},function(t,n,r){"use strict";n.a=Array.isArray||function(t){return null!=t&&t.length>=0&&"[object Array]"===Object.prototype.toString.call(t)}},function(t,n,r){"use strict";function e(t){return t&&t["@@transducer/reduced"]?t:{"@@transducer/value":t,"@@transducer/reduced":!0}}n.a=e},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){return function(){return t}});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return n>t?n:t});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r=n,e=0;e<t.length;){if(null==r)return;r=r[t[e]],e+=1}return r});n.a=a},function(t,n,r){"use strict";function e(t,n){return Object(a.a)(n,t,0)>=0}n.a=e;var a=r(84)},function(t,n,r){"use strict";var e=r(0),a=r(7),u=r(44),c=Object(e.a)(function(t,n){return Object(a.a)(Object(u.a)(t),n)});n.a=c},function(t,n,r){"use strict";function e(t){return"[object String]"===Object.prototype.toString.call(t)}n.a=e},function(t,n,r){"use strict";function e(t,n){return function(){var r=arguments.length;if(0===r)return n();var e=arguments[r-1];return Object(a.a)(e)||"function"!=typeof e[t]?n.apply(this,arguments):e[t].apply(e,Array.prototype.slice.call(arguments,0,r-1))}}n.a=e;var a=r(15)},function(t,n,r){"use strict";var e=r(1),a=r(156),u=Object(e.a)(function(t){return Object(a.a)(t,[])});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(22),u=Object(e.a)(function(t,n){var r=t<0?n.length+t:t;return Object(a.a)(n)?n.charAt(r):n[r]});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(34),u=r(5),c=r(24),i=Object(e.a)(function(t,n){return Object(u.a)(t+1,function(){var r=arguments[t];if(null!=r&&Object(a.a)(r[n]))return r[n].apply(r,Array.prototype.slice.call(arguments,0,t));throw new TypeError(Object(c.a)(r)+' does not have a method named "'+n+'"')})});n.a=i},function(t,n,r){"use strict";function e(t){return null!=t&&"object"==typeof t&&!0===t["@@functional/placeholder"]}n.a=e},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return Number(t)+Number(n)});n.a=a},function(t,n,r){"use strict";function e(t,n,r){return function(){for(var c=[],i=0,o=t,s=0;s<n.length||i<arguments.length;){var f;s<n.length&&(!Object(u.a)(n[s])||i>=arguments.length)?f=n[s]:(f=arguments[i],i+=1),c[s]=f,Object(u.a)(f)||(o-=1),s+=1}return o<=0?r.apply(this,c):Object(a.a)(o,e(t,c,r))}}n.a=e;var a=r(12),u=r(27)},function(t,n,r){"use strict";function e(t,n){for(var r=0,e=n.length,a=Array(e);r<e;)a[r]=t(n[r]),r+=1;return a}n.a=e},function(t,n,r){"use strict";var e=r(1),a=r(15),u=r(22),c=Object(e.a)(function(t){return!!Object(a.a)(t)||!!t&&"object"==typeof t&&!Object(u.a)(t)&&(1===t.nodeType?!!t.length:0===t.length||t.length>0&&t.hasOwnProperty(0)&&t.hasOwnProperty(t.length-1))});n.a=c},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){var e={};for(var a in r)e[a]=r[a];return e[t]=n,e});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){switch(t){case 0:return function(){return n.call(this)};case 1:return function(t){return n.call(this,t)};case 2:return function(t,r){return n.call(this,t,r)};case 3:return function(t,r,e){return n.call(this,t,r,e)};case 4:return function(t,r,e,a){return n.call(this,t,r,e,a)};case 5:return function(t,r,e,a,u){return n.call(this,t,r,e,a,u)};case 6:return function(t,r,e,a,u,c){return n.call(this,t,r,e,a,u,c)};case 7:return function(t,r,e,a,u,c,i){return n.call(this,t,r,e,a,u,c,i)};case 8:return function(t,r,e,a,u,c,i,o){return n.call(this,t,r,e,a,u,c,i,o)};case 9:return function(t,r,e,a,u,c,i,o,s){return n.call(this,t,r,e,a,u,c,i,o,s)};case 10:return function(t,r,e,a,u,c,i,o,s,f){return n.call(this,t,r,e,a,u,c,i,o,s,f)};default:throw new Error("First argument to nAry must be a non-negative integer no greater than ten")}});n.a=a},function(t,n,r){"use strict";function e(t){return"[object Function]"===Object.prototype.toString.call(t)}n.a=e},function(t,n,r){"use strict";var e=r(1),a=r(76),u=Object(e.a)(function(t){return Object(a.a)(t.length,t)});n.a=u},function(t,n,r){"use strict";var e=r(1),a=r(22),u=Object(e.a)(function(t){return Object(a.a)(t)?t.split("").reverse().join(""):Array.prototype.slice.call(t,0).reverse()});n.a=u},function(t,n,r){"use strict";function e(t,n,r){for(var e=0,a=r.length;e<a;){if(t(n,r[e]))return!0;e+=1}return!1}n.a=e},function(t,n,r){"use strict";var e=r(86),a=r(0),u=r(53),c=Object(a.a)(function(t,n){return Object(u.a)(Object(e.a)(t),n)});n.a=c},function(t,n,r){"use strict";var e=r(29),a=r(3),u=r(6),c=r(8),i=r(167),o=Object(e.a)(4,[],Object(a.a)([],i.a,function(t,n,r,e){return Object(c.a)(function(e,a){var c=r(a);return e[c]=t(Object(u.a)(c,e)?e[c]:n,a),e},{},e)}));n.a=o},function(t,n,r){"use strict";var e=r(1),a=r(5),u=Object(e.a)(function(t){return Object(a.a)(t.length,function(n,r){var e=Array.prototype.slice.call(arguments,0);return e[0]=r,e[1]=n,t.apply(this,e)})});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(7),u=Object(e.a)(function(t,n){return function(r){return function(e){return Object(a.a)(function(t){return n(t,e)},r(t(e)))}}});n.a=u},function(t,n,r){"use strict";var e=r(2),a=r(55),u=r(62),c=Object(e.a)(function t(n,r,e){return Object(u.a)(function(r,e,u){return Object(a.a)(e)&&Object(a.a)(u)?t(n,e,u):n(r,e,u)},r,e)});n.a=c},function(t,n,r){"use strict";function e(t){return"function"==typeof t["@@transducer/step"]}n.a=e},function(t,n,r){"use strict";var e=r(0),a=r(19),u=Object(e.a)(function(t,n){return Object(a.a)([t],n)});n.a=u},function(t,n,r){"use strict";var e=r(10),a=r(0),u=r(8),c=r(7),i=Object(a.a)(function(t,n){return"function"==typeof n["fantasy-land/ap"]?n["fantasy-land/ap"](t):"function"==typeof t.ap?t.ap(n):"function"==typeof t?function(r){return t(r)(n(r))}:Object(u.a)(function(t,r){return Object(e.a)(t,Object(c.a)(r,n))},[],t)});n.a=i},function(t,n,r){"use strict";n.a=Number.isInteger||function(t){return t<<0===t}},function(t,n,r){"use strict";var e=r(1),a=r(5),u=Object(e.a)(function(t){return Object(a.a)(t.length,t)});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(77),c=r(146),i=r(7),o=Object(e.a)(Object(a.a)(["fantasy-land/chain","chain"],c.a,function(t,n){return"function"==typeof n?function(r){return t(n(r))(r)}:Object(u.a)(!1)(Object(i.a)(t,n))}));n.a=o},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){return null===t?"Null":void 0===t?"Undefined":Object.prototype.toString.call(t).slice(8,-1)});n.a=a},function(t,n,r){"use strict";function e(){if(0===arguments.length)throw new Error("compose requires at least one argument");return a.a.apply(this,Object(u.a)(arguments))}n.a=e;var a=r(81),u=r(36)},function(t,n,r){"use strict";var e=r(23),a=r(1),u=r(11),c=Object(a.a)(Object(e.a)("tail",Object(u.a)(1,1/0)));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(15),u=r(34),c=r(22),i=r(24),o=Object(e.a)(function(t,n){if(Object(a.a)(t)){if(Object(a.a)(n))return t.concat(n);throw new TypeError(Object(i.a)(n)+" is not an array")}if(Object(c.a)(t)){if(Object(c.a)(n))return t+n;throw new TypeError(Object(i.a)(n)+" is not a string")}if(null!=t&&Object(u.a)(t["fantasy-land/concat"]))return t["fantasy-land/concat"](n);if(null!=t&&Object(u.a)(t.concat))return t.concat(n);throw new TypeError(Object(i.a)(t)+' does not have a method named "concat" or "fantasy-land/concat"')});n.a=o},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(54),c=r(55),i=r(8),o=r(162),s=r(13),f=Object(e.a)(Object(a.a)(["filter"],o.a,function(t,n){return Object(c.a)(n)?Object(i.a)(function(r,e){return t(n[e])&&(r[e]=n[e]),r},{},Object(s.a)(n)):Object(u.a)(t,n)}));n.a=f},function(t,n,r){"use strict";function e(t,n){for(var r=0,e=n.length,a=[];r<e;)t(n[r])&&(a[a.length]=n[r]),r+=1;return a}n.a=e},function(t,n,r){"use strict";function e(t){return"[object Object]"===Object.prototype.toString.call(t)}n.a=e},function(t,n,r){"use strict";var e=r(2),a=r(65),u=r(17),c=Object(e.a)(function(t,n,r){return Object(a.a)(Object(u.a)(n),t,r)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(175),c=r(11),i=Object(e.a)(Object(a.a)(["take"],u.a,function(t,n){return Object(c.a)(0,t<0?1/0:t,n)}));n.a=i},function(t,n,r){"use strict";var e=r(1),a=r(59),u=Object(e.a)(a.a);n.a=u},function(t,n,r){"use strict";function e(t){return t}n.a=e},function(t,n,r){"use strict";var e=r(58),a=r(101),u=Object(a.a)(e.a);n.a=u},function(t,n,r){"use strict";var e=r(220);n.a="function"==typeof Object.assign?Object.assign:e.a},function(t,n,r){"use strict";var e=r(2),a=r(6),u=Object(e.a)(function(t,n,r){var e,u={};for(e in n)Object(a.a)(e,n)&&(u[e]=Object(a.a)(e,r)?t(e,n[e],r[e]):n[e]);for(e in r)Object(a.a)(e,r)&&!Object(a.a)(e,u)&&(u[e]=r[e]);return u});n.a=u},function(t,n,r){"use strict";n.__esModule=!0,n.NODE_TYPES={heading1:"heading1",heading2:"heading2",heading3:"heading3",heading4:"heading4",heading5:"heading5",heading6:"heading6",paragraph:"paragraph",preformatted:"preformatted",strong:"strong",em:"em",listItem:"list-item",oListItem:"o-list-item",list:"group-list-item",oList:"group-o-list-item",image:"image",embed:"embed",hyperlink:"hyperlink",label:"label",span:"span"},n.PRIORITIES=(e={},e[n.NODE_TYPES.heading1]=4,e[n.NODE_TYPES.heading2]=4,e[n.NODE_TYPES.heading3]=4,e[n.NODE_TYPES.heading4]=4,e[n.NODE_TYPES.heading5]=4,e[n.NODE_TYPES.heading6]=4,e[n.NODE_TYPES.paragraph]=3,e[n.NODE_TYPES.preformatted]=5,e[n.NODE_TYPES.strong]=6,e[n.NODE_TYPES.em]=6,e[n.NODE_TYPES.oList]=1,e[n.NODE_TYPES.list]=1,e[n.NODE_TYPES.listItem]=1,e[n.NODE_TYPES.oListItem]=1,e[n.NODE_TYPES.image]=1,e[n.NODE_TYPES.embed]=1,e[n.NODE_TYPES.hyperlink]=3,e[n.NODE_TYPES.label]=4,e[n.NODE_TYPES.span]=7,e);var e},function(t,n,r){"use strict";function e(t){return t.sort(function(t,n){if(t.isParentOf(n))return-1;if(n.isParentOf(t))return 1;var r=O.PRIORITIES[t.type]-O.PRIORITIES[n.type];return 0===r?t.text.length-n.text.length:r})}function a(t,n,r){return r.start<n.start?{inner:j.SpanNode.slice(r,n.start,r.end,t),outer:j.SpanNode.slice(r,r.start,n.start,t)}:r.end>n.end?{inner:j.SpanNode.slice(r,r.start,n.end,t),outer:j.SpanNode.slice(r,n.end,r.end,t)}:{inner:r}}function u(t,n){var r=n.others.reduce(function(r,e){var u=r.inner,c=r.outer,i=a(t,n.elected,e);return{inner:u.concat(i.inner),outer:i.outer?c.concat(i.outer):c}},{inner:[],outer:[]}),e=r.inner,u=r.outer;return[n.elected.setChildren(f(t,e,n.elected.boundaries()))].concat(l(t,u))}function c(t,n){return n.reduce(function(n,r){var e=p.last(n);if(e){if(e.some(function(t){return t.isParentOf(r)}))return p.init(n).concat([e.concat(r)]);var a=p.last(e);return a&&t(a,r)?p.init(n).concat([e.concat(r)]):n.concat([[r]])}return[[r]]},[])}function i(t){var n=function(t,n){return t.start-n.start},r=function(t,n){return t.end-n.end},e=p.sortWith([n,r],t);return c(function(t,n){return t.end>=n.start},e)}function o(t){if(0===t.length)throw new Error("Unable to elect node on empty list");var n=e(t);return{elected:n[0],others:n.slice(1)}}function s(t,n,r){return n.reduce(function(e,a,u){var c=[],i=0===u&&a.start>r.lower,o=u===n.length-1&&r.upper>a.end;if(i){var s=new j.TextNode(r.lower,a.start,t.slice(r.lower,a.start));c=c.concat(s)}else{var f=n[u-1];if(f&&a.start>f.end){var l=t.slice(f.end,a.start),s=new j.TextNode(f.end,a.start,l);c=c.concat(s)}}if(c=c.concat(a),o){var s=new j.TextNode(a.end,r.upper,t.slice(a.end,r.upper));c=c.concat(s)}return e.concat(c)},[])}function f(t,n,r){if(n.length>0)return s(t,l(t,n),r);var e=t.slice(r.lower,r.upper);return[new j.TextNode(r.lower,r.upper,e)]}function l(t,n){var r=p.sortBy(function(t){return t.start},n),e=i(r),a=e.map(o),c=p.flatten(a.map(function(n){return u(t,n)}));return p.sortBy(function(t){return t.start},c)}function v(t){var n=t.spans.map(function(n){var r=t.text.slice(n.start,n.end);return new j.SpanNode(n.start,n.end,n.type,r,[],n)}),r={lower:0,upper:t.text.length};return f(t.text,n,r)}n.__esModule=!0;var p=r(126),d=r(121),b=r(326),O=r(63),j=r(122),h=function(){function t(){}return t.fromRichText=function(t){return{key:d.default(),children:t.reduce(function(t,n,r){if(b.RichTextBlock.isEmbedBlock(n.type)||b.RichTextBlock.isImageBlock(n.type))return t.concat(new j.BlockNode(n.type,n));var e=v(n),a=t[t.length-1];if(b.RichTextBlock.isListItem(n.type)&&a&&a instanceof j.ListBlockNode){var u=new j.ListItemBlockNode(n,e),c=a.addChild(u);return p.init(t).concat(c)}if(b.RichTextBlock.isOrderedListItem(n.type)&&a&&a instanceof j.OrderedListBlockNode){var i=new j.OrderedListItemBlockNode(n,e),c=a.addChild(i);return p.init(t).concat(c)}if(b.RichTextBlock.isListItem(n.type)){var u=new j.ListItemBlockNode(n,e),o=new j.ListBlockNode(b.RichTextBlock.emptyList(),[u]);return t.concat(o)}if(b.RichTextBlock.isOrderedListItem(n.type)){var i=new j.OrderedListItemBlockNode(n,e),s=new j.OrderedListBlockNode(b.RichTextBlock.emptyOrderedList(),[i]);return t.concat(s)}return t.concat(new j.BlockNode(n.type,n,e))},[])}},t.NODE_TYPES=O.NODE_TYPES,t}();n.default=h},function(t,n,r){"use strict";var e=r(10),a=r(2),u=Object(a.a)(function(t,n,r){if(n>=r.length||n<-r.length)return r;var a=n<0?r.length:0,u=a+n,c=Object(e.a)(r);return c[u]=t(r[u]),c});n.a=u},function(t,n,r){"use strict";function e(t){return new a(t)}n.a=e;var a=function(){function t(t){this.f=t}return t.prototype["@@transducer/init"]=function(){throw new Error("init not implemented on XWrap")},t.prototype["@@transducer/result"]=function(t){return t},t.prototype["@@transducer/step"]=function(t,n){return this.f(t,n)},t}()},function(t,n,r){"use strict";var e=r(12),a=r(0),u=Object(a.a)(function(t,n){return Object(e.a)(t.length,function(){return t.apply(n,arguments)})});n.a=u},function(t,n,r){"use strict";var e=r(6),a=Object.prototype.toString,u=function(){return"[object Arguments]"===a.call(arguments)?function(t){return"[object Arguments]"===a.call(t)}:function(t){return Object(e.a)("callee",t)}};n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t&&n});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(71),c=Object(e.a)(Object(a.a)(["any"],u.a,function(t,n){for(var r=0;r<n.length;){if(t(n[r]))return!0;r+=1}return!1}));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(16),u=r(4),c=function(){function t(t,n){this.xf=n,this.f=t,this.any=!1}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=function(t){return this.any||(t=this.xf["@@transducer/step"](t,!1)),this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){return this.f(n)&&(this.any=!0,t=Object(a.a)(this.xf["@@transducer/step"](t,!0))),t},t}(),i=Object(e.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t.apply(this,n)});n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(13),u=Object(e.a)(function(t){for(var n=Object(a.a)(t),r=n.length,e=[],u=0;u<r;)e[u]=t[n[u]],u+=1;return e});n.a=u},function(t,n,r){"use strict";var e=r(2),a=r(6),u=r(15),c=r(46),i=r(32),o=r(75),s=Object(e.a)(function t(n,r,e){if(0===n.length)return r;var s=n[0];if(n.length>1){var f=!Object(o.a)(e)&&Object(a.a)(s,e)?e[s]:Object(c.a)(n[1])?[]:{};r=t(Array.prototype.slice.call(n,1),r,f)}if(Object(c.a)(s)&&Object(u.a)(e)){var l=[].concat(e);return l[s]=r,l}return Object(i.a)(s,r,e)});n.a=s},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){return null==t});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(8),u=r(45),c=r(5),i=r(7),o=Object(e.a)(function(t,n){var r=Object(c.a)(t,n);return Object(c.a)(t,function(){return Object(a.a)(u.a,Object(i.a)(r,arguments[0]),Array.prototype.slice.call(arguments,1))})});n.a=o},function(t,n,r){"use strict";function e(t){return function n(r){for(var e,u,c,i=[],o=0,s=r.length;o<s;){if(Object(a.a)(r[o]))for(e=t?n(r[o]):r[o],c=0,u=e.length;c<u;)i[i.length]=e[c],c+=1;else i[i.length]=r[o];o+=1}return i}}n.a=e;var a=r(31)},function(t,n,r){"use strict";function e(t,n,r,c){var i=function(a){for(var u=n.length,i=0;i<u;){if(t===n[i])return r[i];i+=1}n[i+1]=t,r[i+1]=a;for(var o in t)a[o]=c?e(t[o],n,r,!0):t[o];return a};switch(Object(u.a)(t)){case"Object":return i({});case"Array":return i([]);case"Date":return new Date(t.valueOf());case"RegExp":return Object(a.a)(t);default:return t}}n.a=e;var a=r(79),u=r(49)},function(t,n,r){"use strict";function e(t){return new RegExp(t.source,(t.global?"g":"")+(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.sticky?"y":"")+(t.unicode?"u":""))}n.a=e},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){return!t});n.a=a},function(t,n,r){"use strict";function e(){if(0===arguments.length)throw new Error("pipe requires at least one argument");return Object(a.a)(arguments[0].length,Object(c.a)(u.a,arguments[0],Object(i.a)(arguments)))}n.a=e;var a=r(12),u=r(153),c=r(14),i=r(51)},function(t,n,r){"use strict";function e(){if(0===arguments.length)throw new Error("composeK requires at least one argument");var t=Array.prototype.slice.call(arguments),n=t.pop();return Object(u.a)(u.a.apply(this,Object(c.a)(a.a,t)),n)}n.a=e;var a=r(48),u=r(50),c=r(7)},function(t,n,r){"use strict";function e(){if(0===arguments.length)throw new Error("pipeP requires at least one argument");return Object(a.a)(arguments[0].length,Object(c.a)(u.a,arguments[0],Object(i.a)(arguments)))}n.a=e;var a=r(12),u=r(155),c=r(14),i=r(51)},function(t,n,r){"use strict";function e(t,n,r){var e,u;if("function"==typeof t.indexOf)switch(typeof n){case"number":if(0===n){for(e=1/n;r<t.length;){if(0===(u=t[r])&&1/u===e)return r;r+=1}return-1}if(n!==n){for(;r<t.length;){if("number"==typeof(u=t[r])&&u!==u)return r;r+=1}return-1}return t.indexOf(n,r);case"string":case"boolean":case"function":case"undefined":return t.indexOf(n,r);case"object":if(null===n)return t.indexOf(n,r)}for(;r<t.length;){if(Object(a.a)(t[r],n))return r;r+=1}return-1}n.a=e;var a=r(9)},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t===n?0!==t||1/t==1/n:t!==t&&n!==n});n.a=a},function(t,n,r){"use strict";function e(t){return function(){return!t.apply(this,arguments)}}n.a=e},function(t,n,r){"use strict";var e=r(0),a=r(47),u=r(33),c=Object(e.a)(function(t,n){if(t>10)throw new Error("Constructor with greater than ten arguments");return 0===t?function(){return new n}:Object(a.a)(Object(u.a)(t,function(t,r,e,a,u,c,i,o,s,f){switch(arguments.length){case 1:return new n(t);case 2:return new n(t,r);case 3:return new n(t,r,e);case 4:return new n(t,r,e,a);case 5:return new n(t,r,e,a,u);case 6:return new n(t,r,e,a,u,c);case 7:return new n(t,r,e,a,u,c,i);case 8:return new n(t,r,e,a,u,c,i,o);case 9:return new n(t,r,e,a,u,c,i,o,s);case 10:return new n(t,r,e,a,u,c,i,o,s,f)}}))});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(30),u=r(5),c=r(18),i=r(21),o=r(14),s=Object(e.a)(function(t,n){return Object(u.a)(Object(o.a)(c.a,0,Object(i.a)("length",n)),function(){var r=arguments,e=this;return t.apply(e,Object(a.a)(function(t){return t.apply(e,r)},n))})});n.a=s},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return null==n||n!==n?t:n});n.a=a},function(t,n,r){"use strict";var e=r(20),a=r(0),u=Object(a.a)(function(t,n){for(var r=[],a=0,u=t.length;a<u;)Object(e.a)(t[a],n)||Object(e.a)(t[a],r)||(r[r.length]=t[a]),a+=1;return r});n.a=u},function(t,n,r){"use strict";var e=r(37),a=r(2),u=Object(a.a)(function(t,n,r){for(var a=[],u=0,c=n.length;u<c;)Object(e.a)(t,n[u],r)||Object(e.a)(t,n[u],a)||a.push(n[u]),u+=1;return a});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){var r={};for(var e in n)r[e]=n[e];return delete r[t],r});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){var e=Array.prototype.slice.call(r,0);return e.splice(t,n),e});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(172),c=r(11),i=Object(e.a)(Object(a.a)(["drop"],u.a,function(t,n){return Object(c.a)(Math.max(0,t),1/0,n)}));n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.pred=t,this.lastValue=void 0,this.seenFirstValue=!1}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=a.a.result,t.prototype["@@transducer/step"]=function(t,n){var r=!1;return this.seenFirstValue?this.pred(this.lastValue,n)&&(r=!0):this.seenFirstValue=!0,this.lastValue=n,r?t:this.xf["@@transducer/step"](t,n)},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(95),c=r(97),i=Object(e.a)(Object(a.a)([],u.a,function(t,n){var r=[],e=1,a=n.length;if(0!==a)for(r[0]=n[0];e<a;)t(Object(c.a)(r),n[e])||(r[r.length]=n[e]),e+=1;return r}));n.a=i},function(t,n,r){"use strict";var e=r(25),a=Object(e.a)(-1);n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t||n});n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(68),u=r(15),c=r(55),i=r(22),o=Object(e.a)(function(t){return null!=t&&"function"==typeof t["fantasy-land/empty"]?t["fantasy-land/empty"]():null!=t&&null!=t.constructor&&"function"==typeof t.constructor["fantasy-land/empty"]?t.constructor["fantasy-land/empty"]():null!=t&&"function"==typeof t.empty?t.empty():null!=t&&null!=t.constructor&&"function"==typeof t.constructor.empty?t.constructor.empty():Object(u.a)(t)?[]:Object(i.a)(t)?"":Object(c.a)(t)?{}:Object(a.a)(t)?function(){return arguments}():void 0});n.a=o},function(t,n,r){"use strict";var e=r(0),a=r(94),u=Object(e.a)(function(t,n){return Object(a.a)(t>=0?n.length-t:0,n)});n.a=u},function(t,n,r){"use strict";var e=r(216),a=r(0),u=Object(a.a)(function(t,n){for(var r,a,u=new e.a,c=[],i=0;i<n.length;)a=n[i],r=t(a),u.add(r)&&c.push(a),i+=1;return c});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){var r={};return r[t]=n,r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return null!=n&&n.constructor===t||n instanceof t});n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(88),u=Object(e.a)(function(t){return Object(a.a)(function(){return Array.prototype.slice.call(arguments,0)},t)});n.a=u},function(t,n,r){"use strict";var e=r(1),a=r(106),u=Object(e.a)(function(t){return null!=t&&Object(a.a)(t.length)?t.length:NaN});n.a=u},function(t,n,r){"use strict";function e(t){return"[object Number]"===Object.prototype.toString.call(t)}n.a=e},function(t,n,r){"use strict";var e=r(1),a=r(108),u=Object(e.a)(function(t){return Object(a.a)(t)/t.length});n.a=u},function(t,n,r){"use strict";var e=r(28),a=r(14),u=Object(a.a)(e.a,0);n.a=u},function(t,n,r){"use strict";var e=r(12),a=r(0),u=r(6),c=Object(a.a)(function(t,n){var r={};return Object(e.a)(n.length,function(){var e=t.apply(this,arguments);return Object(u.a)(e,r)||(r[e]=n.apply(this,arguments)),r[e]})});n.a=c},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t*n});n.a=a},function(t,n,r){"use strict";var e=r(2),a=function(t){return{value:t,map:function(n){return a(n(t))}}},u=Object(e.a)(function(t,n,r){return t(function(t){return a(n(t))})(r).value});n.a=u},function(t,n,r){"use strict";function e(t){return Object(u.a)(function(n,r){return Object(a.a)(Math.max(0,n.length-r.length),function(){return n.apply(this,t(r,arguments))})})}n.a=e;var a=r(12),u=r(0)},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r={},e=0,a=t.length;e<a;){var u=t[e];r[u]=n[u],e+=1}return r});n.a=a},function(t,n,r){"use strict";var e=r(10),a=r(0),u=Object(a.a)(function(t,n){return Object(e.a)([t],n)});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(5),u=Object(e.a)(function(t,n){return Object(a.a)(n.length,function(){for(var r=[],e=0;e<n.length;)r.push(n[e].call(this,arguments[e])),e+=1;return t.apply(this,r.concat(Array.prototype.slice.call(arguments,n.length)))})});n.a=u},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){for(var e=r.length-1;e>=0;)n=t(r[e],n),e-=1;return n});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){var r,e=Number(n),a=0;if(e<0||isNaN(e))throw new RangeError("n must be a non-negative number");for(r=new Array(e);a<e;)r[a]=t(a),a+=1;return r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(45),u=r(7),c=r(114),i=r(116),o=Object(e.a)(function(t,n){return"function"==typeof n.sequence?n.sequence(t):Object(i.a)(function(t,n){return Object(a.a)(Object(u.a)(c.a,t),n)},t([]),n)});n.a=o},function(t,n,r){"use strict";var e=r(37),a=r(0),u=Object(a.a)(function(t,n){for(var r,a=0,u=n.length,c=[];a<u;)r=n[a],Object(e.a)(t,r,c)||(c[c.length]=r),a+=1;return c});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(6),u=Object(e.a)(function(t,n){for(var r in t)if(Object(a.a)(r,t)&&!t[r](n[r]))return!1;return!0});n.a=u},function(t,n,r){"use strict";function e(){var t=(new Date).getTime();return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(n){var r=(t+16*Math.random())%16|0;return t=Math.floor(t/16),("x"==n?r:3&r|8).toString(16)})}n.__esModule=!0,n.default=e},function(t,n,r){"use strict";var e=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,n){t.__proto__=n}||function(t,n){for(var r in n)n.hasOwnProperty(r)&&(t[r]=n[r])};return function(n,r){function e(){this.constructor=n}t(n,r),n.prototype=null===r?Object.create(r):(e.prototype=r.prototype,new e)}}();n.__esModule=!0;var a=r(121),u=r(63),c=function(){function t(t,n,r){this.key=a.default(),this.type=t,this.element=n,this.children=r}return t}();n.Node=c;var i=function(t){function n(n,r,e,a,u,c){var i=t.call(this,e,c,u)||this;return i.start=n,i.end=r,i.text=a,i.children=u,i}return e(n,t),n.prototype.boundaries=function(){return{lower:this.start,upper:this.end}},n.prototype.isParentOf=function(t){return this.start<=t.start&&this.end>=t.end},n.prototype.setChildren=function(t){return new n(this.start,this.end,this.type,this.text,t,this.element)},n.slice=function(t,r,e,a){return new n(r,e,t.type,a.slice(r,e),t.children,t.element)},n}(c);n.SpanNode=i;var o=function(t){function n(n,r,e){var a={type:u.NODE_TYPES.span,start:n,end:r,text:e};return t.call(this,n,r,u.NODE_TYPES.span,e,[],a)||this}return e(n,t),n}(i);n.TextNode=o;var s=function(t){function n(n,r,e){return void 0===e&&(e=[]),t.call(this,n,r,e)||this}return e(n,t),n}(c);n.BlockNode=s;var f=function(t){function n(n,r){return t.call(this,u.NODE_TYPES.listItem,n,r)||this}return e(n,t),n}(s);n.ListItemBlockNode=f;var l=function(t){function n(n,r){return t.call(this,u.NODE_TYPES.oListItem,n,r)||this}return e(n,t),n}(s);n.OrderedListItemBlockNode=l;var v=function(t){function n(n,r){return t.call(this,u.NODE_TYPES.oList,n,r)||this}return e(n,t),n.prototype.addChild=function(t){var r=this.children.concat(t);return new n(this.element,r)},n}(s);n.OrderedListBlockNode=v;var p=function(t){function n(n,r){return t.call(this,u.NODE_TYPES.list,n,r)||this}return e(n,t),n.prototype.addChild=function(t){var r=this.children.concat(t);return new n(this.element,r)},n}(s);n.ListBlockNode=p},function(t,n,r){t.exports=r(124)},function(t,n,r){"use strict";n.__esModule=!0;var e=r(125),a=r(64),u=r(327);t.exports={asText:e.default,asTree:a.default.fromRichText,serialize:u.default,Elements:a.default.NODE_TYPES}},function(t,n,r){"use strict";function e(t,n){var r="string"==typeof n?n:" ";return t.map(function(t){return t.text}).join(r)}n.__esModule=!0,n.default=e},function(t,n,r){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var e=r(127);r.d(n,"F",function(){return e.a});var a=r(128);r.d(n,"T",function(){return a.a});var u=r(129);r.d(n,"__",function(){return u.a});var c=r(28);r.d(n,"add",function(){return c.a});var i=r(130);r.d(n,"addIndex",function(){return i.a});var o=r(65);r.d(n,"adjust",function(){return o.a});var s=r(131);r.d(n,"all",function(){return s.a});var f=r(133);r.d(n,"allPass",function(){return f.a});var l=r(17);r.d(n,"always",function(){return l.a});var v=r(69);r.d(n,"and",function(){return v.a});var p=r(70);r.d(n,"any",function(){return p.a});var d=r(135);r.d(n,"anyPass",function(){return d.a});var b=r(45);r.d(n,"ap",function(){return b.a});var O=r(136);r.d(n,"aperture",function(){return O.a});var j=r(139);r.d(n,"append",function(){return j.a});var h=r(72);r.d(n,"apply",function(){return h.a});var y=r(140);r.d(n,"applySpec",function(){return y.a});var g=r(141);r.d(n,"applyTo",function(){return g.a});var m=r(142);r.d(n,"ascend",function(){return m.a});var x=r(32);r.d(n,"assoc",function(){return x.a});var w=r(74);r.d(n,"assocPath",function(){return w.a});var E=r(143);r.d(n,"binary",function(){return E.a});var _=r(67);r.d(n,"bind",function(){return _.a});var S=r(144);r.d(n,"both",function(){return S.a});var N=r(145);r.d(n,"call",function(){return N.a});var T=r(48);r.d(n,"chain",function(){return T.a});var P=r(149);r.d(n,"clamp",function(){return P.a});var k=r(150);r.d(n,"clone",function(){return k.a});var A=r(151);r.d(n,"comparator",function(){return A.a});var D=r(152);r.d(n,"complement",function(){return D.a});var I=r(50);r.d(n,"compose",function(){return I.a});var L=r(82);r.d(n,"composeK",function(){return L.a});var B=r(154);r.d(n,"composeP",function(){return B.a});var Y=r(52);r.d(n,"concat",function(){return Y.a});var M=r(163);r.d(n,"cond",function(){return M.a});var R=r(164);r.d(n,"construct",function(){return R.a});var q=r(87);r.d(n,"constructN",function(){return q.a});var C=r(165);r.d(n,"contains",function(){return C.a});var W=r(88);r.d(n,"converge",function(){return W.a});var F=r(166);r.d(n,"countBy",function(){return F.a});var U=r(47);r.d(n,"curry",function(){return U.a});var z=r(5);r.d(n,"curryN",function(){return z.a});var K=r(168);r.d(n,"dec",function(){return K.a});var V=r(89);r.d(n,"defaultTo",function(){return V.a});var H=r(169);r.d(n,"descend",function(){return H.a});var $=r(90);r.d(n,"difference",function(){return $.a});var J=r(91);r.d(n,"differenceWith",function(){return J.a});var X=r(92);r.d(n,"dissoc",function(){return X.a});var Z=r(170);r.d(n,"dissocPath",function(){return Z.a});var G=r(171);r.d(n,"divide",function(){return G.a});var Q=r(94);r.d(n,"drop",function(){return Q.a});var tt=r(173);r.d(n,"dropLast",function(){return tt.a});var nt=r(177);r.d(n,"dropLastWhile",function(){return nt.a});var rt=r(180);r.d(n,"dropRepeats",function(){return rt.a});var et=r(96);r.d(n,"dropRepeatsWith",function(){return et.a});var at=r(181);r.d(n,"dropWhile",function(){return at.a});var ut=r(183);r.d(n,"either",function(){return ut.a});var ct=r(99);r.d(n,"empty",function(){return ct.a});var it=r(184);r.d(n,"endsWith",function(){return it.a});var ot=r(185);r.d(n,"eqBy",function(){return ot.a});var st=r(186);r.d(n,"eqProps",function(){return st.a});var ft=r(9);r.d(n,"equals",function(){return ft.a});var lt=r(187);r.d(n,"evolve",function(){return lt.a});var vt=r(53);r.d(n,"filter",function(){return vt.a});var pt=r(188);r.d(n,"find",function(){return pt.a});var dt=r(190);r.d(n,"findIndex",function(){return dt.a});var bt=r(192);r.d(n,"findLast",function(){return bt.a});var Ot=r(194);r.d(n,"findLastIndex",function(){return Ot.a});var jt=r(196);r.d(n,"flatten",function(){return jt.a});var ht=r(40);r.d(n,"flip",function(){return ht.a});var yt=r(197);r.d(n,"forEach",function(){return yt.a});var gt=r(198);r.d(n,"forEachObjIndexed",function(){return gt.a});var mt=r(199);r.d(n,"fromPairs",function(){return mt.a});var xt=r(200);r.d(n,"groupBy",function(){return xt.a});var wt=r(201);r.d(n,"groupWith",function(){return wt.a});var Et=r(202);r.d(n,"gt",function(){return Et.a});var _t=r(203);r.d(n,"gte",function(){return _t.a});var St=r(204);r.d(n,"has",function(){return St.a});var Nt=r(205);r.d(n,"hasIn",function(){return Nt.a});var Tt=r(206);r.d(n,"head",function(){return Tt.a});var Pt=r(85);r.d(n,"identical",function(){return Pt.a});var kt=r(58);r.d(n,"identity",function(){return kt.a});var At=r(207);r.d(n,"ifElse",function(){return At.a});var Dt=r(208);r.d(n,"inc",function(){return Dt.a});var It=r(209);r.d(n,"indexBy",function(){return It.a});var Lt=r(210);r.d(n,"indexOf",function(){return Lt.a});var Bt=r(211);r.d(n,"init",function(){return Bt.a});var Yt=r(212);r.d(n,"innerJoin",function(){return Yt.a});var Mt=r(213);r.d(n,"insert",function(){return Mt.a});var Rt=r(214);r.d(n,"insertAll",function(){return Rt.a});var qt=r(215);r.d(n,"intersection",function(){return qt.a});var Ct=r(217);r.d(n,"intersperse",function(){return Ct.a});var Wt=r(218);r.d(n,"into",function(){return Wt.a});var Ft=r(221);r.d(n,"invert",function(){return Ft.a});var Ut=r(222);r.d(n,"invertObj",function(){return Ut.a});var zt=r(26);r.d(n,"invoker",function(){return zt.a});var Kt=r(103);r.d(n,"is",function(){return Kt.a});var Vt=r(223);r.d(n,"isEmpty",function(){return Vt.a});var Ht=r(75);r.d(n,"isNil",function(){return Ht.a});var $t=r(224);r.d(n,"join",function(){return $t.a});var Jt=r(104);r.d(n,"juxt",function(){return Jt.a});var Xt=r(13);r.d(n,"keys",function(){return Xt.a});var Zt=r(225);r.d(n,"keysIn",function(){return Zt.a});var Gt=r(97);r.d(n,"last",function(){return Gt.a});var Qt=r(226);r.d(n,"lastIndexOf",function(){return Qt.a});var tn=r(105);r.d(n,"length",function(){return tn.a});var nn=r(41);r.d(n,"lens",function(){return nn.a});var rn=r(227);r.d(n,"lensIndex",function(){return rn.a});var en=r(228);r.d(n,"lensPath",function(){return en.a});var an=r(229);r.d(n,"lensProp",function(){return an.a});var un=r(35);r.d(n,"lift",function(){return un.a});var cn=r(76);r.d(n,"liftN",function(){return cn.a});var on=r(230);r.d(n,"lt",function(){return on.a});var sn=r(231);r.d(n,"lte",function(){return sn.a});var fn=r(7);r.d(n,"map",function(){return fn.a});var ln=r(232);r.d(n,"mapAccum",function(){return ln.a});var vn=r(233);r.d(n,"mapAccumRight",function(){return vn.a});var pn=r(234);r.d(n,"mapObjIndexed",function(){return pn.a});var dn=r(235);r.d(n,"match",function(){return dn.a});var bn=r(236);r.d(n,"mathMod",function(){return bn.a});var On=r(18);r.d(n,"max",function(){return On.a});var jn=r(237);r.d(n,"maxBy",function(){return jn.a});var hn=r(107);r.d(n,"mean",function(){return hn.a});var yn=r(238);r.d(n,"median",function(){return yn.a});var gn=r(239);r.d(n,"memoize",function(){return gn.a});var mn=r(109);r.d(n,"memoizeWith",function(){return mn.a});var xn=r(240);r.d(n,"merge",function(){return xn.a});var wn=r(241);r.d(n,"mergeAll",function(){return wn.a});var En=r(242);r.d(n,"mergeDeepLeft",function(){return En.a});var _n=r(243);r.d(n,"mergeDeepRight",function(){return _n.a});var Sn=r(244);r.d(n,"mergeDeepWith",function(){return Sn.a});var Nn=r(42);r.d(n,"mergeDeepWithKey",function(){return Nn.a});var Tn=r(245);r.d(n,"mergeWith",function(){return Tn.a});var Pn=r(62);r.d(n,"mergeWithKey",function(){return Pn.a});var kn=r(246);r.d(n,"min",function(){return kn.a});var An=r(247);r.d(n,"minBy",function(){return An.a});var Dn=r(248);r.d(n,"modulo",function(){return Dn.a});var In=r(110);r.d(n,"multiply",function(){return In.a});var Ln=r(33);r.d(n,"nAry",function(){return Ln.a});var Bn=r(249);r.d(n,"negate",function(){return Bn.a});var Yn=r(250);r.d(n,"none",function(){return Yn.a});var Mn=r(80);r.d(n,"not",function(){return Mn.a});var Rn=r(25);r.d(n,"nth",function(){return Rn.a});var qn=r(251);r.d(n,"nthArg",function(){return qn.a});var Cn=r(252);r.d(n,"o",function(){return Cn.a});var Wn=r(102);r.d(n,"objOf",function(){return Wn.a});var Fn=r(253);r.d(n,"of",function(){return Fn.a});var Un=r(255);r.d(n,"omit",function(){return Un.a});var zn=r(256);r.d(n,"once",function(){return zn.a});var Kn=r(98);r.d(n,"or",function(){return Kn.a});var Vn=r(111);r.d(n,"over",function(){return Vn.a});var Hn=r(257);r.d(n,"pair",function(){return Hn.a});var $n=r(258);r.d(n,"partial",function(){return $n.a});var Jn=r(259);r.d(n,"partialRight",function(){return Jn.a});var Xn=r(260);r.d(n,"partition",function(){return Xn.a});var Zn=r(19);r.d(n,"path",function(){return Zn.a});var Gn=r(261);r.d(n,"pathEq",function(){return Gn.a});var Qn=r(262);r.d(n,"pathOr",function(){return Qn.a});var tr=r(263);r.d(n,"pathSatisfies",function(){return tr.a});var nr=r(264);r.d(n,"pick",function(){return nr.a});var rr=r(113);r.d(n,"pickAll",function(){return rr.a});var er=r(265);r.d(n,"pickBy",function(){return er.a});var ar=r(81);r.d(n,"pipe",function(){return ar.a});var ur=r(266);r.d(n,"pipeK",function(){return ur.a});var cr=r(83);r.d(n,"pipeP",function(){return cr.a});var ir=r(21);r.d(n,"pluck",function(){return ir.a});var or=r(114);r.d(n,"prepend",function(){return or.a});var sr=r(267);r.d(n,"product",function(){return sr.a});var fr=r(268);r.d(n,"project",function(){return fr.a});var lr=r(44);r.d(n,"prop",function(){return lr.a});var vr=r(269);r.d(n,"propEq",function(){return vr.a});var pr=r(270);r.d(n,"propIs",function(){return pr.a});var dr=r(271);r.d(n,"propOr",function(){return dr.a});var br=r(272);r.d(n,"propSatisfies",function(){return br.a});var Or=r(273);r.d(n,"props",function(){return Or.a});var jr=r(274);r.d(n,"range",function(){return jr.a});var hr=r(14);r.d(n,"reduce",function(){return hr.a});var yr=r(39);r.d(n,"reduceBy",function(){return yr.a});var gr=r(116);r.d(n,"reduceRight",function(){return gr.a});var mr=r(275);r.d(n,"reduceWhile",function(){return mr.a});var xr=r(276);r.d(n,"reduced",function(){return xr.a});var wr=r(38);r.d(n,"reject",function(){return wr.a});var Er=r(93);r.d(n,"remove",function(){return Er.a});var _r=r(277);r.d(n,"repeat",function(){return _r.a});var Sr=r(278);r.d(n,"replace",function(){return Sr.a});var Nr=r(36);r.d(n,"reverse",function(){return Nr.a});var Tr=r(279);r.d(n,"scan",function(){return Tr.a});var Pr=r(118);r.d(n,"sequence",function(){return Pr.a});var kr=r(280);r.d(n,"set",function(){return kr.a});var Ar=r(11);r.d(n,"slice",function(){return Ar.a});var Dr=r(281);r.d(n,"sort",function(){return Dr.a});var Ir=r(282);r.d(n,"sortBy",function(){return Ir.a});var Lr=r(283);r.d(n,"sortWith",function(){return Lr.a});var Br=r(284);r.d(n,"split",function(){return Br.a});var Yr=r(285);r.d(n,"splitAt",function(){return Yr.a});var Mr=r(286);r.d(n,"splitEvery",function(){return Mr.a});var Rr=r(287);r.d(n,"splitWhen",function(){return Rr.a});var qr=r(288);r.d(n,"startsWith",function(){return qr.a});var Cr=r(289);r.d(n,"subtract",function(){return Cr.a});var Wr=r(108);r.d(n,"sum",function(){return Wr.a});var Fr=r(290);r.d(n,"symmetricDifference",function(){return Fr.a});var Ur=r(291);r.d(n,"symmetricDifferenceWith",function(){return Ur.a});var zr=r(51);r.d(n,"tail",function(){return zr.a});var Kr=r(57);r.d(n,"take",function(){return Kr.a});var Vr=r(100);r.d(n,"takeLast",function(){return Vr.a});var Hr=r(292);r.d(n,"takeLastWhile",function(){return Hr.a});var $r=r(293);r.d(n,"takeWhile",function(){return $r.a});var Jr=r(295);r.d(n,"tap",function(){return Jr.a});var Xr=r(297);r.d(n,"test",function(){return Xr.a});var Zr=r(117);r.d(n,"times",function(){return Zr.a});var Gr=r(299);r.d(n,"toLower",function(){return Gr.a});var Qr=r(300);r.d(n,"toPairs",function(){return Qr.a});var te=r(301);r.d(n,"toPairsIn",function(){return te.a});var ne=r(24);r.d(n,"toString",function(){return ne.a});var re=r(302);r.d(n,"toUpper",function(){return re.a});var ee=r(303);r.d(n,"transduce",function(){return ee.a});var ae=r(304);r.d(n,"transpose",function(){return ae.a});var ue=r(305);r.d(n,"traverse",function(){return ue.a});var ce=r(306);r.d(n,"trim",function(){return ce.a});var ie=r(307);r.d(n,"tryCatch",function(){return ie.a});var oe=r(49);r.d(n,"type",function(){return oe.a});var se=r(308);r.d(n,"unapply",function(){return se.a});var fe=r(309);r.d(n,"unary",function(){return fe.a});var le=r(310);r.d(n,"uncurryN",function(){return le.a});var ve=r(311);r.d(n,"unfold",function(){return ve.a});var pe=r(312);r.d(n,"union",function(){return pe.a});var de=r(313);r.d(n,"unionWith",function(){return de.a});var be=r(60);r.d(n,"uniq",function(){return be.a});var Oe=r(101);r.d(n,"uniqBy",function(){return Oe.a});var je=r(119);r.d(n,"uniqWith",function(){return je.a});var he=r(314);r.d(n,"unless",function(){return he.a});var ye=r(315);r.d(n,"unnest",function(){return ye.a});var ge=r(316);r.d(n,"until",function(){return ge.a});var me=r(56);r.d(n,"update",function(){return me.a});var xe=r(115);r.d(n,"useWith",function(){return xe.a});var we=r(73);r.d(n,"values",function(){return we.a});var Ee=r(317);r.d(n,"valuesIn",function(){return Ee.a});var _e=r(318);r.d(n,"view",function(){return _e.a});var Se=r(319);r.d(n,"when",function(){return Se.a});var Ne=r(120);r.d(n,"where",function(){return Ne.a});var Te=r(320);r.d(n,"whereEq",function(){return Te.a});var Pe=r(321);r.d(n,"without",function(){return Pe.a});var ke=r(322);r.d(n,"xprod",function(){return ke.a});var Ae=r(323);r.d(n,"zip",function(){return Ae.a});var De=r(324);r.d(n,"zipObj",function(){return De.a});var Ie=r(325);r.d(n,"zipWith",function(){return Ie.a})},function(t,n,r){"use strict";var e=r(17),a=Object(e.a)(!1);n.a=a},function(t,n,r){"use strict";var e=r(17),a=Object(e.a)(!0);n.a=a},function(t,n,r){"use strict";n.a={"@@functional/placeholder":!0}},function(t,n,r){"use strict";var e=r(10),a=r(1),u=r(5),c=Object(a.a)(function(t){return Object(u.a)(t.length,function(){var n=0,r=arguments[0],a=arguments[arguments.length-1],u=Array.prototype.slice.call(arguments,0);return u[0]=function(){var t=r.apply(this,Object(e.a)(arguments,[n,a]));return n+=1,t},t.apply(this,u)})});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(132),c=Object(e.a)(Object(a.a)(["all"],u.a,function(t,n){for(var r=0;r<n.length;){if(!t(n[r]))return!1;r+=1}return!0}));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(16),u=r(4),c=function(){function t(t,n){this.xf=n,this.f=t,this.all=!0}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=function(t){return this.all&&(t=this.xf["@@transducer/step"](t,!0)),this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){return this.f(n)||(this.all=!1,t=Object(a.a)(this.xf["@@transducer/step"](t,!1))),t},t}(),i=Object(e.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(1),a=r(5),u=r(18),c=r(21),i=r(14),o=Object(e.a)(function(t){return Object(a.a)(Object(i.a)(u.a,0,Object(c.a)("length",t)),function(){for(var n=0,r=t.length;n<r;){if(!t[n].apply(this,arguments))return!1;n+=1}return!0})});n.a=o},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.f=t}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=a.a.result,t.prototype["@@transducer/step"]=function(t,n){return this.xf["@@transducer/step"](t,this.f(n))},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(1),a=r(5),u=r(18),c=r(21),i=r(14),o=Object(e.a)(function(t){return Object(a.a)(Object(i.a)(u.a,0,Object(c.a)("length",t)),function(){for(var n=0,r=t.length;n<r;){if(t[n].apply(this,arguments))return!0;n+=1}return!1})});n.a=o},function(t,n,r){"use strict";var e=r(137),a=r(0),u=r(3),c=r(138),i=Object(a.a)(Object(u.a)([],c.a,e.a));n.a=i},function(t,n,r){"use strict";function e(t,n){for(var r=0,e=n.length-(t-1),a=new Array(e>=0?e:0);r<e;)a[r]=Array.prototype.slice.call(n,r,r+t),r+=1;return a}n.a=e},function(t,n,r){"use strict";var e=r(10),a=r(0),u=r(4),c=function(){function t(t,n){this.xf=n,this.pos=0,this.full=!1,this.acc=new Array(t)}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=function(t){return this.acc=null,this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){return this.store(n),this.full?this.xf["@@transducer/step"](t,this.getCopy()):t},t.prototype.store=function(t){this.acc[this.pos]=t,this.pos+=1,this.pos===this.acc.length&&(this.pos=0,this.full=!0)},t.prototype.getCopy=function(){return Object(e.a)(Array.prototype.slice.call(this.acc,this.pos),Array.prototype.slice.call(this.acc,0,this.pos))},t}(),i=Object(a.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(10),a=r(0),u=Object(a.a)(function(t,n){return Object(e.a)(n,[t])});n.a=u},function(t,n,r){"use strict";var e=r(1),a=r(72),u=r(5),c=r(7),i=r(18),o=r(21),s=r(14),f=r(73),l=Object(e.a)(function t(n){return n=Object(c.a)(function(n){return"function"==typeof n?n:t(n)},n),Object(u.a)(Object(s.a)(i.a,0,Object(o.a)("length",Object(f.a)(n))),function(){var t=arguments;return Object(c.a)(function(n){return Object(a.a)(n,t)},n)})});n.a=l},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return n(t)});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){var e=t(n),a=t(r);return e<a?-1:e>a?1:0});n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(33),u=Object(e.a)(function(t){return Object(a.a)(2,t)});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(34),u=r(69),c=r(35),i=Object(e.a)(function(t,n){return Object(a.a)(t)?function(){return t.apply(this,arguments)&&n.apply(this,arguments)}:Object(c.a)(u.a)(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(47),a=Object(e.a)(function(t){return t.apply(this,Array.prototype.slice.call(arguments,1))});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(147),u=r(7),c=Object(e.a)(function(t,n){return Object(u.a)(t,Object(a.a)(n))});n.a=c},function(t,n,r){"use strict";var e=r(148),a=r(31),u=r(8),c=r(4),i=function(t){return{"@@transducer/init":c.a.init,"@@transducer/result":function(n){return t["@@transducer/result"](n)},"@@transducer/step":function(n,r){var a=t["@@transducer/step"](n,r);return a["@@transducer/reduced"]?Object(e.a)(a):a}}},o=function(t){var n=i(t);return{"@@transducer/init":c.a.init,"@@transducer/result":function(t){return n["@@transducer/result"](t)},"@@transducer/step":function(t,r){return Object(a.a)(r)?Object(u.a)(n,t,r):Object(u.a)(n,t,[r])}}};n.a=o},function(t,n,r){"use strict";function e(t){return{"@@transducer/value":t,"@@transducer/reduced":!0}}n.a=e},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){if(t>n)throw new Error("min must not be greater than max in clamp(min, max, value)");return r<t?t:r>n?n:r});n.a=a},function(t,n,r){"use strict";var e=r(78),a=r(1),u=Object(a.a)(function(t){return null!=t&&"function"==typeof t.clone?t.clone():Object(e.a)(t,[],[],!0)});n.a=u},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){return function(n,r){return t(n,r)?-1:t(r,n)?1:0}});n.a=a},function(t,n,r){"use strict";var e=r(35),a=r(80),u=Object(e.a)(a.a);n.a=u},function(t,n,r){"use strict";function e(t,n){return function(){return n.call(this,t.apply(this,arguments))}}n.a=e},function(t,n,r){"use strict";function e(){if(0===arguments.length)throw new Error("composeP requires at least one argument");return a.a.apply(this,Object(u.a)(arguments))}n.a=e;var a=r(83),u=r(36)},function(t,n,r){"use strict";function e(t,n){return function(){var r=this;return t.apply(r,arguments).then(function(t){return n.call(r,t)})}}n.a=e},function(t,n,r){"use strict";function e(t,n){var r=function(r){var u=n.concat([t]);return Object(a.a)(r,u)?"<Circular>":e(r,u)},f=function(t,n){return Object(u.a)(function(n){return Object(c.a)(n)+": "+r(t[n])},n.slice().sort())};switch(Object.prototype.toString.call(t)){case"[object Arguments]":return"(function() { return arguments; }("+Object(u.a)(r,t).join(", ")+"))";case"[object Array]":return"["+Object(u.a)(r,t).concat(f(t,Object(s.a)(function(t){return/^\d+$/.test(t)},Object(o.a)(t)))).join(", ")+"]";case"[object Boolean]":return"object"==typeof t?"new Boolean("+r(t.valueOf())+")":t.toString();case"[object Date]":return"new Date("+(isNaN(t.valueOf())?r(NaN):Object(c.a)(Object(i.a)(t)))+")";case"[object Null]":return"null";case"[object Number]":return"object"==typeof t?"new Number("+r(t.valueOf())+")":1/t==-1/0?"-0":t.toString(10);case"[object String]":return"object"==typeof t?"new String("+r(t.valueOf())+")":Object(c.a)(t);case"[object Undefined]":return"undefined";default:if("function"==typeof t.toString){var l=t.toString();if("[object Object]"!==l)return l}return"{"+f(t,Object(o.a)(t)).join(", ")+"}"}}n.a=e;var a=r(20),u=r(30),c=r(160),i=r(161),o=r(13),s=r(38)},function(t,n,r){"use strict";function e(t,n,r,e){function i(t,n){return a(t,n,r.slice(),e.slice())}var o=Object(u.a)(t),s=Object(u.a)(n);return!Object(c.a)(function(t,n){return!Object(c.a)(i,n,t)},s,o)}function a(t,n,r,u){if(Object(s.a)(t,n))return!0;var c=Object(l.a)(t);if(c!==Object(l.a)(n))return!1;if(null==t||null==n)return!1;if("function"==typeof t["fantasy-land/equals"]||"function"==typeof n["fantasy-land/equals"])return"function"==typeof t["fantasy-land/equals"]&&t["fantasy-land/equals"](n)&&"function"==typeof n["fantasy-land/equals"]&&n["fantasy-land/equals"](t);if("function"==typeof t.equals||"function"==typeof n.equals)return"function"==typeof t.equals&&t.equals(n)&&"function"==typeof n.equals&&n.equals(t);switch(c){case"Arguments":case"Array":case"Object":if("function"==typeof t.constructor&&"Promise"===Object(i.a)(t.constructor))return t===n;break;case"Boolean":case"Number":case"String":if(typeof t!=typeof n||!Object(s.a)(t.valueOf(),n.valueOf()))return!1;break;case"Date":if(!Object(s.a)(t.valueOf(),n.valueOf()))return!1;break;case"Error":return t.name===n.name&&t.message===n.message;case"RegExp":if(t.source!==n.source||t.global!==n.global||t.ignoreCase!==n.ignoreCase||t.multiline!==n.multiline||t.sticky!==n.sticky||t.unicode!==n.unicode)return!1}for(var v=r.length-1;v>=0;){if(r[v]===t)return u[v]===n;v-=1}switch(c){case"Map":return t.size===n.size&&e(t.entries(),n.entries(),r.concat([t]),u.concat([n]));case"Set":return t.size===n.size&&e(t.values(),n.values(),r.concat([t]),u.concat([n]));case"Arguments":case"Array":case"Object":case"Boolean":case"Number":case"String":case"Date":case"Error":case"RegExp":case"Int8Array":case"Uint8Array":case"Uint8ClampedArray":case"Int16Array":case"Uint16Array":case"Int32Array":case"Uint32Array":case"Float32Array":case"Float64Array":case"ArrayBuffer":break;default:return!1}var p=Object(f.a)(t);if(p.length!==Object(f.a)(n).length)return!1;var d=r.concat([t]),b=u.concat([n]);for(v=p.length-1;v>=0;){var O=p[v];if(!Object(o.a)(O,n)||!a(n[O],t[O],d,b))return!1;v-=1}return!0}n.a=a;var u=r(158),c=r(37),i=r(159),o=r(6),s=r(85),f=r(13),l=r(49)},function(t,n,r){"use strict";function e(t){for(var n,r=[];!(n=t.next()).done;)r.push(n.value);return r}n.a=e},function(t,n,r){"use strict";function e(t){var n=String(t).match(/^function (\w*)/);return null==n?"":n[1]}n.a=e},function(t,n,r){"use strict";function e(t){return'"'+t.replace(/\\/g,"\\\\").replace(/[\b]/g,"\\b").replace(/\f/g,"\\f").replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\t/g,"\\t").replace(/\v/g,"\\v").replace(/\0/g,"\\0").replace(/"/g,'\\"')+'"'}n.a=e},function(t,n,r){"use strict";var e=function(t){return(t<10?"0":"")+t},a="function"==typeof Date.prototype.toISOString?function(t){return t.toISOString()}:function(t){return t.getUTCFullYear()+"-"+e(t.getUTCMonth()+1)+"-"+e(t.getUTCDate())+"T"+e(t.getUTCHours())+":"+e(t.getUTCMinutes())+":"+e(t.getUTCSeconds())+"."+(t.getUTCMilliseconds()/1e3).toFixed(3).slice(2,5)+"Z"};n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.f=t}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=a.a.result,t.prototype["@@transducer/step"]=function(t,n){return this.f(n)?this.xf["@@transducer/step"](t,n):t},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(12),a=r(1),u=r(7),c=r(18),i=r(14),o=Object(a.a)(function(t){var n=Object(i.a)(c.a,0,Object(u.a)(function(t){return t[0].length},t));return Object(e.a)(n,function(){for(var n=0;n<t.length;){if(t[n][0].apply(this,arguments))return t[n][1].apply(this,arguments);n+=1}})});n.a=o},function(t,n,r){"use strict";var e=r(1),a=r(87),u=Object(e.a)(function(t){return Object(a.a)(t.length,t)});n.a=u},function(t,n,r){"use strict";var e=r(20),a=r(0),u=Object(a.a)(e.a);n.a=u},function(t,n,r){"use strict";var e=r(39),a=Object(e.a)(function(t,n){return t+1},0);n.a=a},function(t,n,r){"use strict";var e=r(29),a=r(6),u=r(4),c=function(){function t(t,n,r,e){this.valueFn=t,this.valueAcc=n,this.keyFn=r,this.xf=e,this.inputs={}}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=function(t){var n;for(n in this.inputs)if(Object(a.a)(n,this.inputs)&&(t=this.xf["@@transducer/step"](t,this.inputs[n]),t["@@transducer/reduced"])){t=t["@@transducer/value"];break}return this.inputs=null,this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){var r=this.keyFn(n);return this.inputs[r]=this.inputs[r]||[r,this.valueAcc],this.inputs[r][1]=this.valueFn(this.inputs[r][1],n),t},t}(),i=Object(e.a)(4,[],function(t,n,r,e){return new c(t,n,r,e)});n.a=i},function(t,n,r){"use strict";var e=r(28),a=Object(e.a)(-1);n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){var e=t(n),a=t(r);return e>a?-1:e<a?1:0});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(46),u=r(32),c=r(92),i=r(93),o=r(56),s=Object(e.a)(function t(n,r){switch(n.length){case 0:return r;case 1:return Object(a.a)(n[0])?Object(i.a)(n[0],1,r):Object(c.a)(n[0],r);default:var e=n[0],s=Array.prototype.slice.call(n,1);return null==r[e]?r:Object(a.a)(n[0])?Object(o.a)(e,t(s,r[e]),r):Object(u.a)(e,t(s,r[e]),r)}});n.a=s},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t/n});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.n=t}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=a.a.result,t.prototype["@@transducer/step"]=function(t,n){return this.n>0?(this.n-=1,t):this.xf["@@transducer/step"](t,n)},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(174),c=r(176),i=Object(e.a)(Object(a.a)([],c.a,u.a));n.a=i},function(t,n,r){"use strict";function e(t,n){return Object(a.a)(t<n.length?n.length-t:0,n)}n.a=e;var a=r(57)},function(t,n,r){"use strict";var e=r(0),a=r(16),u=r(4),c=function(){function t(t,n){this.xf=n,this.n=t,this.i=0}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=u.a.result,t.prototype["@@transducer/step"]=function(t,n){this.i+=1;var r=0===this.n?t:this.xf["@@transducer/step"](t,n);return this.n>=0&&this.i>=this.n?Object(a.a)(r):r},t}(),i=Object(e.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.pos=0,this.full=!1,this.acc=new Array(t)}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=function(t){return this.acc=null,this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){return this.full&&(t=this.xf["@@transducer/step"](t,this.acc[this.pos])),this.store(n),t},t.prototype.store=function(t){this.acc[this.pos]=t,this.pos+=1,this.pos===this.acc.length&&(this.pos=0,this.full=!0)},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(178),c=r(179),i=Object(e.a)(Object(a.a)([],c.a,u.a));n.a=i},function(t,n,r){"use strict";function e(t,n){for(var r=n.length-1;r>=0&&t(n[r]);)r-=1;return Object(a.a)(0,r+1,n)}n.a=e;var a=r(11)},function(t,n,r){"use strict";var e=r(0),a=r(8),u=r(4),c=function(){function t(t,n){this.f=t,this.retained=[],this.xf=n}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=function(t){return this.retained=null,this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){return this.f(n)?this.retain(t,n):this.flush(t,n)},t.prototype.flush=function(t,n){return t=Object(a.a)(this.xf["@@transducer/step"],t,this.retained),this.retained=[],this.xf["@@transducer/step"](t,n)},t.prototype.retain=function(t,n){return this.retained.push(n),t},t}(),i=Object(e.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(1),a=r(3),u=r(95),c=r(96),i=r(9),o=Object(e.a)(Object(a.a)([],Object(u.a)(i.a),Object(c.a)(i.a)));n.a=o},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(182),c=r(11),i=Object(e.a)(Object(a.a)(["dropWhile"],u.a,function(t,n){for(var r=0,e=n.length;r<e&&t(n[r]);)r+=1;return Object(c.a)(r,1/0,n)}));n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.f=t}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=a.a.result,t.prototype["@@transducer/step"]=function(t,n){if(this.f){if(this.f(n))return t;this.f=null}return this.xf["@@transducer/step"](t,n)},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(34),u=r(35),c=r(98),i=Object(e.a)(function(t,n){return Object(a.a)(t)?function(){return t.apply(this,arguments)||n.apply(this,arguments)}:Object(u.a)(c.a)(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(9),u=r(100),c=Object(e.a)(function(t,n){return Object(a.a)(Object(u.a)(t.length,n),t)});n.a=c},function(t,n,r){"use strict";var e=r(2),a=r(9),u=Object(e.a)(function(t,n,r){return Object(a.a)(t(n),t(r))});n.a=u},function(t,n,r){"use strict";var e=r(2),a=r(9),u=Object(e.a)(function(t,n,r){return Object(a.a)(n[t],r[t])});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function t(n,r){var e,a,u,c={};for(a in r)e=n[a],u=typeof e,c[a]="function"===u?e(r[a]):e&&"object"===u?t(e,r[a]):r[a];return c});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(189),c=Object(e.a)(Object(a.a)(["find"],u.a,function(t,n){for(var r=0,e=n.length;r<e;){if(t(n[r]))return n[r];r+=1}}));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(16),u=r(4),c=function(){function t(t,n){this.xf=n,this.f=t,this.found=!1}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=function(t){return this.found||(t=this.xf["@@transducer/step"](t,void 0)),this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){return this.f(n)&&(this.found=!0,t=Object(a.a)(this.xf["@@transducer/step"](t,n))),t},t}(),i=Object(e.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(191),c=Object(e.a)(Object(a.a)([],u.a,function(t,n){for(var r=0,e=n.length;r<e;){if(t(n[r]))return r;r+=1}return-1}));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(16),u=r(4),c=function(){function t(t,n){this.xf=n,this.f=t,this.idx=-1,this.found=!1}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=function(t){return this.found||(t=this.xf["@@transducer/step"](t,-1)),this.xf["@@transducer/result"](t)},t.prototype["@@transducer/step"]=function(t,n){return this.idx+=1,this.f(n)&&(this.found=!0,t=Object(a.a)(this.xf["@@transducer/step"](t,this.idx))),t},t}(),i=Object(e.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(193),c=Object(e.a)(Object(a.a)([],u.a,function(t,n){for(var r=n.length-1;r>=0;){if(t(n[r]))return n[r];r-=1}}));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.f=t}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=function(t){return this.xf["@@transducer/result"](this.xf["@@transducer/step"](t,this.last))},t.prototype["@@transducer/step"]=function(t,n){return this.f(n)&&(this.last=n),t},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(195),c=Object(e.a)(Object(a.a)([],u.a,function(t,n){for(var r=n.length-1;r>=0;){if(t(n[r]))return r;r-=1}return-1}));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.f=t,this.idx=-1,this.lastIdx=-1}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=function(t){return this.xf["@@transducer/result"](this.xf["@@transducer/step"](t,this.lastIdx))},t.prototype["@@transducer/step"]=function(t,n){return this.idx+=1,this.f(n)&&(this.lastIdx=this.idx),t},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(1),a=r(77),u=Object(e.a)(Object(a.a)(!0));n.a=u},function(t,n,r){"use strict";var e=r(23),a=r(0),u=Object(a.a)(Object(e.a)("forEach",function(t,n){for(var r=n.length,e=0;e<r;)t(n[e]),e+=1;return n}));n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(13),u=Object(e.a)(function(t,n){for(var r=Object(a.a)(n),e=0;e<r.length;){var u=r[e];t(n[u],u,n),e+=1}return n});n.a=u},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){for(var n={},r=0;r<t.length;)n[t[r][0]]=t[r][1],r+=1;return n});n.a=a},function(t,n,r){"use strict";var e=r(23),a=r(0),u=r(39),c=Object(a.a)(Object(e.a)("groupBy",Object(u.a)(function(t,n){return null==t&&(t=[]),t.push(n),t},null)));n.a=c},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r=[],e=0,a=n.length;e<a;){for(var u=e+1;u<a&&t(n[u-1],n[u]);)u+=1;r.push(n.slice(e,u)),e=u}return r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t>n});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t>=n});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(6),u=Object(e.a)(a.a);n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t in n});n.a=a},function(t,n,r){"use strict";var e=r(25),a=Object(e.a)(0);n.a=a},function(t,n,r){"use strict";var e=r(2),a=r(5),u=Object(e.a)(function(t,n,r){return Object(a.a)(Math.max(t.length,n.length,r.length),function(){return t.apply(this,arguments)?n.apply(this,arguments):r.apply(this,arguments)})});n.a=u},function(t,n,r){"use strict";var e=r(28),a=Object(e.a)(1);n.a=a},function(t,n,r){"use strict";var e=r(39),a=Object(e.a)(function(t,n){return n},null);n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(84),u=r(15),c=Object(e.a)(function(t,n){return"function"!=typeof n.indexOf||Object(u.a)(n)?Object(a.a)(n,t,0):n.indexOf(t)});n.a=c},function(t,n,r){"use strict";var e=r(11),a=Object(e.a)(0,-1);n.a=a},function(t,n,r){"use strict";var e=r(37),a=r(2),u=r(54),c=Object(a.a)(function(t,n,r){return Object(u.a)(function(n){return Object(e.a)(t,n,r)},n)});n.a=c},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){t=t<r.length&&t>=0?t:r.length;var e=Array.prototype.slice.call(r,0);return e.splice(t,0,n),e});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return t=t<r.length&&t>=0?t:r.length,[].concat(Array.prototype.slice.call(r,0,t),n,Array.prototype.slice.call(r,t))});n.a=a},function(t,n,r){"use strict";var e=r(20),a=r(0),u=r(54),c=r(40),i=r(60),o=Object(a.a)(function(t,n){var r,a;return t.length>n.length?(r=t,a=n):(r=n,a=t),Object(i.a)(Object(u.a)(Object(c.a)(e.a)(r),a))});n.a=o},function(t,n,r){"use strict";function e(t,n,r){var e,u=typeof t;switch(u){case"string":case"number":return 0===t&&1/t==-1/0?!!r._items["-0"]||(n&&(r._items["-0"]=!0),!1):null!==r._nativeSet?n?(e=r._nativeSet.size,r._nativeSet.add(t),r._nativeSet.size===e):r._nativeSet.has(t):u in r._items?t in r._items[u]||(n&&(r._items[u][t]=!0),!1):(n&&(r._items[u]={},r._items[u][t]=!0),!1);case"boolean":if(u in r._items){var c=t?1:0;return!!r._items[u][c]||(n&&(r._items[u][c]=!0),!1)}return n&&(r._items[u]=t?[!1,!0]:[!0,!1]),!1;case"function":return null!==r._nativeSet?n?(e=r._nativeSet.size,r._nativeSet.add(t),r._nativeSet.size===e):r._nativeSet.has(t):u in r._items?!!Object(a.a)(t,r._items[u])||(n&&r._items[u].push(t),!1):(n&&(r._items[u]=[t]),!1);case"undefined":return!!r._items[u]||(n&&(r._items[u]=!0),!1);case"object":if(null===t)return!!r._items.null||(n&&(r._items.null=!0),!1);default:return u=Object.prototype.toString.call(t),u in r._items?!!Object(a.a)(t,r._items[u])||(n&&r._items[u].push(t),!1):(n&&(r._items[u]=[t]),!1)}}var a=r(20),u=function(){function t(){this._nativeSet="function"==typeof Set?new Set:null,this._items={}}return t.prototype.add=function(t){return!e(t,!0,this)},t.prototype.has=function(t){return e(t,!1,this)},t}();n.a=u},function(t,n,r){"use strict";var e=r(23),a=r(0),u=Object(a.a)(Object(e.a)("intersperse",function(t,n){for(var r=[],e=0,a=n.length;e<a;)e===a-1?r.push(n[e]):r.push(n[e],t),e+=1;return r}));n.a=u},function(t,n,r){"use strict";var e=r(78),a=r(2),u=r(43),c=r(8),i=r(219),o=Object(a.a)(function(t,n,r){return Object(u.a)(t)?Object(c.a)(n(t),t["@@transducer/init"](),r):Object(c.a)(n(Object(i.a)(t)),Object(e.a)(t,[],[],!1),r)});n.a=o},function(t,n,r){"use strict";function e(t){if(Object(i.a)(t))return t;if(Object(c.a)(t))return s;if("string"==typeof t)return f;if("object"==typeof t)return l;throw new Error("Cannot create transformer for "+t)}n.a=e;var a=r(61),u=r(59),c=r(31),i=r(43),o=r(102),s={"@@transducer/init":Array,"@@transducer/step":function(t,n){return t.push(n),t},"@@transducer/result":u.a},f={"@@transducer/init":String,"@@transducer/step":function(t,n){return t+n},"@@transducer/result":u.a},l={"@@transducer/init":Object,"@@transducer/step":function(t,n){return Object(a.a)(t,Object(c.a)(n)?Object(o.a)(n[0],n[1]):n)},"@@transducer/result":u.a}},function(t,n,r){"use strict";function e(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var n=Object(t),r=1,e=arguments.length;r<e;){var u=arguments[r];if(null!=u)for(var c in u)Object(a.a)(c,u)&&(n[c]=u[c]);r+=1}return n}n.a=e;var a=r(6)},function(t,n,r){"use strict";var e=r(1),a=r(6),u=r(13),c=Object(e.a)(function(t){for(var n=Object(u.a)(t),r=n.length,e=0,c={};e<r;){var i=n[e],o=t[i],s=Object(a.a)(o,c)?c[o]:c[o]=[];s[s.length]=i,e+=1}return c});n.a=c},function(t,n,r){"use strict";var e=r(1),a=r(13),u=Object(e.a)(function(t){for(var n=Object(a.a)(t),r=n.length,e=0,u={};e<r;){var c=n[e];u[t[c]]=c,e+=1}return u});n.a=u},function(t,n,r){"use strict";var e=r(1),a=r(99),u=r(9),c=Object(e.a)(function(t){return null!=t&&Object(u.a)(t,Object(a.a)(t))});n.a=c},function(t,n,r){"use strict";var e=r(26),a=Object(e.a)(1,"join");n.a=a},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){var n,r=[];for(n in t)r[r.length]=n;return r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(15),u=r(9),c=Object(e.a)(function(t,n){if("function"!=typeof n.lastIndexOf||Object(a.a)(n)){for(var r=n.length-1;r>=0;){if(Object(u.a)(n[r],t))return r;r-=1}return-1}return n.lastIndexOf(t)});n.a=c},function(t,n,r){"use strict";var e=r(1),a=r(41),u=r(25),c=r(56),i=Object(e.a)(function(t){return Object(a.a)(Object(u.a)(t),Object(c.a)(t))});n.a=i},function(t,n,r){"use strict";var e=r(1),a=r(74),u=r(41),c=r(19),i=Object(e.a)(function(t){return Object(u.a)(Object(c.a)(t),Object(a.a)(t))});n.a=i},function(t,n,r){"use strict";var e=r(1),a=r(32),u=r(41),c=r(44),i=Object(e.a)(function(t){return Object(u.a)(Object(c.a)(t),Object(a.a)(t))});n.a=i},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t<n});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t<=n});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){for(var e=0,a=r.length,u=[],c=[n];e<a;)c=t(c[0],r[e]),u[e]=c[1],e+=1;return[c[0],u]});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){for(var e=r.length-1,a=[],u=[n];e>=0;)u=t(r[e],u[0]),a[e]=u[1],e-=1;return[a,u[0]]});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(8),u=r(13),c=Object(e.a)(function(t,n){return Object(a.a)(function(r,e){return r[e]=t(n[e],e,n),r},{},Object(u.a)(n))});n.a=c},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return n.match(t)||[]});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(46),u=Object(e.a)(function(t,n){return Object(a.a)(t)?!Object(a.a)(n)||n<1?NaN:(t%n+n)%n:NaN});n.a=u},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return t(r)>t(n)?r:n});n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(107),u=Object(e.a)(function(t){var n=t.length;if(0===n)return NaN;var r=2-n%2,e=(n-r)/2;return Object(a.a)(Array.prototype.slice.call(t,0).sort(function(t,n){return t<n?-1:t>n?1:0}).slice(e,e+r))});n.a=u},function(t,n,r){"use strict";var e=r(109),a=r(24),u=Object(e.a)(function(){return Object(a.a)(arguments)});n.a=u},function(t,n,r){"use strict";var e=r(61),a=r(0),u=Object(a.a)(function(t,n){return Object(e.a)({},t,n)});n.a=u},function(t,n,r){"use strict";var e=r(61),a=r(1),u=Object(a.a)(function(t){return e.a.apply(null,[{}].concat(t))});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(42),u=Object(e.a)(function(t,n){return Object(a.a)(function(t,n,r){return n},t,n)});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(42),u=Object(e.a)(function(t,n){return Object(a.a)(function(t,n,r){return r},t,n)});n.a=u},function(t,n,r){"use strict";var e=r(2),a=r(42),u=Object(e.a)(function(t,n,r){return Object(a.a)(function(n,r,e){return t(r,e)},n,r)});n.a=u},function(t,n,r){"use strict";var e=r(2),a=r(62),u=Object(e.a)(function(t,n,r){return Object(a.a)(function(n,r,e){return t(r,e)},n,r)});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return n<t?n:t});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return t(r)<t(n)?r:n});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return t%n});n.a=a},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){return-t});n.a=a},function(t,n,r){"use strict";var e=r(86),a=r(0),u=r(3),c=r(71),i=r(70),o=Object(a.a)(Object(e.a)(Object(u.a)(["any"],c.a,i.a)));n.a=o},function(t,n,r){"use strict";var e=r(1),a=r(5),u=r(25),c=Object(e.a)(function(t){var n=t<0?1:t+1;return Object(a.a)(n,function(){return Object(u.a)(t,arguments)})});n.a=c},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return t(n(r))});n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(254),u=Object(e.a)(a.a);n.a=u},function(t,n,r){"use strict";function e(t){return[t]}n.a=e},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r={},e={},a=0,u=t.length;a<u;)e[t[a]]=1,a+=1;for(var c in n)e.hasOwnProperty(c)||(r[c]=n[c]);return r});n.a=a},function(t,n,r){"use strict";var e=r(12),a=r(1),u=Object(a.a)(function(t){var n,r=!1;return Object(e.a)(t.length,function(){return r?n:(r=!0,n=t.apply(this,arguments))})});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return[t,n]});n.a=a},function(t,n,r){"use strict";var e=r(10),a=r(112),u=Object(a.a)(e.a);n.a=u},function(t,n,r){"use strict";var e=r(10),a=r(112),u=r(40),c=Object(a.a)(Object(u.a)(e.a));n.a=c},function(t,n,r){"use strict";var e=r(53),a=r(104),u=r(38),c=Object(a.a)([e.a,u.a]);n.a=c},function(t,n,r){"use strict";var e=r(2),a=r(9),u=r(19),c=Object(e.a)(function(t,n,r){return Object(a.a)(Object(u.a)(t,r),n)});n.a=c},function(t,n,r){"use strict";var e=r(2),a=r(89),u=r(19),c=Object(e.a)(function(t,n,r){return Object(a.a)(t,Object(u.a)(n,r))});n.a=c},function(t,n,r){"use strict";var e=r(2),a=r(19),u=Object(e.a)(function(t,n,r){return n.length>0&&t(Object(a.a)(n,r))});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r={},e=0;e<t.length;)t[e]in n&&(r[t[e]]=n[t[e]]),e+=1;return r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){var r={};for(var e in n)t(n[e],e,n)&&(r[e]=n[e]);return r});n.a=a},function(t,n,r){"use strict";function e(){if(0===arguments.length)throw new Error("pipeK requires at least one argument");return a.a.apply(this,Object(u.a)(arguments))}n.a=e;var a=r(82),u=r(36)},function(t,n,r){"use strict";var e=r(110),a=r(14),u=Object(a.a)(e.a,1);n.a=u},function(t,n,r){"use strict";var e=r(30),a=r(58),u=r(113),c=r(115),i=Object(c.a)(e.a,[u.a,a.a]);n.a=i},function(t,n,r){"use strict";var e=r(2),a=r(9),u=Object(e.a)(function(t,n,r){return Object(a.a)(n,r[t])});n.a=u},function(t,n,r){"use strict";var e=r(2),a=r(103),u=Object(e.a)(function(t,n,r){return Object(a.a)(t,r[n])});n.a=u},function(t,n,r){"use strict";var e=r(2),a=r(6),u=Object(e.a)(function(t,n,r){return null!=r&&Object(a.a)(n,r)?r[n]:t});n.a=u},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return t(r[n])});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r=t.length,e=[],a=0;a<r;)e[a]=n[t[a]],a+=1;return e});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(106),u=Object(e.a)(function(t,n){if(!Object(a.a)(t)||!Object(a.a)(n))throw new TypeError("Both arguments to range must be numbers");for(var r=[],e=t;e<n;)r.push(e),e+=1;return r});n.a=u},function(t,n,r){"use strict";var e=r(29),a=r(8),u=r(16),c=Object(e.a)(4,[],function(t,n,r,e){return Object(a.a)(function(r,e){return t(r,e)?n(r,e):Object(u.a)(r)},r,e)});n.a=c},function(t,n,r){"use strict";var e=r(1),a=r(16),u=Object(e.a)(a.a);n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(17),u=r(117),c=Object(e.a)(function(t,n){return Object(u.a)(Object(a.a)(t),n)});n.a=c},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return r.replace(t,n)});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){for(var e=0,a=r.length,u=[n];e<a;)n=t(n,r[e]),u[e+1]=n,e+=1;return u});n.a=a},function(t,n,r){"use strict";var e=r(2),a=r(17),u=r(111),c=Object(e.a)(function(t,n,r){return Object(u.a)(t,Object(a.a)(n),r)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return Array.prototype.slice.call(n,0).sort(t)});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return Array.prototype.slice.call(n,0).sort(function(n,r){var e=t(n),a=t(r);return e<a?-1:e>a?1:0})});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return Array.prototype.slice.call(n,0).sort(function(n,r){for(var e=0,a=0;0===e&&a<t.length;)e=t[a](n,r),a+=1;return e})});n.a=a},function(t,n,r){"use strict";var e=r(26),a=Object(e.a)(1,"split");n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(105),u=r(11),c=Object(e.a)(function(t,n){return[Object(u.a)(0,t,n),Object(u.a)(t,Object(a.a)(n),n)]});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(11),u=Object(e.a)(function(t,n){if(t<=0)throw new Error("First argument to splitEvery must be a positive integer");for(var r=[],e=0;e<n.length;)r.push(Object(a.a)(e,e+=t,n));return r});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r=0,e=n.length,a=[];r<e&&!t(n[r]);)a.push(n[r]),r+=1;return[a,Array.prototype.slice.call(n,r)]});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(9),u=r(57),c=Object(e.a)(function(t,n){return Object(a.a)(Object(u.a)(t.length,n),t)});n.a=c},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){return Number(t)-Number(n)});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(52),u=r(90),c=Object(e.a)(function(t,n){return Object(a.a)(Object(u.a)(t,n),Object(u.a)(n,t))});n.a=c},function(t,n,r){"use strict";var e=r(2),a=r(52),u=r(91),c=Object(e.a)(function(t,n,r){return Object(a.a)(Object(u.a)(t,n,r),Object(u.a)(t,r,n))});n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(11),u=Object(e.a)(function(t,n){for(var r=n.length-1;r>=0&&t(n[r]);)r-=1;return Object(a.a)(r+1,1/0,n)});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(294),c=r(11),i=Object(e.a)(Object(a.a)(["takeWhile"],u.a,function(t,n){for(var r=0,e=n.length;r<e&&t(n[r]);)r+=1;return Object(c.a)(0,r,n)}));n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(16),u=r(4),c=function(){function t(t,n){this.xf=n,this.f=t}return t.prototype["@@transducer/init"]=u.a.init,t.prototype["@@transducer/result"]=u.a.result,t.prototype["@@transducer/step"]=function(t,n){return this.f(n)?this.xf["@@transducer/step"](t,n):Object(a.a)(t)},t}(),i=Object(e.a)(function(t,n){return new c(t,n)});n.a=i},function(t,n,r){"use strict";var e=r(0),a=r(3),u=r(296),c=Object(e.a)(Object(a.a)([],u.a,function(t,n){return t(n),n}));n.a=c},function(t,n,r){"use strict";var e=r(0),a=r(4),u=function(){function t(t,n){this.xf=n,this.f=t}return t.prototype["@@transducer/init"]=a.a.init,t.prototype["@@transducer/result"]=a.a.result,t.prototype["@@transducer/step"]=function(t,n){return this.f(n),this.xf["@@transducer/step"](t,n)},t}(),c=Object(e.a)(function(t,n){return new u(t,n)});n.a=c},function(t,n,r){"use strict";var e=r(79),a=r(0),u=r(298),c=r(24),i=Object(a.a)(function(t,n){if(!Object(u.a)(t))throw new TypeError("‘test’ requires a value of type RegExp as its first argument; received "+Object(c.a)(t));return Object(e.a)(t).test(n)});n.a=i},function(t,n,r){"use strict";function e(t){return"[object RegExp]"===Object.prototype.toString.call(t)}n.a=e},function(t,n,r){"use strict";var e=r(26),a=Object(e.a)(0,"toLowerCase");n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(6),u=Object(e.a)(function(t){var n=[];for(var r in t)Object(a.a)(r,t)&&(n[n.length]=[r,t[r]]);return n});n.a=u},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){var n=[];for(var r in t)n[n.length]=[r,t[r]];return n});n.a=a},function(t,n,r){"use strict";var e=r(26),a=Object(e.a)(0,"toUpperCase");n.a=a},function(t,n,r){"use strict";var e=r(8),a=r(66),u=r(5),c=Object(u.a)(4,function(t,n,r,u){return Object(e.a)(t("function"==typeof n?Object(a.a)(n):n),r,u)});n.a=c},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){for(var n=0,r=[];n<t.length;){for(var e=t[n],a=0;a<e.length;)void 0===r[a]&&(r[a]=[]),r[a].push(e[a]),a+=1;n+=1}return r});n.a=a},function(t,n,r){"use strict";var e=r(2),a=r(7),u=r(118),c=Object(e.a)(function(t,n,r){return"function"==typeof r["fantasy-land/traverse"]?r["fantasy-land/traverse"](n,t):Object(u.a)(t,Object(a.a)(n,r))});n.a=c},function(t,n,r){"use strict";var e=r(1),a="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff",u="​",c="function"==typeof String.prototype.trim,i=c&&!a.trim()&&u.trim()?function(t){return t.trim()}:function(t){var n=new RegExp("^["+a+"]["+a+"]*"),r=new RegExp("["+a+"]["+a+"]*$");return t.replace(n,"").replace(r,"")},o=Object(e.a)(i);n.a=o},function(t,n,r){"use strict";var e=r(12),a=r(10),u=r(0),c=Object(u.a)(function(t,n){return Object(e.a)(t.length,function(){try{return t.apply(this,arguments)}catch(t){return n.apply(this,Object(a.a)([t],arguments))}})});n.a=c},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){return function(){return t(Array.prototype.slice.call(arguments,0))}});n.a=a},function(t,n,r){"use strict";var e=r(1),a=r(33),u=Object(e.a)(function(t){return Object(a.a)(1,t)});n.a=u},function(t,n,r){"use strict";var e=r(0),a=r(5),u=Object(e.a)(function(t,n){return Object(a.a)(t,function(){for(var r,e=1,a=n,u=0;e<=t&&"function"==typeof a;)r=e===t?arguments.length:u+a.length,a=a.apply(this,Array.prototype.slice.call(arguments,u,r)),e+=1,u=r;return a})});n.a=u},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r=t(n),e=[];r&&r.length;)e[e.length]=r[0],r=t(r[1]);return e});n.a=a},function(t,n,r){"use strict";var e=r(10),a=r(0),u=r(50),c=r(60),i=Object(a.a)(Object(u.a)(c.a,e.a));n.a=i},function(t,n,r){"use strict";var e=r(10),a=r(2),u=r(119),c=Object(a.a)(function(t,n,r){return Object(u.a)(t,Object(e.a)(n,r))});n.a=c},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return t(r)?r:n(r)});n.a=a},function(t,n,r){"use strict";var e=r(59),a=r(48),u=Object(a.a)(e.a);n.a=u},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){for(var e=r;!t(e);)e=n(e);return e});n.a=a},function(t,n,r){"use strict";var e=r(1),a=Object(e.a)(function(t){var n,r=[];for(n in t)r[r.length]=t[n];return r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=function(t){return{value:t,"fantasy-land/map":function(){return this}}},u=Object(e.a)(function(t,n){return t(a)(n).value});n.a=u},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){return t(r)?n(r):r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=r(9),u=r(7),c=r(120),i=Object(e.a)(function(t,n){return Object(c.a)(Object(u.a)(a.a,t),n)});n.a=i},function(t,n,r){"use strict";var e=r(20),a=r(0),u=r(40),c=r(38),i=Object(a.a)(function(t,n){return Object(c.a)(Object(u.a)(e.a)(t),n)});n.a=i},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r,e=0,a=t.length,u=n.length,c=[];e<a;){for(r=0;r<u;)c[c.length]=[t[e],n[r]],r+=1;e+=1}return c});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r=[],e=0,a=Math.min(t.length,n.length);e<a;)r[e]=[t[e],n[e]],e+=1;return r});n.a=a},function(t,n,r){"use strict";var e=r(0),a=Object(e.a)(function(t,n){for(var r=0,e=Math.min(t.length,n.length),a={};r<e;)a[t[r]]=n[r],r+=1;return a});n.a=a},function(t,n,r){"use strict";var e=r(2),a=Object(e.a)(function(t,n,r){for(var e=[],a=0,u=Math.min(n.length,r.length);a<u;)e[a]=t(n[a],r[a]),a+=1;return e});n.a=a},function(t,n,r){"use strict";n.__esModule=!0;var e=r(63),a=function(){function t(t,n,r){this.type=t,this.text=n,this.spans=r}return t.isEmbedBlock=function(t){return t===e.NODE_TYPES.embed},t.isImageBlock=function(t){return t===e.NODE_TYPES.image},t.isList=function(t){return t===e.NODE_TYPES.list},t.isOrderedList=function(t){return t===e.NODE_TYPES.oList},t.isListItem=function(t){return t===e.NODE_TYPES.listItem},t.isOrderedListItem=function(t){return t===e.NODE_TYPES.oListItem},t.emptyList=function(){return{type:e.NODE_TYPES.list,spans:[],text:""}},t.emptyOrderedList=function(){return{type:e.NODE_TYPES.oList,spans:[],text:""}},t}();n.RichTextBlock=a},function(t,n,r){"use strict";function e(t,n,r){return u.default.fromRichText(t).children.map(function(t,e){return a(t,n,e,r)})}function a(t,n,r,e){function a(t,r){var u=t instanceof c.SpanNode?t.text:null,i=t.children.reduce(function(t,n,r){return t.concat([a(n,r)])},[]);return e&&e(t.type,t.element,u,i,r)||n(t.type,t.element,u,i,r)}return a(t,r)}n.__esModule=!0;var u=r(64),c=r(122);n.default=e}])}()}()},function(t,n,r){t.exports=r(1)}])});

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {
	
	  // Store setTimeout reference so promise-polyfill will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var setTimeoutFunc = setTimeout;
	
	  function noop() {}
	  
	  // Polyfill for Function.prototype.bind
	  function bind(fn, thisArg) {
	    return function () {
	      fn.apply(thisArg, arguments);
	    };
	  }
	
	  function Promise(fn) {
	    if (!(this instanceof Promise)) throw new TypeError('Promises must be constructed via new');
	    if (typeof fn !== 'function') throw new TypeError('not a function');
	    this._state = 0;
	    this._handled = false;
	    this._value = undefined;
	    this._deferreds = [];
	
	    doResolve(fn, this);
	  }
	
	  function handle(self, deferred) {
	    while (self._state === 3) {
	      self = self._value;
	    }
	    if (self._state === 0) {
	      self._deferreds.push(deferred);
	      return;
	    }
	    self._handled = true;
	    Promise._immediateFn(function () {
	      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	      if (cb === null) {
	        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	        return;
	      }
	      var ret;
	      try {
	        ret = cb(self._value);
	      } catch (e) {
	        reject(deferred.promise, e);
	        return;
	      }
	      resolve(deferred.promise, ret);
	    });
	  }
	
	  function resolve(self, newValue) {
	    try {
	      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
	      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	        var then = newValue.then;
	        if (newValue instanceof Promise) {
	          self._state = 3;
	          self._value = newValue;
	          finale(self);
	          return;
	        } else if (typeof then === 'function') {
	          doResolve(bind(then, newValue), self);
	          return;
	        }
	      }
	      self._state = 1;
	      self._value = newValue;
	      finale(self);
	    } catch (e) {
	      reject(self, e);
	    }
	  }
	
	  function reject(self, newValue) {
	    self._state = 2;
	    self._value = newValue;
	    finale(self);
	  }
	
	  function finale(self) {
	    if (self._state === 2 && self._deferreds.length === 0) {
	      Promise._immediateFn(function() {
	        if (!self._handled) {
	          Promise._unhandledRejectionFn(self._value);
	        }
	      });
	    }
	
	    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	      handle(self, self._deferreds[i]);
	    }
	    self._deferreds = null;
	  }
	
	  function Handler(onFulfilled, onRejected, promise) {
	    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	    this.promise = promise;
	  }
	
	  /**
	   * Take a potentially misbehaving resolver function and make sure
	   * onFulfilled and onRejected are only called once.
	   *
	   * Makes no guarantees about asynchrony.
	   */
	  function doResolve(fn, self) {
	    var done = false;
	    try {
	      fn(function (value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      }, function (reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      });
	    } catch (ex) {
	      if (done) return;
	      done = true;
	      reject(self, ex);
	    }
	  }
	
	  Promise.prototype['catch'] = function (onRejected) {
	    return this.then(null, onRejected);
	  };
	
	  Promise.prototype.then = function (onFulfilled, onRejected) {
	    var prom = new (this.constructor)(noop);
	
	    handle(this, new Handler(onFulfilled, onRejected, prom));
	    return prom;
	  };
	
	  Promise.all = function (arr) {
	    return new Promise(function (resolve, reject) {
	      if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
	      var args = Array.prototype.slice.call(arr);
	      if (args.length === 0) return resolve([]);
	      var remaining = args.length;
	
	      function res(i, val) {
	        try {
	          if (val && (typeof val === 'object' || typeof val === 'function')) {
	            var then = val.then;
	            if (typeof then === 'function') {
	              then.call(val, function (val) {
	                res(i, val);
	              }, reject);
	              return;
	            }
	          }
	          args[i] = val;
	          if (--remaining === 0) {
	            resolve(args);
	          }
	        } catch (ex) {
	          reject(ex);
	        }
	      }
	
	      for (var i = 0; i < args.length; i++) {
	        res(i, args[i]);
	      }
	    });
	  };
	
	  Promise.resolve = function (value) {
	    if (value && typeof value === 'object' && value.constructor === Promise) {
	      return value;
	    }
	
	    return new Promise(function (resolve) {
	      resolve(value);
	    });
	  };
	
	  Promise.reject = function (value) {
	    return new Promise(function (resolve, reject) {
	      reject(value);
	    });
	  };
	
	  Promise.race = function (values) {
	    return new Promise(function (resolve, reject) {
	      for (var i = 0, len = values.length; i < len; i++) {
	        values[i].then(resolve, reject);
	      }
	    });
	  };
	
	  // Use polyfill for setImmediate for performance gains
	  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
	    function (fn) {
	      setTimeoutFunc(fn, 0);
	    };
	
	  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	    if (typeof console !== 'undefined' && console) {
	      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
	    }
	  };
	
	  /**
	   * Set the immediate function to execute callbacks
	   * @param fn {function} Function to execute
	   * @deprecated
	   */
	  Promise._setImmediateFn = function _setImmediateFn(fn) {
	    Promise._immediateFn = fn;
	  };
	
	  /**
	   * Change the function to execute on unhandled rejection
	   * @param {function} fn Function to execute on unhandled rejection
	   * @deprecated
	   */
	  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	    Promise._unhandledRejectionFn = fn;
	  };
	  
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Promise;
	  } else if (!root.Promise) {
	    root.Promise = Promise;
	  }
	
	})(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(487).setImmediate))

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),

/***/ 452:
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(451);
	exports.encode = exports.stringify = __webpack_require__(452);


/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (min, max) {
		if (max === undefined) {
			max = min;
			min = 0;
		}
	
		if (typeof min !== 'number' || typeof max !== 'number') {
			throw new TypeError('Expected all arguments to be numbers');
		}
	
		return Math.floor(Math.random() * (max - min + 1) + min);
	};


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var react = __webpack_require__(1);
	var emotionUtils = __webpack_require__(62);
	var emotion = __webpack_require__(16);
	var PropTypes = _interopDefault(__webpack_require__(2));
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var _contextTypes;
	
	var channel = '__EMOTION_THEMING__';
	var contextTypes = (_contextTypes = {}, _contextTypes[channel] = PropTypes.object, _contextTypes);
	
	/* global codegen */
	function setTheme(theme) {
	  this.setState({
	    theme: theme
	  });
	}
	
	function componentWillMount() {
	  if (this.context[channel] !== undefined) {
	    this.unsubscribe = this.context[channel].subscribe(setTheme.bind(this));
	  }
	}
	
	function componentWillUnmount() {
	  if (this.unsubscribe !== undefined) {
	    this.context[channel].unsubscribe(this.unsubscribe);
	  }
	}
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|accept|acceptCharset|accessKey|action|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan)|(on[A-Z].*)|((data|aria)-.*))$/;
	var testOmitPropsOnStringTag = emotionUtils.memoize(function (key) {
	  return reactPropsRegex.test(key);
	});
	
	var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
	  return key !== 'theme' && key !== 'innerRef';
	};
	
	var testAlwaysTrue = function testAlwaysTrue() {
	  return true;
	};
	
	var omitAssign = function omitAssign(testFn, target) {
	  var i = 2;
	  var length = arguments.length;
	
	  for (; i < length; i++) {
	    var source = arguments[i];
	    var key = void 0;
	
	    for (key in source) {
	      if (testFn(key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var createStyled = function createStyled(tag, options) {
	  if (false) {
	    if (tag === undefined) {
	      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
	    }
	  }
	
	  var identifierName;
	  var stableClassName;
	  var staticClassName;
	
	  if (options !== undefined) {
	    identifierName = options.label;
	    stableClassName = options.target;
	    staticClassName = options.e;
	  }
	
	  var isReal = tag.__emotion_real === tag;
	  var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;
	  var omitFn = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
	  return function (strings) {
	    var styles = isReal && tag[emotionUtils.STYLES_KEY] || [];
	
	    if (identifierName !== undefined) {
	      styles = styles.concat("label:" + identifierName + ";");
	    }
	
	    if (staticClassName === undefined) {
	      for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        interpolations[_key - 1] = arguments[_key];
	      }
	
	      if (strings == null || strings.raw === undefined) {
	        styles = styles.concat(strings, interpolations);
	      } else {
	        styles = interpolations.reduce(function (array, interp, i) {
	          return array.concat(interp, strings[i + 1]);
	        }, styles.concat(strings[0]));
	      }
	    }
	
	    var Styled =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(Styled, _Component);
	
	      function Styled() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      var _proto = Styled.prototype;
	
	      _proto.render = function render() {
	        var props = this.props,
	            state = this.state;
	        this.mergedProps = omitAssign(testAlwaysTrue, {}, props, {
	          theme: state !== null && state.theme || props.theme || {}
	        });
	        var className = '';
	        var classInterpolations = [];
	
	        if (props.className) {
	          if (staticClassName === undefined) {
	            className += emotion.getRegisteredStyles(classInterpolations, props.className);
	          } else {
	            className += props.className + " ";
	          }
	        }
	
	        if (staticClassName === undefined) {
	          className += emotion.css.apply(this, styles.concat(classInterpolations));
	        } else {
	          className += staticClassName;
	        }
	
	        if (stableClassName !== undefined) {
	          className += " " + stableClassName;
	        }
	
	        return react.createElement(baseTag, omitAssign(omitFn, {}, props, {
	          className: className,
	          ref: props.innerRef
	        }));
	      };
	
	      return Styled;
	    }(react.Component);
	
	    Styled.prototype.componentWillMount = componentWillMount;
	    Styled.prototype.componentWillUnmount = componentWillUnmount;
	    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
	    Styled.contextTypes = contextTypes;
	    Styled[emotionUtils.STYLES_KEY] = styles;
	    Styled.__emotion_base = baseTag;
	    Styled.__emotion_real = Styled;
	    Styled[emotionUtils.TARGET_KEY] = stableClassName;
	
	    Styled.withComponent = function (nextTag, nextOptions) {
	      return createStyled(nextTag, nextOptions !== undefined ? omitAssign(testAlwaysTrue, {}, options, nextOptions) : options)(styles);
	    };
	
	    return Styled;
	  };
	};
	
	exports['default'] = createStyled;
	Object.keys(emotion).forEach(function (key) { exports[key] = emotion[key]; });
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(77);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(59);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(69);
	
	var _HelmetConstants = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(66);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(99));
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(101));
	var _inheritsLoose = _interopDefault(__webpack_require__(100));
	var react = __webpack_require__(1);
	var PropTypes = _interopDefault(__webpack_require__(2));
	var ResizeObserver = _interopDefault(__webpack_require__(145));
	
	var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];
	function getTypes(props) {
	  var allowedTypes = [];
	  types.forEach(function (type) {
	    if (props[type]) {
	      allowedTypes.push(type);
	    }
	  });
	  return allowedTypes;
	}
	
	function getContentRect(node, types) {
	  var calculations = {};
	
	  if (types.indexOf('client') > -1) {
	    calculations.client = {
	      top: node.clientTop,
	      left: node.clientLeft,
	      width: node.clientWidth,
	      height: node.clientHeight
	    };
	  }
	
	  if (types.indexOf('offset') > -1) {
	    calculations.offset = {
	      top: node.offsetTop,
	      left: node.offsetLeft,
	      width: node.offsetWidth,
	      height: node.offsetHeight
	    };
	  }
	
	  if (types.indexOf('scroll') > -1) {
	    calculations.scroll = {
	      top: node.scrollTop,
	      left: node.scrollLeft,
	      width: node.scrollWidth,
	      height: node.scrollHeight
	    };
	  }
	
	  if (types.indexOf('bounds') > -1) {
	    var rect = node.getBoundingClientRect();
	    calculations.bounds = {
	      top: rect.top,
	      right: rect.right,
	      bottom: rect.bottom,
	      left: rect.left,
	      width: rect.width,
	      height: rect.height
	    };
	  }
	
	  if (types.indexOf('margin') > -1) {
	    var styles = getComputedStyle(node);
	    calculations.margin = {
	      top: styles ? parseInt(styles.marginTop) : 0,
	      right: styles ? parseInt(styles.marginRight) : 0,
	      bottom: styles ? parseInt(styles.marginBottom) : 0,
	      left: styles ? parseInt(styles.marginLeft) : 0
	    };
	  }
	
	  return calculations;
	}
	
	function withContentRect(types) {
	  return function (WrappedComponent) {
	    var _class, _temp;
	
	    return _temp = _class =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithContentRect, _Component);
	
	      function WithContentRect() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          contentRect: {
	            entry: {},
	            client: {},
	            offset: {},
	            scroll: {},
	            bounds: {},
	            margin: {}
	          }
	        };
	        _this._animationFrameID = null;
	        _this._resizeObserver = null;
	        _this._node = null;
	
	        _this.measure = function (entries) {
	          var contentRect = getContentRect(_this._node, types || getTypes(_this.props));
	
	          if (entries) {
	            contentRect.entry = entries[0].contentRect;
	          }
	
	          _this._animationFrameID = window.requestAnimationFrame(function () {
	            if (_this._resizeObserver !== null) {
	              _this.setState({
	                contentRect: contentRect
	              });
	            }
	          });
	
	          if (typeof _this.props.onResize === 'function') {
	            _this.props.onResize(contentRect);
	          }
	        };
	
	        _this._handleRef = function (node) {
	          if (_this._resizeObserver !== null && _this._node !== null) {
	            _this._resizeObserver.unobserve(_this._node);
	          }
	
	          _this._node = node;
	
	          if (_this._resizeObserver !== null && _this._node !== null) {
	            _this._resizeObserver.observe(_this._node);
	          }
	
	          var innerRef = _this.props.innerRef;
	
	          if (innerRef) {
	            if (typeof innerRef === 'function') {
	              innerRef(_this._node);
	            } else {
	              innerRef.current = _this._node;
	            }
	          }
	        };
	
	        return _this;
	      }
	
	      var _proto = WithContentRect.prototype;
	
	      _proto.componentDidMount = function componentDidMount() {
	        this._resizeObserver = new ResizeObserver(this.measure);
	
	        if (this._node !== null) {
	          this._resizeObserver.observe(this._node);
	        }
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this._resizeObserver !== null) {
	          this._resizeObserver.disconnect();
	
	          this._resizeObserver = null;
	        }
	
	        window.cancelAnimationFrame(this._animationFrameID);
	      };
	
	      _proto.render = function render() {
	        var _this$props = this.props,
	            innerRef = _this$props.innerRef,
	            onResize = _this$props.onResize,
	            props = _objectWithoutPropertiesLoose(_this$props, ["innerRef", "onResize"]);
	
	        return react.createElement(WrappedComponent, _extends({}, props, {
	          measureRef: this._handleRef,
	          measure: this.measure,
	          contentRect: this.state.contentRect
	        }));
	      };
	
	      return WithContentRect;
	    }(react.Component), _class.propTypes = {
	      client: PropTypes.bool,
	      offset: PropTypes.bool,
	      scroll: PropTypes.bool,
	      bounds: PropTypes.bool,
	      margin: PropTypes.bool,
	      innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
	      onResize: PropTypes.func
	    }, _temp;
	  };
	}
	
	var Measure = withContentRect()(function (_ref) {
	  var measure = _ref.measure,
	      measureRef = _ref.measureRef,
	      contentRect = _ref.contentRect,
	      children = _ref.children;
	  return children({
	    measure: measure,
	    measureRef: measureRef,
	    contentRect: contentRect
	  });
	});
	Measure.displayName = 'Measure';
	Measure.propTypes.children = PropTypes.func;
	
	exports.default = Measure;
	exports.withContentRect = withContentRect;


/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function Fade(e,t){function o(e){function t(){var t=p||u||i||a||l||s,o=void 0,r=void 0;if(t){var d=n?"2000px":"100%",f=_&&e;o=p?(f?"":"-")+d:u?(f?"-":"")+d:"0",r=a||l?(f?"":"-")+d:i||s?(f?"-":"")+d:"0"}return(0,_globals.animation)((e?"to":"from")+" {opacity: 0;"+(t?" transform: translate3d("+o+", "+r+", 0);":"")+"}\n         "+(e?"from":"to")+" {opacity: 1;transform: none;} ")}return{reverse:p,make:t}}var r=e.out,p=e.left,u=e.right,i=e.up,a=e.down,l=e.top,s=e.bottom,n=e.big,_=e.opposite,d=(0,_objectWithoutProperties3.default)(e,["out","left","right","up","down","top","bottom","big","opposite"]);return t?_react2.default.createElement(_Reveal2.default,(0,_extends3.default)({},d,{in:o(!1),out:o(!0)})):o(r)}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(9),_extends3=_interopRequireDefault(_extends2),_objectWithoutProperties2=__webpack_require__(13),_objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2),_react=__webpack_require__(1),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(2),_Reveal=__webpack_require__(6),_Reveal2=_interopRequireDefault(_Reveal),_globals=__webpack_require__(7),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,big:_propTypes.bool,opposite:_propTypes.bool},defaultProps={};Fade.propTypes=propTypes,Fade.defaultProps=defaultProps,exports.default=Fade,module.exports=exports.default;

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function Flip(e,t){function n(e){function t(){var t=void 0;if(s||u||r||p||i||a){var n=e&&l,o=s||i||a?(a?n?"":"-":n?"-":"")+"1":"0",f=u||p||r?(r?n?"":"-":n?"-":"")+"1":"0";t=e?"from {\n              transform: perspective(400px);\n            }\n\n            30% {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, -15deg);\n              opacity: 1;\n            }\n\n            to {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, 90deg);\n              opacity: 0;\n            }":"from {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, 90deg);\n              animation-timing-function: ease-in;\n              opacity: 0;\n            }\n\n            40% {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, -20deg);\n              animation-timing-function: ease-in;\n            }\n\n            60% {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, 10deg);\n              opacity: 1;\n            }\n\n            80% {\n              transform: perspective(400px) rotate3d("+o+", "+f+", 0, -5deg);\n            }\n\n            to {\n              transform: perspective(400px);\n            }"}else t="from {\n              transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n              animation-timing-function: ease-out;\n              opacity: "+(e?"1":"0")+";\n            }\n\n            40% {\n              transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n              animation-timing-function: ease-out;\n            }\n\n            50% {\n              transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n              animation-timing-function: ease-in;\n            }\n\n            to {\n              transform: perspective(400px);\n              animation-timing-function: ease-in;\n              opacity: "+(e?"0":"1")+";\n            }";return(0,_globals.animation)(t)}return{style:{backfaceVisibility:"visible"},make:t}}var o=e.out,r=e.left,p=e.right,i=e.top,a=e.bottom,s=e.x,u=e.y,l=e.opposite,f=(0,_objectWithoutProperties3.default)(e,["out","left","right","top","bottom","x","y","opposite"]);return t?_react2.default.createElement(_Reveal2.default,(0,_extends3.default)({},f,{in:n(!1),out:n(!0)})):n(o)}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(9),_extends3=_interopRequireDefault(_extends2),_objectWithoutProperties2=__webpack_require__(13),_objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2),_react=__webpack_require__(1),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(2),_Reveal=__webpack_require__(6),_Reveal2=_interopRequireDefault(_Reveal),_globals=__webpack_require__(7),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,opposite:_propTypes.bool},defaultProps={};Flip.propTypes=propTypes,Flip.defaultProps=defaultProps,exports.default=Flip,module.exports=exports.default;

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(9),_extends3=_interopRequireDefault(_extends2),_getPrototypeOf=__webpack_require__(81),_getPrototypeOf2=_interopRequireDefault(_getPrototypeOf),_classCallCheck2=__webpack_require__(18),_classCallCheck3=_interopRequireDefault(_classCallCheck2),_createClass2=__webpack_require__(25),_createClass3=_interopRequireDefault(_createClass2),_possibleConstructorReturn2=__webpack_require__(27),_possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2),_inherits2=__webpack_require__(26),_inherits3=_interopRequireDefault(_inherits2),_react=__webpack_require__(1),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(2),_globals=__webpack_require__(7),_Step=__webpack_require__(73),_Step2=_interopRequireDefault(_Step),_debounce=__webpack_require__(75),_debounce2=_interopRequireDefault(_debounce),propTypes={when:_propTypes.bool,spy:_propTypes.any,effect:_propTypes.string,collapse:(0,_propTypes.oneOfType)([_propTypes.bool,_propTypes.string]),duration:_propTypes.number,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool,tag:_propTypes.string,step:(0,_propTypes.oneOfType)([(0,_propTypes.instanceOf)(_Step2.default),_propTypes.string]),className:_propTypes.string,style:_propTypes.object,props:_propTypes.object,force:_propTypes.bool,bypass:_propTypes.bool,fraction:_propTypes.number,onReveal:_propTypes.func,children:_propTypes.node.isRequired,in:_propTypes.object,out:(0,_propTypes.oneOfType)([_propTypes.object,_propTypes.bool])},defaultProps={duration:1e3,delay:0,count:1,fraction:.2,tag:"div",when:!0},contextTypes={stepper:_propTypes.object},RevealBase=function(e){function t(e){(0,_classCallCheck3.default)(this,t);var s=(0,_possibleConstructorReturn3.default)(this,(t.__proto__||(0,_getPrototypeOf2.default)(t)).call(this,e));return s.state={legacyMode:!1,style:{height:e.collapse?0:void 0,visibility:e.collapse?e.when||!e.out?"visible":"hidden":void 0,opacity:!e.when&&e.out?0:void 0}},s.isListener=!1,s.isShown=!!s.props.bypass,s.revealHandler=(0,_debounce2.default)(s.reveal.bind(s,!1),66),s.resizeHandler=(0,_debounce2.default)(s.resize.bind(s),500),s.invisible=(0,_debounce2.default)(s.invisible,500),s.saveRef=function(e){return s.el=e},s}return(0,_inherits3.default)(t,e),(0,_createClass3.default)(t,[{key:"inViewport",value:function(){if(!this.el||window.document.hidden)return!1;var e=this.el.offsetHeight,s=window.pageYOffset-t.getTop(this.el),i=Math.min(e,window.innerHeight)*(_globals.globalHide?this.props.fraction:0);return s>i-window.innerHeight&&s<e-i}},{key:"hide",value:function(){this.props.out&&this.setState({style:{opacity:0}})}},{key:"resize",value:function(){this&&this.el&&this.props.when&&this.inViewport()&&(this.clean(),this.isShown=!!this.props.when,this.setState({style:{opacity:this.props.when||!this.props.out?1:0}}),this.props.onReveal&&this.props.when&&this.props.onReveal())}},{key:"invisible",value:function(){this&&!this.isShown&&this.setState({style:(0,_extends3.default)({},this.state.style,{visibility:"hidden"})})}},{key:"animationEnd",value:function(e,t){var s=this;if(!t){var i=this.finalEl||this.el,n=function t(){s&&i&&(i.removeEventListener("animationend",t),e.call(s))};i.addEventListener("animationend",n)}}},{key:"collapse",value:function(e,t){if(t.collapse&&t.out){var s=t.duration+(t.cascade?!0===t.cascade?1e3:t.cascade:0),i=s>>2,n=t.when?i:s-i,o=t.delay+(t.when?0:i);return(0,_extends3.default)({},e,{height:t.when?!0===t.collapse?this.dummyEl.offsetHeight:t.collapse:0,transition:"height "+n+"ms ease "+o+"ms"})}return e}},{key:"animate",value:function(e){if(this&&this.el){if(this.clean(),e.effect)this.setState({legacyMode:!0});else{var t=e[e.when||!e.out?"in":"out"],s=e.out||e.when?t.animation||t.make():void 0;if(this.isShown===!!e.when)return;this.isShown=!!e.when,this.setState({style:this.collapse((0,_extends3.default)({animationName:s,animationDuration:e.duration+"ms",animationDelay:e.delay+"ms",animationIterationCount:e.forever?"infinite":e.count,animationFillMode:"both",opacity:1},t.style),e)}),!e.when&&e.out&&this.animationEnd(this.invisible,e.forever)}e.onReveal&&e.when&&e.onReveal()}}},{key:"clean",value:function(){this.isListener&&(window.removeEventListener("scroll",this.revealHandler),window.removeEventListener("orientationchange",this.revealHandler),window.document.removeEventListener("visibilitychange",this.revealHandler),window.removeEventListener("resize",this.resizeHandler),this.isListener=!1)}},{key:"componentWillUnmount",value:function(){this.clean(),_globals.ssr&&(0,_globals.disableSsr)()}},{key:"listen",value:function(){this.isListener||(this.isListener=!0,window.addEventListener("scroll",this.revealHandler),window.addEventListener("orientationchange",this.revealHandler),window.document.addEventListener("visibilitychange",this.revealHandler),window.addEventListener("resize",this.resizeHandler))}},{key:"reveal",value:function(e){var t=this;if(this&&this.el)if(e||(e=this.props),this.inViewport()){if(this.start)return this.hide(),this.listen(),void this.start(this.step);e.when&&this.isShown&&"spy"in e?(this.isShown=!1,this.setState({style:{}}),window.setTimeout(function(){return t.animate.call(t,e)},200)):this.animate(e)}else this.listen()}},{key:"componentDidMount",value:function(){if(this.el&&!this.props.bypass){if(this.props.force)return this.animate(this.props);this.props.step instanceof _Step2.default?this.props.step.push(this):this.props.step&&this.context.stepper&&this.context.stepper.get(this.props.step).push(this),_globals.ssr&&(this.props.out||this.props.effect)&&t.getTop(this.el)<window.pageYOffset+window.innerHeight?(this.setState({style:{opacity:0,transition:"opacity 1000ms"}}),window.setTimeout(this.revealHandler,1e3)):this.props.when&&this.reveal(this.props)}}},{key:"cascade",value:function(e){var t=this,s=void 0;s="string"==typeof e?e.split("").map(function(e,t){return _react2.default.createElement("span",{key:t,style:{display:"inline-block",whiteSpace:"pre"}},e)}):_react2.default.Children.toArray(e);var i=s.length-1,n=this.props.duration+(!0===this.props.cascade?1e3:this.props.cascade),o=0;return s=s.map(function(e){return _react2.default.cloneElement(e,{style:(0,_extends3.default)({},e.props.style,t.state.style,{animationDuration:Math.round((0,_globals.cascade)(o++,0,i,t.props.duration,n))+"ms"}),ref:o===i?function(e){return t.finalEl=e}:void 0})})}},{key:"componentWillReceiveProps",value:function(e){e.when===this.props.when&&e.spy===this.props.spy||this.reveal(e)}},{key:"dummy",value:function(e){var t=this;if(!0!==this.props.collapse)return e;var s=[e,_react2.default.createElement(e.type,(0,_extends3.default)({},this.props.props||void 0,{className:this.props.className,children:this.props.children,key:2,ref:function(e){return t.dummyEl=e},style:(0,_extends3.default)({},this.props.style,{position:"absolute",left:"-9999em",top:"-9999em",height:"auto",display:"block",animationName:"none",animationDuration:"0s",transition:"none",opacity:0})}))];return _react2.default.createElement("span",null,s)}},{key:"render",value:function(){var e=this.props,t=e.tag,s=e.id,i=e.children,n=e.style,o=e.className,r=(this.state.legacyMode?this.props.effect:this.props.out||this.props.effect?_globals.namespace:"")+(o?" "+o:"")||void 0,a=void 0,p=!1;this.state.legacyMode||(a=(0,_extends3.default)({},n,this.state.style),this.props.cascade&&i&&this.state.style.animationName&&(p=this.cascade(i),a.animationName=void 0));var l=_react2.default.createElement(t,(0,_extends3.default)({},this.props.props||void 0,{id:s,className:r,style:this.state.legacyMode?n:a,key:this.props.collapse?1:void 0,ref:this.saveRef}),p||i);return this.props.collapse?this.dummy(l):l}}],[{key:"getTop",value:function(e){for(;void 0===e.offsetTop;)e=e.parentNode;for(var t=e.offsetTop;e.offsetParent;t+=e.offsetTop)e=e.offsetParent;return t}}]),t}(_react2.default.Component);RevealBase.propTypes=propTypes,RevealBase.defaultProps=defaultProps,RevealBase.contextTypes=contextTypes,exports.default=RevealBase,module.exports=exports.default;

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function Rotate(e,t){function o(e){function t(){var t="-200deg",o="center";return e&&n?((l||a)&&u&&(t="-45deg"),((l||a)&&p||(s||i)&&u)&&(t="45deg"),(s||i)&&p&&(t="-90deg"),(p||u)&&(o=(u?"left":"right")+" bottom")):((s||i)&&p&&(t="-45deg"),((s||i)&&u||(l||a)&&p)&&(t="45deg"),(l||a)&&u&&(t="-90deg"),(p||u)&&(o=(p?"left":"right")+" bottom")),(0,_globals.animation)("\n        "+(e?"to":"from")+" { opacity: 0; transform-origin: "+o+"; transform: rotate3d(0, 0, 1, "+t+");}\n        "+(e?"from":"to")+" { opacity: 1; transform-origin: "+o+"; transform: none;}\n      ")}return{make:t}}var r=e.out,p=e.left,u=e.right,i=e.top,a=e.bottom,l=e.up,s=e.down,n=e.opposite,_=(0,_objectWithoutProperties3.default)(e,["out","left","right","top","bottom","up","down","opposite"]);return t?_react2.default.createElement(_Reveal2.default,(0,_extends3.default)({},_,{in:o(!1),out:o(!0)})):o(r)}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(9),_extends3=_interopRequireDefault(_extends2),_objectWithoutProperties2=__webpack_require__(13),_objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2),_react=__webpack_require__(1),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(2),_Reveal=__webpack_require__(6),_Reveal2=_interopRequireDefault(_Reveal),_globals=__webpack_require__(7),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,opposite:_propTypes.bool},defaultProps={};Rotate.propTypes=propTypes,Rotate.defaultProps=defaultProps,exports.default=Rotate,module.exports=exports.default;

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(exports,"__esModule",{value:!0});var _classCallCheck2=__webpack_require__(18),_classCallCheck3=_interopRequireDefault(_classCallCheck2),_createClass2=__webpack_require__(25),_createClass3=_interopRequireDefault(_createClass2),Step=function(){function e(t){var s=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1e3;(0,_classCallCheck3.default)(this,e),this.after=s,this.name=t,this.chain=[]}return(0,_createClass3.default)(e,[{key:"push",value:function(e){this.start&&(e.step=this.index,e.start=this.start),this.chain.push(e)}}]),e}();exports.default=Step,module.exports=exports.default;

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function Zoom(e,t){function o(e){function t(){var t=p||n,o=i||a||s||u,r=t||o,c=void 0,f=void 0,d=void 0,_=void 0,m=void 0;return r?e?(f=t?((l?n:p)?"":"-")+"42px":"0",d=o?((l?s||a:u||i)?"-":"")+"60px":"0",_=t?((l?p:n)?"":"-")+"2000px":"0",m=o?((l?u||i:s||a)?"":"-")+"2000px":"0",c="40% {\n              opacity: 1;\n              transform: scale3d(.475, .475, .475) translate3d("+f+", "+d+", 0);\n            }\n            to {\n              opacity: 0;\n              transform: scale(.1) translate3d("+_+", "+m+", 0);\n              transform-origin: "+(o?"center bottom":((l?n:p)?"left":"right")+" center")+";\n            }"):(f=t?(p?"-":"")+"1000px":"0",d=o?(u||i?"-":"")+"1000px":"0",_=t?(n?"-":"")+"10px":"0",m=o?(s||a?"-":"")+"60px":"0",c="from {\n              opacity: 0;\n              transform: scale3d(.1, .1, .1) translate3d("+f+", "+d+", 0);\n              animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n            }\n            60% {\n              opacity: 1;\n              transform: scale3d(.475, .475, .475) translate3d("+_+", "+m+", 0);\n              animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n            }"):c=(e?"to":"from")+" {opacity: 0; transform: scale3d(.1, .1, .1);} "+(e?"from":"to")+" { opacity: 1; transform: none;}",(0,_globals.animation)(c)}return{make:t}}var r=e.out,p=e.left,n=e.right,i=e.top,a=e.bottom,s=e.up,u=e.down,l=e.opposite,c=(0,_objectWithoutProperties3.default)(e,["out","left","right","top","bottom","up","down","opposite"]);return t?_react2.default.createElement(_Reveal2.default,(0,_extends3.default)({},c,{in:o(!1),out:o(!0)})):o(r)}Object.defineProperty(exports,"__esModule",{value:!0});var _extends2=__webpack_require__(9),_extends3=_interopRequireDefault(_extends2),_objectWithoutProperties2=__webpack_require__(13),_objectWithoutProperties3=_interopRequireDefault(_objectWithoutProperties2),_react=__webpack_require__(1),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(2),_Reveal=__webpack_require__(6),_Reveal2=_interopRequireDefault(_Reveal),_globals=__webpack_require__(7),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,opposite:_propTypes.bool},defaultProps={};Zoom.propTypes=propTypes,Zoom.defaultProps=defaultProps,exports.default=Zoom,module.exports=exports.default;

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

	"use strict";function debounce(e,t,u){var o;return function(){var r=this,n=arguments,l=function(){o=null,u||e.apply(r,n)},p=u&&!o;clearTimeout(o),o=setTimeout(l,t),p&&e.apply(r,n)}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=debounce,module.exports=exports.default;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	"use strict";function insertRule(e){try{return sheet.insertRule(e,sheet.cssRules.length)}catch(e){console.warn("react-reveal - animation failed")}}function cascade(e,n,t,i,o){var r=Math.log(i),s=Math.log(o),a=(s-r)/(t-n);return Math.exp(r+a*(e-n))}function animation(e){if(!sheet)return"";var n="@keyframes "+(name+counter)+"{"+e+"}",t=effectMap[e];return t?""+name+t:(sheet.insertRule(n,sheet.cssRules.length),effectMap[e]=counter,""+name+counter++)}function hideAll(){window.removeEventListener("scroll",hideAll,!0),insertRule("."+namespace+" { opacity: 0; }"),window.removeEventListener("orientationchange",hideAll,!0),window.document.removeEventListener("visibilitychange",hideAll),exports.globalHide=globalHide=!0}Object.defineProperty(exports,"__esModule",{value:!0}),exports.insertRule=insertRule,exports.cascade=cascade,exports.animation=animation;var namespace=exports.namespace="react-reveal",is16=exports.is16=!1,ssr=exports.ssr=!0,disableSsr=exports.disableSsr=function(){return exports.ssr=ssr=!1},globalHide=exports.globalHide=!1,counter=1,effectMap={},sheet=!1,name=namespace+"-"+Math.floor(1e15*Math.random())+"-";if("undefined"!=typeof window&&"nodejs"!==window.name&&window.document&&"undefined"!=typeof navigator){exports.ssr=ssr=window.document.querySelectorAll("div[data-reactroot]").length>0,ssr&&"performance"in window&&"timing"in window.performance&&"domContentLoadedEventEnd"in window.performance.timing&&window.performance.timing.domLoading&&Date.now()-window.performance.timing.domLoading<500&&(exports.ssr=ssr=!1);var element=document.createElement("style");document.head.appendChild(element),element.sheet&&element.sheet.cssRules&&element.sheet.insertRule&&(sheet=element.sheet,window.addEventListener("scroll",hideAll,!0),window.addEventListener("orientationchange",hideAll,!0),window.document.addEventListener("visibilitychange",hideAll))}

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(exports,"__esModule",{value:!0});var _Reveal=__webpack_require__(6);Object.defineProperty(exports,"default",{enumerable:!0,get:function(){return _interopRequireDefault(_Reveal).default}});var _Fade=__webpack_require__(70);Object.defineProperty(exports,"Fade",{enumerable:!0,get:function(){return _interopRequireDefault(_Fade).default}});var _Flip=__webpack_require__(71);Object.defineProperty(exports,"Flip",{enumerable:!0,get:function(){return _interopRequireDefault(_Flip).default}});var _Rotate=__webpack_require__(72);Object.defineProperty(exports,"Rotate",{enumerable:!0,get:function(){return _interopRequireDefault(_Rotate).default}});var _Zoom=__webpack_require__(74);Object.defineProperty(exports,"Zoom",{enumerable:!0,get:function(){return _interopRequireDefault(_Zoom).default}});

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(63));
	var shallowEqual = _interopDefault(__webpack_require__(78));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var consolidatedEvents = __webpack_require__(32);
	var PropTypes = _interopDefault(__webpack_require__(2));
	var React = _interopDefault(__webpack_require__(1));
	
	/**
	 * Attempts to parse the offset provided as a prop as a percentage. For
	 * instance, if the component has been provided with the string "20%" as
	 * a value of one of the offset props. If the value matches, then it returns
	 * a numeric version of the prop. For instance, "20%" would become `0.2`.
	 * If `str` isn't a percentage, then `undefined` will be returned.
	 *
	 * @param {string} str The value of an offset prop to be converted to a
	 *   number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was not a percentage.
	 */
	function parseOffsetAsPercentage(str) {
	  if (str.slice(-1) === '%') {
	    return parseFloat(str.slice(0, -1)) / 100;
	  }
	}
	
	/**
	 * Attempts to parse the offset provided as a prop as a pixel value. If
	 * parsing fails, then `undefined` is returned. Three examples of values that
	 * will be successfully parsed are:
	 * `20`
	 * "20px"
	 * "20"
	 *
	 * @param {string|number} str A string of the form "{number}" or "{number}px",
	 *   or just a number.
	 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
	 *   was neither a number nor string ending in "px".
	 */
	function parseOffsetAsPixels(str) {
	  if (!isNaN(parseFloat(str)) && isFinite(str)) {
	    return parseFloat(str);
	  } else if (str.slice(-2) === 'px') {
	    return parseFloat(str.slice(0, -2));
	  }
	}
	
	/**
	 * @param {string|number} offset
	 * @param {number} contextHeight
	 * @return {number} A number representing `offset` converted into pixels.
	 */
	function computeOffsetPixels(offset, contextHeight) {
	  var pixelOffset = parseOffsetAsPixels(offset);
	
	  if (typeof pixelOffset === 'number') {
	    return pixelOffset;
	  }
	
	  var percentOffset = parseOffsetAsPercentage(offset);
	  if (typeof percentOffset === 'number') {
	    return percentOffset * contextHeight;
	  }
	}
	
	var constants = {
	  above: 'above',
	  inside: 'inside',
	  below: 'below',
	  invisible: 'invisible'
	};
	
	function debugLog() {
	  if (false) {
	    console.log(arguments); // eslint-disable-line no-console
	  }
	}
	
	var errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';
	
	/**
	 * Raise an error if more that one child was provided to "children"
	 *
	 * @param {?React.element} children
	 * @return {undefined}
	 */
	function ensureChildrenIsValid(children) {
	  if (children) {
	    try {
	      React.Children.only(children);
	    } catch (e) {
	      throw new Error(errorMessage);
	    }
	  }
	}
	
	/**
	 * When an element's type is a string, it represents a DOM node with that tag name
	 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
	 *
	 * @param {React.element} Component
	 * @return {bool} Whether the component is a DOM Element
	 */
	function isDOMElement(Component) {
	  return typeof Component.type === 'string';
	}
	
	var errorMessage$1 = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';
	
	/**
	 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
	 *
	 * @param {?React.element} children
	 * @param {?HTMLElement} ref
	 * @return {undefined}
	 */
	function ensureRefIsProvidedByChild(children, ref) {
	  if (children && !isDOMElement(children) && !ref) {
	    throw new Error(errorMessage$1);
	  }
	}
	
	/**
	 * @param {object} bounds An object with bounds data for the waypoint and
	 *   scrollable parent
	 * @return {string} The current position of the waypoint in relation to the
	 *   visible portion of the scrollable parent. One of `constants.above`,
	 *   `constants.below`, or `constants.inside`.
	 */
	function getCurrentPosition(bounds) {
	  if (bounds.viewportBottom - bounds.viewportTop === 0) {
	    return constants.invisible;
	  }
	
	  // top is within the viewport
	  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
	    return constants.inside;
	  }
	
	  // bottom is within the viewport
	  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
	    return constants.inside;
	  }
	
	  // top is above the viewport and bottom is below the viewport
	  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
	    return constants.inside;
	  }
	
	  if (bounds.viewportBottom < bounds.waypointTop) {
	    return constants.below;
	  }
	
	  if (bounds.waypointTop < bounds.viewportTop) {
	    return constants.above;
	  }
	
	  return constants.invisible;
	}
	
	var timeout = void 0;
	var timeoutQueue = [];
	
	function onNextTick(cb) {
	  timeoutQueue.push(cb);
	
	  if (!timeout) {
	    timeout = setTimeout(function () {
	      timeout = null;
	
	      // Drain the timeoutQueue
	      var item = void 0;
	      // eslint-disable-next-line no-cond-assign
	      while (item = timeoutQueue.shift()) {
	        item();
	      }
	    }, 0);
	  }
	
	  var isSubscribed = true;
	
	  return function () {
	    function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      var index = timeoutQueue.indexOf(cb);
	      if (index === -1) {
	        return;
	      }
	
	      timeoutQueue.splice(index, 1);
	
	      if (!timeoutQueue.length && timeout) {
	        clearTimeout(timeout);
	        timeout = null;
	      }
	    }
	
	    return unsubscribe;
	  }();
	}
	
	function resolveScrollableAncestorProp(scrollableAncestor) {
	  // When Waypoint is rendered on the server, `window` is not available.
	  // To make Waypoint easier to work with, we allow this to be specified in
	  // string form and safely convert to `window` here.
	  if (scrollableAncestor === 'window') {
	    return global.window;
	  }
	
	  return scrollableAncestor;
	}
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultProps = {
	  topOffset: '0px',
	  bottomOffset: '0px',
	  horizontal: false,
	  onEnter: function () {
	    function onEnter() {}
	
	    return onEnter;
	  }(),
	  onLeave: function () {
	    function onLeave() {}
	
	    return onLeave;
	  }(),
	  onPositionChange: function () {
	    function onPositionChange() {}
	
	    return onPositionChange;
	  }(),
	
	  fireOnRapidScroll: true
	};
	
	/**
	 * Calls a function when you scroll to the element.
	 */
	
	var Waypoint = function (_React$Component) {
	  _inherits(Waypoint, _React$Component);
	
	  function Waypoint(props) {
	    _classCallCheck(this, Waypoint);
	
	    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));
	
	    _this.refElement = function (e) {
	      return _this._ref = e;
	    };
	    return _this;
	  }
	
	  _createClass(Waypoint, [{
	    key: 'componentWillMount',
	    value: function () {
	      function componentWillMount() {
	        ensureChildrenIsValid(this.props.children);
	      }
	
	      return componentWillMount;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        var _this2 = this;
	
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        // this._ref may occasionally not be set at this time. To help ensure that
	        // this works smoothly, we want to delay the initial execution until the
	        // next tick.
	        this.cancelInitialTimeout = onNextTick(function () {
	          // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint
	          ensureRefIsProvidedByChild(_this2.props.children, _this2._ref);
	
	          _this2._handleScroll = _this2._handleScroll.bind(_this2);
	          _this2.scrollableAncestor = _this2._findScrollableAncestor();
	
	          if (false) {
	            debugLog('scrollableAncestor', _this2.scrollableAncestor);
	          }
	
	          _this2.scrollEventListenerUnsubscribe = consolidatedEvents.addEventListener(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });
	
	          _this2.resizeEventListenerUnsubscribe = consolidatedEvents.addEventListener(window, 'resize', _this2._handleScroll, { passive: true });
	
	          _this2._handleScroll(null);
	        });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(newProps) {
	        ensureChildrenIsValid(newProps.children);
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate() {
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        if (!this.scrollableAncestor) {
	          // The Waypoint has not yet initialized.
	          return;
	        }
	
	        // The element may have moved.
	        this._handleScroll(null);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (!Waypoint.getWindow()) {
	          return;
	        }
	
	        if (this.scrollEventListenerUnsubscribe) {
	          this.scrollEventListenerUnsubscribe();
	        }
	        if (this.resizeEventListenerUnsubscribe) {
	          this.resizeEventListenerUnsubscribe();
	        }
	
	        if (this.cancelInitialTimeout) {
	          this.cancelInitialTimeout();
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	
	    /**
	     * Traverses up the DOM to find an ancestor container which has an overflow
	     * style that allows for scrolling.
	     *
	     * @return {Object} the closest ancestor element with an overflow style that
	     *   allows for scrolling. If none is found, the `window` object is returned
	     *   as a fallback.
	     */
	
	  }, {
	    key: '_findScrollableAncestor',
	    value: function () {
	      function _findScrollableAncestor() {
	        var _props = this.props,
	            horizontal = _props.horizontal,
	            scrollableAncestor = _props.scrollableAncestor;
	
	
	        if (scrollableAncestor) {
	          return resolveScrollableAncestorProp(scrollableAncestor);
	        }
	
	        var node = this._ref;
	
	        while (node.parentNode) {
	          node = node.parentNode;
	
	          if (node === document.body) {
	            // We've reached all the way to the root node.
	            return window;
	          }
	
	          var style = window.getComputedStyle(node);
	          var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
	          var overflow = overflowDirec || style.getPropertyValue('overflow');
	
	          if (overflow === 'auto' || overflow === 'scroll') {
	            return node;
	          }
	        }
	
	        // A scrollable ancestor element was not found, which means that we need to
	        // do stuff on window.
	        return window;
	      }
	
	      return _findScrollableAncestor;
	    }()
	
	    /**
	     * @param {Object} event the native scroll event coming from the scrollable
	     *   ancestor, or resize event coming from the window. Will be undefined if
	     *   called by a React lifecyle method
	     */
	
	  }, {
	    key: '_handleScroll',
	    value: function () {
	      function _handleScroll(event) {
	        if (!this._ref) {
	          // There's a chance we end up here after the component has been unmounted.
	          return;
	        }
	
	        var bounds = this._getBounds();
	        var currentPosition = getCurrentPosition(bounds);
	        var previousPosition = this._previousPosition;
	
	        if (false) {
	          debugLog('currentPosition', currentPosition);
	          debugLog('previousPosition', previousPosition);
	        }
	
	        // Save previous position as early as possible to prevent cycles
	        this._previousPosition = currentPosition;
	
	        if (previousPosition === currentPosition) {
	          // No change since last trigger
	          return;
	        }
	
	        var callbackArg = {
	          currentPosition: currentPosition,
	          previousPosition: previousPosition,
	          event: event,
	          waypointTop: bounds.waypointTop,
	          waypointBottom: bounds.waypointBottom,
	          viewportTop: bounds.viewportTop,
	          viewportBottom: bounds.viewportBottom
	        };
	        this.props.onPositionChange.call(this, callbackArg);
	
	        if (currentPosition === constants.inside) {
	          this.props.onEnter.call(this, callbackArg);
	        } else if (previousPosition === constants.inside) {
	          this.props.onLeave.call(this, callbackArg);
	        }
	
	        var isRapidScrollDown = previousPosition === constants.below && currentPosition === constants.above;
	        var isRapidScrollUp = previousPosition === constants.above && currentPosition === constants.below;
	
	        if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
	          // If the scroll event isn't fired often enough to occur while the
	          // waypoint was visible, we trigger both callbacks anyway.
	          this.props.onEnter.call(this, {
	            currentPosition: constants.inside,
	            previousPosition: previousPosition,
	            event: event,
	            waypointTop: bounds.waypointTop,
	            waypointBottom: bounds.waypointBottom,
	            viewportTop: bounds.viewportTop,
	            viewportBottom: bounds.viewportBottom
	          });
	          this.props.onLeave.call(this, {
	            currentPosition: currentPosition,
	            previousPosition: constants.inside,
	            event: event,
	            waypointTop: bounds.waypointTop,
	            waypointBottom: bounds.waypointBottom,
	            viewportTop: bounds.viewportTop,
	            viewportBottom: bounds.viewportBottom
	          });
	        }
	      }
	
	      return _handleScroll;
	    }()
	  }, {
	    key: '_getBounds',
	    value: function () {
	      function _getBounds() {
	        var horizontal = this.props.horizontal;
	
	        var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
	            left = _ref$getBoundingClien.left,
	            top = _ref$getBoundingClien.top,
	            right = _ref$getBoundingClien.right,
	            bottom = _ref$getBoundingClien.bottom;
	
	        var waypointTop = horizontal ? left : top;
	        var waypointBottom = horizontal ? right : bottom;
	
	        var contextHeight = void 0;
	        var contextScrollTop = void 0;
	        if (this.scrollableAncestor === window) {
	          contextHeight = horizontal ? window.innerWidth : window.innerHeight;
	          contextScrollTop = 0;
	        } else {
	          contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
	          contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
	        }
	
	        if (false) {
	          debugLog('waypoint top', waypointTop);
	          debugLog('waypoint bottom', waypointBottom);
	          debugLog('scrollableAncestor height', contextHeight);
	          debugLog('scrollableAncestor scrollTop', contextScrollTop);
	        }
	
	        var _props2 = this.props,
	            bottomOffset = _props2.bottomOffset,
	            topOffset = _props2.topOffset;
	
	        var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
	        var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
	        var contextBottom = contextScrollTop + contextHeight;
	
	        return {
	          waypointTop: waypointTop,
	          waypointBottom: waypointBottom,
	          viewportTop: contextScrollTop + topOffsetPx,
	          viewportBottom: contextBottom - bottomOffsetPx
	        };
	      }
	
	      return _getBounds;
	    }()
	
	    /**
	     * @return {Object}
	     */
	
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this3 = this;
	
	        var children = this.props.children;
	
	
	        if (!children) {
	          // We need an element that we can locate in the DOM to determine where it is
	          // rendered relative to the top of its context.
	          return React.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
	        }
	
	        if (isDOMElement(children)) {
	          var ref = function () {
	            function ref(node) {
	              _this3.refElement(node);
	              if (children.ref) {
	                children.ref(node);
	              }
	            }
	
	            return ref;
	          }();
	
	          return React.cloneElement(children, { ref: ref });
	        }
	
	        return React.cloneElement(children, { innerRef: this.refElement });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return Waypoint;
	}(React.Component);
	
	Waypoint.propTypes = {
	  children: PropTypes.node,
	  debug: PropTypes.bool,
	  onEnter: PropTypes.func,
	  onLeave: PropTypes.func,
	  onPositionChange: PropTypes.func,
	  fireOnRapidScroll: PropTypes.bool,
	  scrollableAncestor: PropTypes.any,
	  horizontal: PropTypes.bool,
	
	  // `topOffset` can either be a number, in which case its a distance from the
	  // top of the container in pixels, or a string value. Valid string values are
	  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
	  // as a percentage of the height of the containing element.
	  // For instance, if you pass "-20%", and the containing element is 100px tall,
	  // then the waypoint will be triggered when it has been scrolled 20px beyond
	  // the top of the containing element.
	  topOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	
	  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
	  bottomOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	
	Waypoint.above = constants.above;
	Waypoint.below = constants.below;
	Waypoint.inside = constants.inside;
	Waypoint.invisible = constants.invisible;
	Waypoint.getWindow = function () {
	  if (typeof window !== 'undefined') {
	    return window;
	  }
	};
	Waypoint.defaultProps = defaultProps;
	Waypoint.displayName = 'Waypoint';
	
	module.exports = Waypoint;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(139)))

/***/ }),

/***/ 78:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(484);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module), (function() { return this; }())))

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(503);
	var util = __webpack_require__(505);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(453);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ }),

/***/ 505:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(16);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _ScrollNotifier = __webpack_require__(8);
	
	var _ScrollNotifier2 = _interopRequireDefault(_ScrollNotifier);
	
	var _theme = __webpack_require__(4);
	
	var _utilities = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var ArticleHeading = function ArticleHeading(_ref) {
	  var slice = _ref.slice;
	
	  return React.createElement("div", {
	    className: (0, _emotion.css)({
	      maxWidth: "32rem",
	      marginLeft: "auto",
	      marginRight: "auto",
	      fontFamily: _theme.theme.sans.fontFamily,
	      fontWeight: _theme.theme.bold,
	      "& > h1": {
	        fontSize: _theme.theme.h1,
	        marginTop: _theme.theme.space1,
	        marginBottom: _theme.theme.space1
	      }
	    }),
	
	    dangerouslySetInnerHTML: { __html: slice.primary.heading_text.html }
	  });
	};
	
	exports.default = ArticleHeading;
	module.exports = exports["default"];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _theme = __webpack_require__(4);
	
	var _utilities = __webpack_require__(11);
	
	var _ScrollNotifier = __webpack_require__(8);
	
	var _ScrollNotifier2 = _interopRequireDefault(_ScrollNotifier);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Wrap = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "css-165w79r0"
	})("max-width:42rem;margin-bottom:", _theme.theme.space3, ";margin-left:auto;margin-right:auto;text-align:center;");
	
	var Caption = /*#__PURE__*/(0, _reactEmotion2.default)("figcaption", {
	  target: "css-165w79r1"
	})("font-size:", _theme.theme.h5, ";font-family:", _theme.theme.sans.fontFamily, ";font-weight:", _theme.theme.sans.normal, ";");
	
	var Image = /*#__PURE__*/(0, _reactEmotion2.default)("img", {
	  target: "css-165w79r2"
	})("width:", function (props) {
	  return props.dimensions.height > props.dimensions.width ? "auto" : "100%";
	}, ";height:", function (props) {
	  return props.dimensions.height > props.dimensions.width ? "80vh" : "auto";
	}, ";");
	
	var ArticleImage = function ArticleImage(_ref) {
	  var slice = _ref.slice;
	
	  console.log(slice);
	  return React.createElement(
	    Wrap,
	    null,
	    React.createElement(_ScrollNotifier2.default, { onEnter: "CLEAR" }),
	    slice.items.map(function (i, k) {
	      return React.createElement(
	        "figure",
	        null,
	        React.createElement(Image, { k: k, src: i.image.url, dimensions: i.image.dimensions }),
	        i.download_link.url && React.createElement(
	          Caption,
	          null,
	          React.createElement(
	            "a",
	            { href: i.download_link.url },
	            "Download Full Resolution"
	          )
	        )
	      );
	    })
	  );
	};
	
	exports.default = ArticleImage;
	module.exports = exports["default"];

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _ScrollNotifier = __webpack_require__(8);
	
	var _ScrollNotifier2 = _interopRequireDefault(_ScrollNotifier);
	
	var _theme = __webpack_require__(4);
	
	var _utilities = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Wrap = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "css-vjurr90"
	})("max-width:42rem;margin-bottom:", _theme.theme.space3, ";margin-left:auto;margin-right:auto;p{font-size:", _theme.theme.h3, ";line-height:", _theme.theme.lineHeight3, ";font-family:", _theme.theme.sans.fontFamily, ";font-weight:", _theme.theme.sans.bold, ";padding-bottom:", _theme.theme.space2, ";}");
	
	var Attribution = /*#__PURE__*/(0, _reactEmotion2.default)("cite", {
	  target: "css-vjurr91"
	})("font-style:italic;font-size:", _theme.theme.h4, ";font-family:", _theme.theme.sans.fontFamily, ";font-weight:", _theme.theme.sans.bold, ";");
	
	var ArticleQuote = function ArticleQuote(_ref) {
	  var slice = _ref.slice;
	
	  var text = slice.primary.text.html;
	  return React.createElement(
	    Wrap,
	    null,
	    React.createElement(_ScrollNotifier2.default, { onEnter: "DIAGONAL_LEFT" }),
	    React.createElement("blockquote", { dangerouslySetInnerHTML: { __html: text } }),
	    slice.primary.attribution && React.createElement(
	      Attribution,
	      null,
	      slice.primary.attribution
	    )
	  );
	};
	
	exports.default = ArticleQuote;
	module.exports = exports["default"];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _ArticleImage = __webpack_require__(204);
	
	var _ArticleImage2 = _interopRequireDefault(_ArticleImage);
	
	var _ArticleVideo = __webpack_require__(208);
	
	var _ArticleVideo2 = _interopRequireDefault(_ArticleVideo);
	
	var _ArticleText = __webpack_require__(207);
	
	var _ArticleText2 = _interopRequireDefault(_ArticleText);
	
	var _ArticleHeading = __webpack_require__(203);
	
	var _ArticleHeading2 = _interopRequireDefault(_ArticleHeading);
	
	var _ArticleQuote = __webpack_require__(205);
	
	var _ArticleQuote2 = _interopRequireDefault(_ArticleQuote);
	
	var _PhotoGrid = __webpack_require__(217);
	
	var _PhotoGrid2 = _interopRequireDefault(_PhotoGrid);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Wrap = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "css-yrwl0y0"
	})("margin-top:", _theme.theme.space3, ";margin-bottom:", _theme.theme.space4, ";");
	
	var ArticleSwitch = function ArticleSwitch(_ref) {
	  var slice = _ref.slice;
	
	  switch (slice.__typename) {
	    case "PrismicArticleBodyText":
	      return React.createElement(_ArticleText2.default, { slice: slice });
	    case "PrismicArticleBodyHeading":
	      return React.createElement(_ArticleHeading2.default, { slice: slice });
	    case "PrismicArticleBodyQuote":
	      return React.createElement(_ArticleQuote2.default, { slice: slice });
	    case "PrismicArticleBodyImage":
	      return React.createElement(_ArticleImage2.default, { slice: slice });
	    case "PrismicArticleBodyImageGallery":
	      return React.createElement(_PhotoGrid2.default, { photos: slice.items, columns: slice.number_of_columns });
	    case "PrismicArticleBodyVideo":
	      return React.createElement(_ArticleVideo2.default, { slice: slice });
	
	    default:
	      return null;
	  }
	};
	
	var ArticleSlices = function ArticleSlices(_ref2) {
	  var slices = _ref2.slices;
	
	  return React.createElement(
	    Wrap,
	    null,
	    slices.map(function (s, k) {
	      return React.createElement(ArticleSwitch, { slice: s, key: k });
	    })
	  );
	};
	
	exports.default = ArticleSlices;
	module.exports = exports["default"];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _ScrollNotifier = __webpack_require__(8);
	
	var _ScrollNotifier2 = _interopRequireDefault(_ScrollNotifier);
	
	var _theme = __webpack_require__(4);
	
	var _utilities = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Wrap = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "css-157equs0"
	})("max-width:32rem;margin-bottom:", _theme.theme.space3, ";margin-left:auto;margin-right:auto;p{font-size:", _theme.theme.h4, ";padding-bottom:", _theme.theme.space2, ";}", (0, _theme.mqMin)(_theme.theme.tablet), "{font-size:", _theme.theme.h3, ";p{font-size:", _theme.theme.h4, ";}}");
	var ArticleText = function ArticleText(_ref) {
	  var slice = _ref.slice;
	
	  console.log(slice);
	  return React.createElement(
	    "div",
	    null,
	    React.createElement(_ScrollNotifier2.default, { onEnter: "DIAGONAL_RIGHT" }),
	    React.createElement(Wrap, {
	      dangerouslySetInnerHTML: {
	        __html: slice.primary.text.html
	      }
	    })
	  );
	};
	
	exports.default = ArticleText;
	module.exports = exports["default"];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _embedVideo = __webpack_require__(322);
	
	var _embedVideo2 = _interopRequireDefault(_embedVideo);
	
	var _reactMeasure = __webpack_require__(141);
	
	var _theme = __webpack_require__(4);
	
	var _utilities = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Wrap = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "css-1huke4l0"
	})("max-width:42rem;margin-bottom:", _theme.theme.space3, ";margin-left:auto;margin-right:auto;text-align:center;");
	
	var ArticleVideo = (0, _reactMeasure.withContentRect)("bounds")(function (_ref) {
	  var slice = _ref.slice,
	      measureRef = _ref.measureRef,
	      measure = _ref.measure,
	      contentRect = _ref.contentRect;
	  var width = contentRect.bounds.width;
	
	  return React.createElement(Wrap, {
	    innerRef: measureRef,
	    width: width,
	    dangerouslySetInnerHTML: {
	      __html: (0, _embedVideo2.default)(slice.primary.share_link, {
	        attr: {
	          width: width,
	          height: width / 16 * 9
	        }
	      })
	    }
	  });
	});
	
	exports.default = ArticleVideo;
	module.exports = exports["default"];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(16);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _css2;
	
	  var photos = _ref.photos,
	      _ref$columns = _ref.columns,
	      columns = _ref$columns === undefined ? 3 : _ref$columns;
	  return _react2.default.createElement(
	    "div",
	    {
	      className: (0, _emotion.css)((_css2 = {
	        display: "flex",
	        overflowY: "scroll",
	        "-webkit-overflow-scrolling": "touch",
	        alignItems: "center"
	      }, _css2[(0, _theme.mqMin)(750)] = {
	        flexWrap: "wrap",
	        overflowY: "hidden",
	        justifyContent: "center"
	      }, _css2))
	    },
	    photos.map(function (p, i) {
	      var _css4;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          key: i,
	          className: (0, _emotion.css)((_css4 = {
	            padding: "0.5rem",
	            alignItems: "center",
	            flexBasis: 85 + "%",
	            flex: "0 0 auto",
	            width: 85 + "%"
	          }, _css4[(0, _theme.mqMin)(750)] = {
	            padding: "1rem",
	            flexBasis: 100 / columns + "%",
	            flex: "0 0 auto",
	            width: 100 / columns + "%"
	          }, _css4))
	        },
	        _react2.default.createElement(
	          "a",
	          {
	            href: p.full_resolution.url,
	            target: "_blank",
	            rel: "noopener noreferrer"
	          },
	          _react2.default.createElement("img", {
	            src: p.thumbnail.url,
	            alt: "",
	            className: (0, _emotion.css)({ width: "100%", height: "auto" }) + " lazyload"
	          })
	        )
	      );
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactWaypoint = __webpack_require__(23);
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	var _mobxReact = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScrollNotifier = function ScrollNotifier(_ref) {
	  var _ref$offset = _ref.offset,
	      offset = _ref$offset === undefined ? "0px" : _ref$offset,
	      onEnter = _ref.onEnter,
	      onLeave = _ref.onLeave,
	      updateBackground = _ref.updateBackground;
	  return _react2.default.createElement(_reactWaypoint2.default, {
	    bottomOffset: offset,
	    onEnter: onEnter ? function () {
	      return updateBackground(onEnter);
	    } : function () {
	      return null;
	    },
	    onLeave: onLeave ? function () {
	      return updateBackground(onLeave);
	    } : function () {
	      return null;
	    }
	  });
	};
	
	exports.default = (0, _mobxReact.inject)(function (_ref2) {
	  var store = _ref2.store;
	  return {
	    scroll: store.uiStore.scroll,
	    background: store.appStore.background1,
	    updateBackground: store.appStore.updateBackground
	  };
	})((0, _mobxReact.observer)(ScrollNotifier));
	module.exports = exports["default"];

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _WorkGridItem = __webpack_require__(105);
	
	var _WorkGridItem2 = _interopRequireDefault(_WorkGridItem);
	
	var _colors = __webpack_require__(12);
	
	var _theme = __webpack_require__(4);
	
	var _ScrollNotifier = __webpack_require__(8);
	
	var _ScrollNotifier2 = _interopRequireDefault(_ScrollNotifier);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var ProcessGrid = /*#__PURE__*/(0, _reactEmotion2.default)("section", {
	  target: "css-xkw1on0"
	})("position:relative;margin:0 auto;padding-left:", _theme.theme.space1, ";padding-right:", _theme.theme.space1, ";padding-top:", _theme.theme.space4, ";padding-bottom:", _theme.theme.space4, ";color:", _colors.black, ";max-width:", _theme.theme.maxWidth3, ";");
	
	var workEdgeToProps = function workEdgeToProps(edge) {
	  return {
	    text: edge.node.data.work_list_title,
	    heading: edge.node.data.client_name,
	    meta: edge.node.data.type_of_work,
	    uid: "/article/" + edge.node.uid
	  };
	};
	
	exports.default = function (_ref) {
	  var workItems = _ref.workItems;
	
	  return React.createElement(
	    ProcessGrid,
	    null,
	    React.createElement(_ScrollNotifier2.default, { offset: "0%", onEnter: "FOOTER" }),
	    workItems.filter(function (x) {
	      return !x.node.tags.includes("landing");
	    }).map(function (w, k) {
	      return React.createElement(
	        "div",
	        { key: k },
	        console.log(w),
	        React.createElement(_WorkGridItem2.default, workEdgeToProps(w)),
	        React.createElement(_ScrollNotifier2.default, {
	          offset: "0%",
	          onEnter: k % 2 === 0 ? "WORK_" + k : null
	        })
	      );
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _gatsbyLink = __webpack_require__(64);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _theme = __webpack_require__(4);
	
	var _reactReveal = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Wrap = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "css-1oospmv0"
	})("padding-left:", _theme.theme.space2, ";padding-right:", _theme.theme.space2, ";padding-bottom:", _theme.theme.space3, ";width:100%;", (0, _theme.mqMin)(_theme.theme.tablet), "{padding:0;display:flex;align-items:center;justify-content:flex-end;}");
	
	
	var Intro = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "css-1oospmv1"
	})("padding-bottom:", _theme.theme.space1, ";", (0, _theme.mqMin)(_theme.theme.tablet), "{padding-top:", _theme.theme.space3, ";padding-bottom:", _theme.theme.space3, ";padding-left:", _theme.theme.space3, ";padding-right:", _theme.theme.space3, ";flex-shrink:0;flex-basis:40%;}");
	var Heading = /*#__PURE__*/(0, _reactEmotion2.default)("h3", {
	  target: "css-1oospmv2"
	})("font-size:", _theme.theme.h2, ";font-family:", _theme.theme.heading.fontFamily, ";font-weight:", _theme.theme.heading.bold, ";line-height:", _theme.theme.lineHeight2, ";");
	
	var Text = /*#__PURE__*/(0, _reactEmotion2.default)("p", {
	  target: "css-1oospmv3"
	})("font-family:", _theme.theme.display.fontFamily, ";font-weight:", _theme.theme.display.fontWeight, ";", (0, _theme.mqMin)(_theme.theme.tablet), "{padding-top:", _theme.theme.space3, ";padding-bottom:", _theme.theme.space3, ";font-size:", _theme.theme.h4, ";line-height:", _theme.theme.lineHeight3, ";p:first-of-type:{padding-top:", _theme.theme.space1, ";}font-size:", _theme.theme.h3, ";}");
	var Meta = /*#__PURE__*/(0, _reactEmotion2.default)("span", {
	  target: "css-1oospmv4"
	})("font-size:", _theme.theme.h4, ";font-family:", _theme.theme.heading.fontFamily, ";font-weight:400;");
	
	exports.default = function (_ref) {
	  var heading = _ref.heading,
	      text = _ref.text,
	      meta = _ref.meta,
	      active = _ref.active,
	      uid = _ref.uid,
	      progress = _ref.progress;
	  return React.createElement(
	    Wrap,
	    null,
	    React.createElement(
	      Intro,
	      null,
	      React.createElement(
	        Heading,
	        null,
	        React.createElement(
	          _gatsbyLink2.default,
	          { to: uid },
	          heading
	        )
	      ),
	      React.createElement(
	        Meta,
	        null,
	        meta
	      )
	    ),
	    React.createElement(
	      Text,
	      null,
	      React.createElement(
	        _gatsbyLink2.default,
	        { to: uid },
	        text
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(68);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _prismicDom = __webpack_require__(40);
	
	var _prismicDom2 = _interopRequireDefault(_prismicDom);
	
	var _WorkGrid = __webpack_require__(104);
	
	var _WorkGrid2 = _interopRequireDefault(_WorkGrid);
	
	var _ArticleSlices = __webpack_require__(206);
	
	var _ArticleSlices2 = _interopRequireDefault(_ArticleSlices);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _theme = __webpack_require__(4);
	
	var _utilities = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Cover = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "css-1v0h0tt0"
	})("position:relative;z-index:2;max-width:", _theme.theme.breakpoints[3], ";margin-top:", _theme.theme.space4, ";margin-bottom:", _theme.theme.space5, ";padding-left:", _theme.theme.space1, ";padding-right:", _theme.theme.space1, ";margin-left:auto;margin-right:auto;");
	
	var Heading = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "css-1v0h0tt1"
	})("font-family:", _theme.theme.heading.fontFamily, ";font-weight:", _theme.theme.heading.bold, ";font-size:", _theme.theme.h1, ";line-height:", _theme.theme.lineHeight2, ";text-align:center;", (0, _theme.mqMin)(_theme.theme.tablet), "{font-size:", _theme.theme.super, ";}");
	
	var Subtext = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "css-1v0h0tt2"
	})("font-family:", _theme.theme.sans.fontFamily, ";font-weight:", _theme.theme.sans.normal, ";font-size:", _theme.theme.h4, ";margin-top:", _theme.theme.space1, ";text-align:center;", (0, _theme.mqMin)(_theme.theme.tablet), "{font-size:", _theme.theme.h3, ";}");
	
	exports.default = function (_ref) {
	  var data = _ref.data,
	      props = _objectWithoutProperties(_ref, ["data"]);
	
	  console.log(data);
	  var slug = props.pathContext.slug;
	  var articles = data.work.edges.filter(function (n) {
	    return n.node.uid === slug;
	  });
	  if (articles.length < 1) {
	    return null;
	  }
	
	  var article = articles[0].node.data;
	  var title = article.title || article.client_name;
	  var tags = [{ itemprop: "name", content: "PandaGoat Media" }, { name: "twitter:card", content: "summary" }, { name: "twitter:title", content: "PaNDAGOAT MEDIA - " + title }, { name: "og:title", content: "PaNDAGOAT MEDIA - " + title }, { name: "og:url", content: props.pathContext.path }, { name: "og:site_name", content: "Panda Goat Media" }, { name: "og:type", content: "website" }, { name: "twitter:site", content: "@pandagoatmedia ‏" }, { name: "twitter:creator", content: "@pandagoatmedia ‏" }, {
	    name: "description",
	    value: article.description ? article.description.text : article.lead_in.text
	  }];
	
	  return _react2.default.createElement(
	    Cover,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: article.title || article.client_name, meta: tags }),
	    _react2.default.createElement(
	      Heading,
	      null,
	      article.client_name || article.title
	    ),
	    _react2.default.createElement(Subtext, { dangerouslySetInnerHTML: { __html: article.lead_in.html } }),
	    _react2.default.createElement(_ArticleSlices2.default, { slices: article.body })
	  );
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var button = {
	  base: {
	    fontWeight: "500",
	    cursor: "pointer",
	    display: "inline-block",
	    lineHeight: "1.125rem",
	    padding: ".5rem 1rem",
	    margin: 0,
	    height: "auto",
	    verticalAlign: "middle"
	  }
	};
	
	exports.default = button;
	module.exports = exports["default"];

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = [["#34e95c", "#d012a3", "#1212d0"], ["#c2f6b2", "#3d054d", "#05154d"], ["#8ada6b", "#752195", "#214195"], ["#ceb61b", "#2d46ea", "#2DEAD1"], ["#b63413", "#01c7f8", "#01f832"], [("#062583", "#FDDFDB")], ["#363378", "#F9747D"]];
	var black = exports.black = "#262626";
	
	var gray = exports.gray = "#5C5D60";
	
	var teal = exports.teal = "#009E99";
	
	var lime = exports.lime = "#8ada6b";
	
	var blue = exports.blue = "28213C";

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.AbsOverflow = exports.mqBetween = exports.mqMax = exports.mqMin = exports.py = exports.px = exports.my = exports.mx = exports.mxAuto = exports.ratio = exports.rs = exports.colors = exports.button = exports.theme = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _button = __webpack_require__(24);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _colors = __webpack_require__(12);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _emotion = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var phone = 400;
	var phablet = 550;
	var tablet = 750;
	var desktop = 1000;
	var hd = 1200;
	var scale = 1.33;
	var rem = 18;
	var h6 = rem / scale / scale;
	var h5 = rem / scale;
	var h4 = rem;
	var h3 = rem * scale;
	var h2 = rem * scale * scale;
	var h1 = rem * scale * scale * scale;
	var hBig = rem * scale * scale * scale * scale;
	var hSuper = rem * scale * scale * scale * scale * scale;
	var hHuge = rem * scale * scale * scale * scale * scale * scale * scale;
	var breakpoints = ["24em", "46.8em", "67.5em"];
	
	// ...
	var theme = {
	  display: {
	    fontFamily: "'adobe-garamond-pro', garamond,  'Gill Sans', apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
	    fontWeight: 400
	  },
	  sans: {
	    fontFamily: "'europa', 'Gill Sans', apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
	    bold: 700
	  },
	  heading: {
	    fontFamily: "'freight-neo-pro', 'Gill Sans', apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
	    bold: 700
	  },
	  mono: {
	    fontFamily: "'mono45-headline','Lucida Console', Monaco, monospace ",
	    normal: 400
	  },
	
	  system: "apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
	  huge: hHuge / rem + "rem",
	  super: hSuper / rem + "rem",
	  big: hBig / rem + "rem",
	  h1: h1 / rem + "rem",
	  h2: h2 / rem + "rem",
	  h3: h3 / rem + "rem",
	  h4: h4 / rem + "rem",
	  h5: h5 / rem + "rem",
	  h6: h6 / rem + "rem",
	  bold: 700,
	  normal: 400,
	  light: 300,
	  lineHeight1: 1,
	  lineHeight2: 1.125,
	  lineHeight3: 1.25,
	  lineHeight4: 1.5,
	  lineHeight5: 1.75,
	  lineHeightCompressed: 0.8,
	  breakpoints: breakpoints,
	  maxWidth1: breakpoints[0],
	  maxWidth2: breakpoints[1],
	  maxWidth3: breakpoints[2],
	  maxWidth4: breakpoints[3],
	  spaceMicro: ".25rem",
	  space1: ".5rem",
	  space2: "1rem",
	  space3: "2rem",
	  space4: "4rem",
	  space5: "8rem",
	  spaceHuge: "10rem",
	  phone: phone,
	  phablet: phablet,
	  tablet: tablet,
	  desktop: desktop,
	  hd: hd,
	  phoneEm: phone / 16 + "em",
	  phabletEm: phablet / 16 + "em",
	  tabletEm: tablet / 16 + "em",
	  desktopEm: desktop / 16 + "em",
	  hdEm: hd / 16 + "em"
	};
	
	var merge = function merge(a, b) {
	  return _extends({}, a, b, Object.keys(b).reduce(function (obj, key) {
	    var _extends2;
	
	    return _extends(obj, (_extends2 = {}, _extends2[key] = a[key] !== null && typeof a[key] === "object" ? merge(a[key], b[key]) : b[key], _extends2));
	  }, {}));
	};
	
	var isPx = function isPx(m) {
	  return typeof m === "number" ? m + "px" : m;
	};
	var mqMin = function mqMin(n) {
	  return "@media screen and (min-width: " + isPx(n) + ")";
	};
	var mqMax = function mqMax(n) {
	  return "@media screen and (max-width: " + isPx(n) + ")";
	};
	var mqBetween = function mqBetween(n, m) {
	  return "@media screen and (min-width: " + isPx(n) + " and (max-width: " + isPx(m) + ")";
	};
	
	function TooManyStylesException(message) {
	  this.name = "ResponsiveStyleError";
	  this.message = message;
	}
	
	var rs = function rs() {
	  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
	    styles[_key] = arguments[_key];
	  }
	
	  if (styles.length > breakpoints.length + 1) {
	    throw new TooManyStylesException("Too many styles. There are " + (breakpoints.length + 1) + " breakpoints (incl. default), but " + styles.length + " styles passed");
	  }
	
	  return (/*#__PURE__*/(0, _emotion.css)(styles.reduce(function (acc, x, i) {
	      var _extends3;
	
	      if (i === 0) {
	        return x;
	      }
	      return _extends({}, acc, (_extends3 = {}, _extends3[mqMin(breakpoints[i - 1])] = x, _extends3));
	    }))
	  );
	};
	
	var ratio = function ratio(a, b) {
	  return a / b;
	};
	var mxAuto = function mxAuto() {
	  return "margin-left: \"auto\", margin-right: \"auto\"";
	};
	var mx = function mx(space) {
	  return "margin-left: " + space + ", margin-right: " + space;
	};
	var my = function my(space) {
	  return { marginTop: space, marginBottom: space };
	};
	var px = function px(space) {
	  return { paddingLeft: space, paddingRight: space };
	};
	var py = function py(space) {
	  return { paddingTop: space, paddingBottom: space };
	};
	
	var AbsOverflow = /*#__PURE__*/(0, _emotion.css)("position:fixed;top:0;left:0;bottom:0;right:0;z-index:10;");
	
	exports.theme = theme;
	exports.button = _button2.default;
	exports.colors = _colors2.default;
	exports.rs = rs;
	exports.ratio = ratio;
	exports.mxAuto = mxAuto;
	exports.mx = mx;
	exports.my = my;
	exports.px = px;
	exports.py = py;
	exports.mqMin = mqMin;
	exports.mqMax = mqMax;
	exports.mqBetween = mqBetween;
	exports.AbsOverflow = AbsOverflow;

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.fieldExists = exports.getText = exports.progress = exports.noDummy = exports.toHtml = exports.linkResolver = exports.getSlides = exports.pageFraction = exports.pageProgress = exports.gridProgress = undefined;
	
	var _prismicDom = __webpack_require__(40);
	
	var _randomInt = __webpack_require__(49);
	
	var _randomInt2 = _interopRequireDefault(_randomInt);
	
	var _lodash = __webpack_require__(48);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _objectPath = __webpack_require__(67);
	
	var _objectPath2 = _interopRequireDefault(_objectPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var gridProgress = exports.gridProgress = function gridProgress(page, progress, pages) {
	  return (100 * page + progress) / (pages * 100) * 100;
	};
	
	var pageProgress = exports.pageProgress = function pageProgress(page, pages) {
	  return page * 100;
	}; // * page / (pages * 100) * 100;
	var pageFraction = exports.pageFraction = function pageFraction(page, pages) {
	  return page / pages * 100;
	}; // * page / (pages * 100) * 100;
	
	var getSlides = exports.getSlides = function getSlides(sm, lg) {
	  return typeof window === "undefined" ? 6 : window.innerWidth < 768 ? sm : lg;
	};
	
	var linkResolver = exports.linkResolver = function linkResolver(doc) {
	  if (doc.type === "article") return "/article/" + doc.uid;
	  // Fallback for other types, in case new custom types get created
	  return "/article/" + doc.id;
	};
	
	var toHtml = exports.toHtml = function toHtml(src) {
	  return src.html ? src.html : "";
	}; //RichText.asHtml(src, linkResolver);
	
	var noDummy = exports.noDummy = function noDummy(edges) {
	  return edges;
	};
	
	var progress = exports.progress = function progress() {
	  var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
	  var spread = arguments[1];
	
	  var lastProgress = 0;
	  var lastIndex = (0, _randomInt2.default)(0, spread - 1);
	  return function (progress) {
	    if (progress > lastProgress + step || progress < lastProgress - step) {
	      lastProgress = progress;
	      lastIndex = (0, _randomInt2.default)(0, spread - 1);
	    }
	    return lastIndex;
	  };
	};
	
	var getText = exports.getText = function getText(src, path) {
	  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
	
	  var str = _objectPath2.default.get(src, path, fallback);
	  console.log(_prismicDom.RichText.asHtml(str, linkResolver));
	  if (!str) {
	    return "";
	  }
	  return typeof str === "string" ? str : _prismicDom.RichText.asHtml(str, linkResolver);
	};
	
	var fieldExists = exports.fieldExists = function fieldExists(src, path) {
	  return getText(src, path).length > 0;
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-article-js-cf34f7bc42a9143f0e5b.js